module.exports={
  "recs": [
    {
      "id": 1,
      "name": "Gwen Evans",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "take a cheap river cruise with the water taxi",
      "place": "the Chicago River",
      "link": "https://www.chicagowatertaxi.com/",
      "address": "Chicago Water Taxi",
      "Latitude": 41.8892836,
      "Longitude": -87.6252144,
      "tags": [
        "outdoor",
        "relaxing",
        "midday",
        "wandering"
      ]
    },
    {
      "id": 2,
      "type": "feeling",
      "adj": " overcrowded ",
      "verb": "walk the quietest part of the \"South Side Riviera\"",
      "place": "the lakefront between 47th and 41st streets",
      "Side": "South Side",
      "address": "Lakefront 47th and 41st Streets",
      "Latitude": 41.820469,
      "Longitude": -87.597605,
      "tags": [
        "lakefront",
        "outdoor",
        "relaxing",
        "free",
        "midday",
        "morning",
        "evening",
        "active",
        "South Side"
      ]
    },
    {
      "id": 3,
      "name": "Liz",
      "type": "feeling",
      "adj": " like trying something new  ",
      "verb": "try a unique (and delicious) pastry ",
      "place": "Lost Larson",
      "Side": "North Side",
      "link": "https://www.lostlarson.com/",
      "address": "5318 N Clark St, Chicago, IL 60640",
      "Latitude": 41.9786115,
      "Longitude": -87.6686121,
      "tags": [
        "indoor",
        "food",
        "midday",
        "morning",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 4,
      "name": "Emily",
      "type": "feeling",
      "adj": " bored ",
      "verb": "walk down 18th and 16th streets in Pilsen, stopping",
      "place": "Alulu Brewery and Pub",
      "Side": "South Side",
      "link": "http://www.alulubrew.com/",
      "address": "2011 S Laflin St, Chicago, IL 60608",
      "Latitude": 41.854733,
      "Longitude": -87.663403,
      "tags": [
        "active",
        "indoor",
        "outdoor",
        "wandering",
        "drinking",
        "midday",
        "evening",
        "active",
        "South Side"
      ]
    },
    {
      "id": 5,
      "name": "Erik Benusa",
      "type": "description",
      "adj": " a sweaty day ",
      "verb": "Divvy down Diversey Avenue to find some air conditioning",
      "place": "Diversey River Bowl",
      "Side": "North Side",
      "link": "http://www.drbowl.com/",
      "address": "2211 W Diversey Ave, Chicago, IL 60647",
      "Latitude": 41.9315703,
      "Longitude": -87.6834046,
      "tags": [
        "active",
        "biking",
        "cool off",
        "fun and games",
        "indoor",
        "kid friendly",
        "North Side"
      ]
    },
    {
      "id": 6,
      "type": "time",
      "adj": " Friday afternoon ",
      "verb": "drink a glass of Prosecco",
      "place": "Cindy’s rooftop bar",
      "Side": "Downtown",
      "link": "http://www.cindysrooftop.com/",
      "address": "12 S Michigan Ave, Chicago, IL 60603",
      "Latitude": 41.8816513,
      "Longitude": -87.6249599,
      "tags": [
        "drinking",
        "good views",
        "outdoor",
        "evening",
        "midday",
        "feeling fancy",
        "Downtown"
      ]
    },
    {
      "id": 7,
      "name": "Meghan",
      "type": "description",
      "adj": " a stormy day ",
      "verb": "watch a storm from the windows while enjoying the beauty",
      "place": "the Chicago Cultural Center",
      "Side": "Downtown",
      "tip": "The Cultural Center also offers free movies and exhibits.",
      "link": "https://www.chicago.gov/city/en/depts/dca/supp_info/chicago_culturalcenter.html",
      "address": "78 E Washington St, Chicago, IL 60602",
      "Latitude": 41.8841623,
      "Longitude": -87.6249624,
      "tags": [
        "good views",
        "learn something new",
        "kid friendly",
        "indoor",
        "Downtown"
      ]
    },
    {
      "id": 8,
      "type": "time",
      "adj": " around lunchtime ",
      "verb": "walk around your neighborhood and end up",
      "place": "a family-owned restaurant you haven't tried",
      "tags": [
        "indoor",
        "food",
        "local business",
        "evening",
        "midday",
        "morning",
        "active"
      ]
    },
    {
      "id": 9,
      "name": "Lee Helmer",
      "type": "time",
      "adj": "2106 N Tripp Ave",
      "verb": "ride to Walt Disney's birthplace.",
      "Side": "North Side",
      "tip": "You can take The 606 to get there. The western end is about a mile away.",
      "link": "http://www.thewaltdisneybirthplace.org/",
      "address": "2156 N Tripp Ave, Chicago, IL 60639",
      "Latitude": 41.9206176,
      "Longitude": -87.7330562,
      "tags": [
        "biking",
        "active",
        "kid friendly",
        "learn something new",
        "free",
        "North Side"
      ]
    },
    {
      "id": 10,
      "name": "Adriane Battilana",
      "type": "time",
      "adj": " Friday morning  ",
      "verb": "go to a free Friday morning coffee tasting",
      "place": "Metric Coffee Company",
      "Side": "North Side",
      "link": "https://metriccoffee.com/pages/friday-public-cuppings",
      "address": "2021 W Fulton St suite k-101b, Chicago, IL 60612",
      "Latitude": 41.8864901,
      "Longitude": -87.6783,
      "tags": [
        "free",
        "coffee",
        "indoor",
        "relaxing",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 11,
      "name": "Helena",
      "type": "feeling",
      "verb": "get a deliciously extra-thick chocolate shake",
      "place": "Margie's Candies",
      "Side": "North Side",
      "tip": "Others recommend getting a sundae at Margie's.\n",
      "link": "https://margiesfinecandies.com/",
      "address": "1960 N Western Ave",
      "Latitude": 41.9173705,
      "Longitude": -87.6876492,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "cool off",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 12,
      "name": "Eve",
      "type": "feeling",
      "adj": " bored ",
      "verb": "eat sweet potato deliciousness ",
      "place": "Jimmy Jamm Sweet Potato Pies",
      "Side": "South Side",
      "link": "https://www.facebook.com/jimmyjammpies/",
      "address": "1844 W 95th St, Chicago, IL 60643",
      "Latitude": 41.7213644,
      "Longitude": -87.669267,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 13,
      "name": "Amy Lecza",
      "type": "feeling",
      "adj": " tired of all your usual spots ",
      "verb": "eat a slice of caramel cake",
      "place": "Fabiana's Bakery",
      "Side": "South Side",
      "link": "https://www.fabianasbakery.com/",
      "address": "1658 E 53rd St, Chicago, IL 60615",
      "Latitude": 41.7998696,
      "Longitude": -87.5845754,
      "tags": [
        "midday",
        "relaxing",
        "indoor",
        "morning",
        "food",
        "South Side"
      ]
    },
    {
      "id": 14,
      "name": "Tim",
      "type": "time",
      "adj": " 9pm,  ",
      "verb": "see a concert",
      "place": "Sleeping Village",
      "Side": "North Side",
      "link": "https://sleeping-village.com/",
      "address": "3734 W Belmont Ave, Chicago, IL 60618",
      "Latitude": 41.939347,
      "Longitude": -87.7213407,
      "tags": [
        "music",
        "local business",
        "indoor",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 15,
      "name": "Rahm Emanuel",
      "person_title": "former Chicago mayor",
      "type": "description",
      "adj": "rainy",
      "verb": "pick up a copy of \"Becoming Lincoln\"",
      "place": "Unabridged Bookstore",
      "Side": "North Side",
      "link": "https://www.unabridgedbookstore.com/",
      "address": "3251 N Broadway, Chicago, IL 60657",
      "Latitude": 41.9510027,
      "Longitude": -87.6496075,
      "tags": [
        "local business",
        "books",
        "indoor",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 16,
      "name": "Lucia Whalen",
      "type": "feeling",
      "adj": " cooped up by the concrete gray of the city ",
      "verb": "be with the trees and escape the concrete gray of the city ",
      "place": "the Morton Arboretum in Lisle",
      "Side": "Suburbs",
      "link": "https://www.mortonarb.org/",
      "tags": [
        "outdoor",
        "relaxing",
        "kid friendly",
        "nature",
        "midday",
        "morning",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 17,
      "name": "E.M.",
      "type": "description",
      "adj": " a warm afternoon ",
      "verb": "enjoy Jeni’s Splendid Ice Creams while watching baseball or kickball from the hill",
      "place": "Oz Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/oz-park",
      "address": "2021 N Burling St, Chicago, IL 60614",
      "Latitude": 41.9187998,
      "Longitude": -87.6466891,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 18,
      "name": "Molly ",
      "type": "description",
      "adj": " a windy day ",
      "verb": "fly a kite",
      "place": "Cricket Hill",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/cricket-hill",
      "address": "4500 N. Lakeshore Drive | W. Montrose",
      "Latitude": 41.9636782,
      "Longitude": -87.6468553,
      "tags": [
        "active",
        "outdoor",
        "free",
        "kid friendly",
        "midday",
        "morning",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 19,
      "name": "Paula Friedrich\n",
      "person_title": "WBEZ producer",
      "type": "description",
      "verb": "go see the Thorne Miniature Rooms\n",
      "place": "The Art Institute of Chicago",
      "Side": "Downtown",
      "tip": "If you're an Illinois resident, admission is free from 5:00 - 8:00 p.m. on Thursdays. Mei-Ann Chen, music director of Chicago Sinfonietta, also recommends going to view Marc Chagall’s \"America Windows.\"",
      "link": "https://www.artic.edu/departments/PC-15/thorne-miniature-rooms",
      "address": "11 S Michigan Ave, Chicago, IL 60603",
      "Latitude": 41.8819975,
      "Longitude": -87.6241997,
      "tags": [
        "drinking",
        "indoor",
        "evening",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 20,
      "type": "time",
      "adj": " springtime ",
      "verb": "watch the ducklings and goslings figure out the world",
      "place": "the banks of the Chicago River",
      "tags": [
        "nature",
        "animals",
        "kid friendly",
        "wandering",
        "outdoor",
        "free"
      ]
    },
    {
      "id": 21,
      "name": "Amy VanStee",
      "type": "time",
      "adj": " Wednesday ",
      "verb": "visit the Wednesday Andersonville farmers market and look for the \"puppet bike\" performing",
      "place": "the corner of Berwyn and Clark",
      "Side": "North Side",
      "tip": "The \"puppet bike\" is a traveling puppet show on wheels.",
      "address": "1500 W Berwyn Ave, Chicago, IL 60640",
      "Latitude": 41.9780084,
      "Longitude": -87.6683307,
      "tags": [
        "food",
        "kid friendly",
        "fun and games",
        "morning",
        "midday",
        "wandering",
        "North Side"
      ]
    },
    {
      "id": 22,
      "name": "Tricia Dempsey",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "get a glass of wine",
      "place": "City Winery",
      "Side": "West Side",
      "link": "https://www.citywinery.com/chicago/restaurant-bar.html",
      "address": "1200 w randolph",
      "Latitude": 41.8845863,
      "Longitude": -87.6571115,
      "tags": [
        "drinking",
        "indoor",
        "evening",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 23,
      "name": "Emily Taft",
      "type": "time",
      "adj": " Sunday afternoon ",
      "verb": "go for a bike ride through Humboldt Park and get sandwiches",
      "place": "Humboldt Haus",
      "Side": "West Side",
      "link": "http://www.humboldthauschicago.net/",
      "address": "1440 N. Humboldt Boulevard",
      "Latitude": 41.907065,
      "Longitude": -87.7030079,
      "tags": [
        "outdoor",
        "picnic",
        "food",
        "biking",
        "midday",
        "morning",
        "evening",
        "kid friendly",
        "West Side"
      ]
    },
    {
      "id": 24,
      "name": "Gregg",
      "type": "description",
      "adj": " a Hot day ",
      "verb": "get a cold margarita and listen to live music on the beach",
      "place": "Pier 31 Restaurant",
      "Side": "South Side",
      "link": "https://www.facebook.com/Pier31Restaurant/",
      "address": "3101 S Lake Shore Dr, Chicago, IL 60616",
      "Latitude": 41.8386196,
      "Longitude": -87.6067464,
      "tags": [
        "drinking",
        "outdoor",
        "relaxing",
        "cool off",
        "midday",
        "evening",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 25,
      "name": "David Stanford",
      "type": "feeling",
      "adj": " down ",
      "verb": "watch children frolic",
      "place": "any of the spitting or jumping water fountains",
      "Side": "Downtown",
      "tip": "Popular fountains can be found at Millenniuml Park and Navy Pier.",
      "tags": [
        "outdoor",
        "relaxing",
        "midday",
        "outdoor",
        "kid friendly",
        "morning",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 26,
      "name": "Colleen Lavin",
      "type": "feeling",
      "adj": " heartbroken ",
      "verb": "remind yourself of your galactic insignificance",
      "place": "the Dearborn Observatory in Evanston",
      "Side": "Suburbs",
      "link": "https://planitpurple.northwestern.edu/calendar/222",
      "tags": [
        "indoor",
        "evening",
        "free",
        "Suburbs"
      ]
    },
    {
      "id": 27,
      "name": "Laurence Holmes",
      "person_title": "WSCR radio host",
      "type": "feeling",
      "adj": "like summertime",
      "verb": "get brunch",
      "place": "The Chicago Firehouse Restaurant",
      "Side": "Downtown",
      "link": "https://www.choosechicago.com/listing/the-chicago-firehouse-restaurant/58006/",
      "address": "1401 S Michigan Ave, Chicago, IL 60605",
      "Latitude": 41.8639369,
      "Longitude": -87.623765
    },
    {
      "id": 28,
      "type": "description",
      "adj": " the first warm day ",
      "verb": "discover the expansive, underrated riverside green space",
      "place": "Horner Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/horner-henry-park",
      "address": "2741 W Montrose Ave, Chicago, IL 60618",
      "Latitude": 41.960554,
      "Longitude": -87.6977103,
      "tags": [
        "nature",
        "nature",
        "outdoor",
        "kid friendly",
        "relaxing",
        "wandering",
        "free",
        "North Side"
      ]
    },
    {
      "id": 29,
      "name": "Michael Lansu",
      "person_title": "WBEZ editor",
      "verb": "check out a early-evening weekend concert",
      "place": "The Empty Bottle",
      "Side": "West Side",
      "tip": "Michael says: These shows are less crowded and more intimate (plus, it's easier to get a drink.)",
      "link": "http://emptybottle.com/",
      "address": "1035 N Western Ave, Chicago, IL 60622",
      "Latitude": 41.9004625,
      "Longitude": -87.6866398,
      "tags": [
        "evening",
        "local business",
        "music",
        "dancing",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 30,
      "name": "Max D",
      "type": "description",
      "adj": " a beautiful summer day ",
      "verb": "bet on the ponies",
      "place": "Arlington International Racecourse in Arlington Heights",
      "Side": "Suburbs",
      "link": "https://www.arlingtonpark.com/",
      "tags": [
        "outdoor",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 31,
      "name": "Kora",
      "type": "feeling",
      "adj": " low key  ",
      "verb": "get dinner and drinks",
      "place": "Best Intentions' patio",
      "Side": "North Side",
      "link": "http://www.bestintentionschicago.com/",
      "address": "3281 W Armitage Ave",
      "Latitude": 41.9171816,
      "Longitude": -87.7101609,
      "tags": [
        "outdoor",
        "good for groups",
        "drinking",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 32,
      "name": "Samantha ",
      "type": "description",
      "adj": " a beautiful day ",
      "verb": "take a walk",
      "place": "Beer Baron Row",
      "Side": "West Side",
      "tip": "Beer Baron Row is not actually a place to drink. Instead, it's a stretch of elaborate homes that were built by immigrants who made their fortune in the brewing business, according to Atlas Obscura.",
      "link": "https://www.atlasobscura.com/places/beer-baron-row",
      "address": "1420 North Hoyne Ave\r\nChicago, Illinois, 60622\r\nUnited States",
      "Latitude": 41.907749,
      "Longitude": -87.6802249,
      "tags": [
        "learn something new",
        "active",
        "free",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 33,
      "name": "Pamela Barnes",
      "type": "time",
      "adj": " a weekday ",
      "verb": "spend the day reading",
      "place": "the Cook County Law Library at The Daley Center",
      "Side": "Downtown",
      "link": "https://www.cookcountyil.gov/agency/law-library",
      "address": "50 W Washington St, Chicago, IL 60602",
      "Latitude": 41.8840336,
      "Longitude": -87.6301288,
      "tags": [
        "indoor",
        "books",
        "relaxing",
        "learn something new",
        "midday",
        "morning",
        "Downtown"
      ]
    },
    {
      "id": 34,
      "name": "Zach Jesse",
      "type": "description",
      "adj": " a top-down kinda day ",
      "verb": "cruise on Longwood Drive with your top down from Beverly or Morgan Park to suburban Blue Island.",
      "Side": "South Side",
      "tags": [
        "indoor",
        "free",
        "midday",
        "evening",
        "wandering",
        "South Side"
      ]
    },
    {
      "id": 35,
      "name": "Beth Ann Samra",
      "type": "description",
      "adj": " warm ",
      "verb": "try out stand-up paddle boarding",
      "place": "Montrose Beach",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/montrose-beach",
      "address": "601 W Montrose Ave, Chicago, IL 60613",
      "Latitude": 41.9630332,
      "Longitude": -87.6381737,
      "tags": [
        "kid friendly",
        "lakefront",
        "midday",
        "outdoor",
        "active",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 36,
      "name": "Janet Kennedy",
      "type": "time",
      "adj": " summer ",
      "verb": "taste beer on the rooftop",
      "place": "Open Outcry Brewing Company",
      "Side": "South Side",
      "link": "http://www.openoutcrybrewing.com/",
      "address": "10934 S Western Ave, Chicago, IL 60643",
      "Latitude": 41.6944461,
      "Longitude": -87.6815737,
      "tags": [
        "drinking",
        "outdoor",
        "local business",
        "cool off",
        "good views",
        "evening",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 37,
      "name": "Nichole Gardner",
      "type": "description",
      "adj": " a balmy day ",
      "verb": "take a bike ride and enjoy the gorgeous scenery (including a lake surrounded by weeping willows)",
      "place": "Graceland Cemetery",
      "Side": "North Side",
      "link": "https://www.gracelandcemetery.org/",
      "address": "4001 N Clark St, Chicago, IL 60613",
      "Latitude": 41.9546042,
      "Longitude": -87.6618116,
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "kid friendly",
        "nature",
        "North Side"
      ]
    },
    {
      "id": 38,
      "name": "Emily",
      "type": "time",
      "adj": "freezing ",
      "verb": "warm up with chifrijo dip",
      "place": "Irazu",
      "Side": "North Side",
      "link": "http://irazuchicago.com/",
      "address": "1865 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9155157,
      "Longitude": -87.685061,
      "tags": [
        "indoor",
        "food",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 39,
      "name": "Carrie Shepherd",
      "person_title": "WBEZ reporter",
      "type": "description",
      "adj": " dark, rainy  ",
      "verb": "drive under the tracks",
      "place": "Lake Street",
      "Side": "West Side",
      "address": "Lake Street, Chicago IL",
      "Latitude": 41.8853811,
      "Longitude": -87.6732926,
      "tags": [
        "outdoor",
        "good views",
        "midday",
        "morning",
        "evening",
        "free",
        "West Side"
      ]
    },
    {
      "id": 40,
      "name": "Rahm Emanuel",
      "person_title": "former Chicago mayor",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "order chicken and carne asada tacos",
      "place": "Paco's Tacos in La Internacional Supermercado",
      "Side": "South Side",
      "tip": "Rahm says: \"Their salsa is a game-changer.\"",
      "link": "https://www.facebook.com/pacostacoschicago/",
      "address": "4556 S Ashland Ave, Chicago, IL 60609",
      "Latitude": 41.8105461,
      "Longitude": -87.6653952,
      "tags": [
        "food",
        "local business",
        "indoor",
        "evening",
        "midday",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 41,
      "name": "Anna Navin",
      "type": "description",
      "adj": " a summer day ",
      "verb": "grab an Old Style and shoot hoops on the patio",
      "place": "Phyllis’ Musical Inn",
      "Side": "West Side",
      "link": "https://www.facebook.com/phyllismusicalinn/",
      "address": "1800 W Division St",
      "Latitude": 41.9034595,
      "Longitude": -87.6725669,
      "tags": [
        "active",
        "drinking",
        "outdoor",
        "fun and games",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 42,
      "name": "Tyler",
      "type": "feeling",
      "adj": " like you'll never make enough money to buy nice things ",
      "verb": "pretend to be a celebrity at Restoration Hardware, then eat brunch ",
      "place": "3 Arts Club Cafe",
      "Side": "North Side",
      "tip": "Restoration Hardware is a Gold Coast furniture store. ",
      "link": "http://3artsclubcafe.com/",
      "address": "1300 N Dearborn Pkwy, Chicago, IL 60610",
      "Latitude": 41.9059916,
      "Longitude": -87.630486,
      "tags": [
        "wandering",
        "food",
        "indoor",
        "feeling fancy",
        "midday",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 43,
      "name": "Bonnie Fritz",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "enjoy, yet reflect, on the humbling works",
      "place": "the National Veterans Art Museum",
      "Side": "North Side",
      "link": "https://www.nvam.org/",
      "address": "4041 N Milwaukee Ave 2nd floor, Chicago, IL 60641",
      "Latitude": 41.9544838,
      "Longitude": -87.7485312,
      "tags": [
        "learn something new",
        "indoor",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 44,
      "name": "Yamani Hernandez",
      "verb": "eat",
      "place": "The Woodlawn",
      "Side": "South Side",
      "address": "1200 E 79th St, Chicago, IL 60619",
      "Latitude": 41.7515437,
      "Longitude": -87.5952526,
      "tags": [
        "local business",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 45,
      "name": "Carlos Ramirez-Rosa",
      "person_title": "Chicago alderman",
      "type": "feeling",
      "adj": " adventurous ",
      "verb": "scale the rock climbing wall ",
      "place": "Steelworkers Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/steelworkers-park",
      "address": "E 87th St, Chicago, IL 60617",
      "Latitude": 41.737196,
      "Longitude": -87.5647681,
      "tags": [
        "outdoor",
        "active",
        "kid friendly",
        "free",
        "morning",
        "midday",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 46,
      "name": "Erin Eife",
      "type": "time",
      "adj": " clear ",
      "verb": "check out the skyline view",
      "place": "Palmisano Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/palmisano-henry-park",
      "address": "2700 S Halsted St, Chicago, IL 60608",
      "Latitude": 41.8444961,
      "Longitude": -87.6464721,
      "tags": [
        "outdoor",
        "good views",
        "kid friendly",
        "good for groups",
        "morning",
        "midday",
        "evening",
        "free",
        "South Side"
      ]
    },
    {
      "id": 47,
      "name": "Linda Miller",
      "type": "feeling",
      "adj": " like you've seen all the sights in Chicago. You should visit the hidden gem of an Arts & Crafts design church at 1936 S. Michigan. It is the only church ",
      "verb": "visit a hidden gem of arts and crafts design",
      "place": "the Second Presbytarian Church",
      "Side": "South Side",
      "tip": "It's the only church in Chicago to be named a National Historic Landmark.",
      "link": "https://2ndpresbyterian.org/",
      "address": "1936 S. Michigan",
      "Latitude": 41.8557309,
      "Longitude": -87.6243914,
      "tags": [
        "learn something new",
        "good views",
        "outdoor",
        "indoor",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 48,
      "name": "Beth Morrissey",
      "type": "time",
      "adj": " Friday night ",
      "verb": "order pizza (with that delicious sweet sauce)",
      "place": "Palermo's",
      "Side": "South Side",
      "link": "https://www.palermosof63rd.com/palermos-of-63rd-chicago-midway-menu/",
      "address": "3751 W 63rd St, Chicago, IL 60629",
      "Latitude": 41.7785445,
      "Longitude": -87.7174925,
      "tags": [
        "food",
        "indoor",
        "relaxing",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 49,
      "name": "Alanna",
      "type": "description",
      "adj": " a gross day ",
      "verb": "watch Charlie Chaplin films",
      "place": "the Museum of Science and Industry",
      "Side": "South Side",
      "link": "https://www.msichicago.org/explore/whats-here/exhibits/yesterdays-main-street/",
      "address": "5700 S Lake Shore Dr, Chicago, IL 60637",
      "Latitude": 41.7920438,
      "Longitude": -87.5829263,
      "tags": [
        "kid friendly",
        "indoor",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 50,
      "name": "Tricia Dempsey",
      "type": "time",
      "adj": " Friday night ",
      "verb": "grab dinner",
      "place": "etta",
      "Side": "North Side",
      "tip": "Tricia recommends getting dessert at Jeni's Splendid Ice Creams after dinner.",
      "link": "https://ettarestaurant.com/",
      "address": "1840 W North Ave, Chicago, IL 60622",
      "Latitude": 41.9106889,
      "Longitude": -87.6742363,
      "tags": [
        "local business",
        "food",
        "outdoor",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 51,
      "name": "Evan Moore",
      "person_title": "<em>Chicago Sun-Times</em> journalist",
      "type": "feeling",
      "adj": "hungry",
      "verb": "feast",
      "place": "5 Loaves Eatery",
      "Side": "South Side",
      "link": "http://www.5loaveschicago.com/",
      "address": "405 E 75th St, Chicago, Illinois 60619, United States",
      "Latitude": 41.7582246,
      "Longitude": -87.6147618,
      "tags": [
        "local business",
        "food",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 52,
      "name": "Meghan McKeever",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "rent a volleyball and net",
      "place": "North Avenue Beach",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/north-avenue-beach",
      "address": "1600 N Lake Shore Dr",
      "Latitude": 41.9129534,
      "Longitude": -87.6247288,
      "tags": [
        "active",
        "lakefront",
        "kid friendly",
        "midday",
        "kid friendly",
        "good for groups",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 53,
      "name": "Maureen Kelleher",
      "type": "feeling",
      "adj": " cooped up ",
      "verb": "take your bike to the BMX trails",
      "place": "Big Marsh Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/big-marsh-park-park-no-564",
      "address": "11559 S Stony Island Ave, Chicago, IL 60633",
      "Latitude": 41.6853018,
      "Longitude": -87.5764125,
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 54,
      "name": "Sterling Haukom Anderson",
      "type": "time",
      "adj": " a Saturday with the kids ",
      "verb": "release energy",
      "place": "Indian Boundary Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/indian-boundary-park",
      "address": "2500 W Lunt Ave, Chicago, IL 60645",
      "Latitude": 42.0098036,
      "Longitude": -87.6931948,
      "tags": [
        "outdoor",
        "kid friendly",
        "nature",
        "active",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 55,
      "name": "Alexa L Schutz",
      "type": "description",
      "adj": " Wednes(day)  ",
      "verb": "dance the night away and sip punch during Thursday reggae nights",
      "place": "Subterranean",
      "Side": "North Side",
      "link": "https://www.subt.net/event/tw-artistinfo/Reggae+Gold/",
      "address": "2011 W North Ave",
      "Latitude": 41.9102565,
      "Longitude": -87.677978,
      "tags": [
        "dancing",
        "evening",
        "indoor",
        "North Side"
      ]
    },
    {
      "id": 56,
      "name": "Cassidy Lacy",
      "type": "description",
      "adj": " a sunny, but windy day ",
      "verb": "order a Lavender Collins and sit on the patio",
      "place": "Saint Lou's Assembly",
      "Side": "West Side",
      "tip": "Cassidy recommends this spot on Chicago's famous windy days because \"they have walls around their patio that blocks out the wind!\"",
      "link": "https://www.saintlouschicago.com/",
      "address": "664 W Lake St",
      "Latitude": 41.8859105,
      "Longitude": -87.6452528,
      "tags": [
        " relaxing",
        "local business",
        "drinking",
        "midday",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 57,
      "name": "Stephanie J Friedman",
      "type": "feeling",
      "adj": " mellow ",
      "verb": "grab a Mexicana shake and people watch",
      "place": "Medici on 57th",
      "Side": "South Side",
      "link": "https://www.medici57.com/",
      "address": "1327-1331, E 57th St, Chicago, IL 60637",
      "Latitude": 41.7912777,
      "Longitude": -87.5937379,
      "tags": [
        "good views",
        "ice cream",
        "indoor",
        "cool off",
        "ice cream",
        "good views",
        "relaxing",
        "South Side"
      ]
    },
    {
      "id": 58,
      "name": "Mei-Ann Chen",
      "person_title": "music director of the Chicago Sinfonietta",
      "type": "description",
      "adj": " a chilly day ",
      "verb": "get a grilled lamb skewer and an iron pot dish",
      "place": "Homestyle Taste",
      "Side": "South Side",
      "link": "http://homestylesy.com/",
      "address": "3205 S Halsted St, Chicago, IL 60608",
      "Latitude": 41.8360163,
      "Longitude": -87.6458318,
      "tags": [
        "food",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 59,
      "name": "Sabrina Miller",
      "type": "feeling",
      "adj": "curious",
      "verb": "learn about Chicago's steel industry on Thursdays",
      "place": "the Southeast Chicago Historical Museum",
      "Side": "South Side",
      "link": "http://www.calumetstewardship.org/member-organizations/southeast-chicago-historical-society#.XNRszPlKi70",
      "address": "9801 S Ave G, Chicago, IL 60617",
      "Latitude": 41.7178298,
      "Longitude": -87.5306437,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "learn something new",
        "local business",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 60,
      "name": "Gwen Evans",
      "type": "feeling",
      "adj": " bougie ",
      "verb": "stroll and admire the pre-war mansions and apartment buildings",
      "place": "the Gold Coast",
      "Side": "North Side",
      "tip": "Gwen says: End your stroll with a drink at the 3 Arts Club Cafe.",
      "address": "1300 N Dearborn Pkwy, Chicago, IL 60610",
      "Latitude": 41.9059916,
      "Longitude": -87.630486,
      "tags": [
        "wandering",
        "learn something new",
        "drinking",
        "evening",
        "midday",
        "morning",
        "good for groups",
        "feeling fancy",
        "North Side"
      ]
    },
    {
      "id": 61,
      "name": "Adam Morgan",
      "person_title": "Chicago writer",
      "type": "time",
      "adj": " Tuesday night ",
      "verb": "go to Wordplay (the Tuesday poetry open mic night)",
      "place": "Young Chicago Authors",
      "Side": "West Side",
      "link": "https://youngchicagoauthors.org/programs/open-mics/wordplay",
      "address": "1180 N Milwaukee Ave, Chicago, IL 60642",
      "Latitude": 41.9029774,
      "Longitude": -87.6665683,
      "tags": [
        "indoor",
        "creativity",
        "free",
        "active",
        "West Side"
      ]
    },
    {
      "id": 62,
      "name": "Rebecca Makkai",
      "person_title": "Author, <em>The Great Believers</em>",
      "type": "time",
      "adj": " Sundaymorning  ",
      "verb": "do a Bloody Mary bar crawl",
      "place": "Boystown bars",
      "Side": "North Side",
      "address": "Boystown, Chicago",
      "Latitude": 41.9439979,
      "Longitude": -87.6473853,
      "tags": [
        "indoor",
        "outdoor",
        "morning",
        "midday",
        "drinking",
        "wandering",
        "North Side"
      ]
    },
    {
      "id": 63,
      "name": "Taylor Fenderbosch",
      "type": "description",
      "adj": " a gorgeous day ",
      "verb": "get a lobster roll",
      "place": "The Waterfront Cafe",
      "Side": "North Side",
      "tip": "Regina Buccola also recommends having a cocktail here.",
      "link": "http://waterfrontcafechicago.com/",
      "address": "6219 N Sheridan Rd, Chicago, IL 60660",
      "Latitude": 41.9952409,
      "Longitude": -87.6551264,
      "tags": [
        "food",
        "outdoor",
        "lakefront",
        "relaxing",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 64,
      "name": "Mia Sato",
      "type": "time",
      "adj": " a Saturday and you have plenty of time ",
      "verb": "come out with more books than you can carry home",
      "place": "Powell’s Books Chicago",
      "Side": "South Side",
      "link": "https://www.powellschicago.com/",
      "address": "1501 E 57th St, Chicago, IL 60637",
      "Latitude": 41.7913443,
      "Longitude": -87.5888934,
      "tags": [
        "books",
        "indoor",
        "local business",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 65,
      "name": "Kat ",
      "type": "feeling",
      "adj": " lonely ",
      "verb": "read or people watch while riding a CTA train from one end to the other.",
      "link": "https://www.transitchicago.com/maps/",
      "tags": [
        "good views",
        "indoor",
        "free",
        "wandering",
        "relaxing"
      ]
    },
    {
      "id": 66,
      "name": "Zach Jesse",
      "type": "feeling",
      "adj": " hungry from the replenishing waters of Lake Michigan ",
      "verb": "get seafood platters (and BYOB)",
      "place": "La Palapa",
      "Side": "South Side",
      "link": "http://www.lapalapamariscos.com/home",
      "address": "2000 W 34th St",
      "Latitude": 41.8324326,
      "Longitude": -87.6755538,
      "tags": [
        "food",
        "local business",
        "drinking",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 67,
      "name": "Joy R",
      "type": "description",
      "adj": "' sunny ",
      "verb": "jump in the splashpad",
      "place": "Navy Pier",
      "Side": "Downtown",
      "tip": "Gwyn Aubrey says: Go ride The Tall Ship Windy at Navy Pier \"because it's cooler on the lake!\"",
      "link": "https://navypier.org/",
      "address": "600 E Grand Ave, Chicago, IL 60611",
      "Latitude": 41.8917065,
      "Longitude": -87.6084807,
      "tags": [
        "cool off",
        "free",
        "kid friendly",
        "outdoor",
        "midday",
        "evening",
        "cool off",
        "free",
        "Downtown"
      ]
    },
    {
      "id": 68,
      "type": "feeling",
      "adj": " productive  ",
      "verb": "up your productivity",
      "place": "Avondale Coffee Club",
      "Side": "North Side",
      "link": "https://www.avondalecoffeeclub.com/",
      "address": " 3185 N Elston Ave, Chicago, IL 60618",
      "Latitude": 41.9391443,
      "Longitude": -87.6975155,
      "tags": [
        "indoor",
        "coffee",
        "morning",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 69,
      "name": "Stephanie J Friedman",
      "type": "description",
      "adj": " a breezy day ",
      "verb": "fly a kite",
      "place": "Promontory Point",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/promontory-point",
      "address": "5491 S Shore Dr, Chicago, IL 60615",
      "Latitude": 41.7964623,
      "Longitude": -87.5761275,
      "tags": [
        "fun and games",
        "active",
        "nature",
        "lakefront",
        "midday",
        "morning",
        "evening",
        "free",
        "South Side"
      ]
    },
    {
      "id": 70,
      "type": "description",
      "adj": " a warmevening ",
      "verb": "set up a picnic",
      "place": "the lake along South Shore Drive",
      "Side": "South Side",
      "address": "7059 S. South Shore Dr.",
      "Latitude": 41.7683018,
      "Longitude": -87.563868,
      "tags": [
        "outdoor",
        "picnic",
        "free",
        "kid friendly",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 71,
      "name": "Natalie Moore",
      "person_title": "WBEZ reporter",
      "verb": "listen to African dummers",
      "place": "63rd Street Beach",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/63rd-street-beach",
      "address": "6301 S. Lake Shore Drive Chicago, IL 60637",
      "Latitude": 41.7807246,
      "Longitude": -87.5746274,
      "tags": [
        "kid friendly",
        "outdoor",
        "evening",
        "music",
        "midday",
        "lakefront",
        "South Side"
      ]
    },
    {
      "id": 72,
      "name": "Jennifer Kilgore",
      "type": "time",
      "adj": " Friday ",
      "verb": "play darts and try new beers",
      "place": "The Beer Temple",
      "Side": "North Side",
      "link": "http://www.craftbeertemple.com/",
      "address": "3173 N Elston Ave, Chicago, IL 60618",
      "Latitude": 41.9388476,
      "Longitude": -87.6972208,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "fun and games",
        "good for groups",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 73,
      "name": "Allison Manley",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "admire the secret mermaid statue",
      "place": "Oakwood - 41st Street Beach",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/mermaid",
      "address": "Oakwood Beach Chicago, Illinois, 60653",
      "Latitude": 41.8213586,
      "Longitude": -87.5958032,
      "tags": [
        "outdoor",
        "lakefront",
        "relaxing",
        "evening",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 74,
      "name": "Luis Hernandez",
      "type": "time",
      "adj": " a bright weekend ",
      "verb": "take in the lakefront and skyline",
      "place": "Rainbow Beach Dunes",
      "Side": "South Side",
      "tip": "A.N. Toonen recommends spending an afternoon here with a good book.",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/rainbow-beach-park",
      "address": "7700 S South Shore Dr Chicago IL",
      "Latitude": 41.756752,
      "Longitude": -87.553557,
      "tags": [
        "outdoor",
        "lakefront",
        "free",
        "good views",
        "kid friendly",
        "relaxing",
        "South Side"
      ]
    },
    {
      "id": 75,
      "name": "Sara Corley",
      "type": "time",
      "adj": " the third Monday of the month ",
      "verb": "salsa dance on the third Mondays of the month",
      "place": "The Promontory",
      "Side": "South Side",
      "link": "https://www.promontorychicago.com/",
      "address": "5311 S Lake Park Ave W, Chicago, IL 60615",
      "Latitude": 41.7990051,
      "Longitude": -87.5876077,
      "tags": [
        "dancing",
        "indoor",
        "active",
        "learn something new",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 76,
      "name": "Emily Graslie",
      "person_title": "host of the Field Museum's <em>Brain Scoop</em>",
      "type": "time",
      "adj": " Saturday ",
      "verb": "get a hot dog",
      "place": "Kim and Carlo's Hot Dog Cart outside the Field Museum",
      "Side": "Downtown",
      "link": "https://www.facebook.com/kimandcarloshotdogs/",
      "address": "1400 S Lake Shore Dr, Chicago, IL 60605",
      "Latitude": 41.8661733,
      "Longitude": -87.6169862,
      "tags": [
        "food",
        "outdoor",
        "midday",
        "local business",
        "kid friendly",
        "Downtown"
      ]
    },
    {
      "id": 77,
      "name": "Heidi Stevens",
      "person_title": "<em>Chicago Tribune</em> columnist",
      "type": "description",
      "adj": " a stormy day ",
      "verb": "watch the skies darken on a stormy day at a corner table",
      "place": "The Lakefront Restaurant - Theater on the Lake",
      "Side": "North Side",
      "address": "2401 N Lake Shore Dr",
      "Latitude": 41.9270754,
      "Longitude": -87.6306663,
      "tags": [
        " relaxing",
        "local business",
        "indoor",
        "lakefront",
        "evening",
        "good views",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 78,
      "name": "Eleanore",
      "type": "description",
      "adj": " a sunny day  ",
      "verb": "walk your pet",
      "place": "Archer Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/archer-park-irma-abelar",
      "address": "4901 S Kilbourn Ave, Chicago, IL 60632",
      "Latitude": 41.8039647,
      "Longitude": -87.7356277,
      "tags": [
        "free",
        "outdoor",
        "animals",
        "active",
        "free",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 79,
      "type": "description",
      "adj": " a hot day ",
      "verb": "get an Oreo ice cream bar",
      "place": "La Michoacana Premium",
      "Side": "South Side",
      "link": "http://lamichoacanapremiumpilsen.com/",
      "address": "2150 W Cermak Rd, Chicago, IL 60608",
      "Latitude": 41.8523508,
      "Longitude": -87.6803257,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "cool off",
        "South Side"
      ]
    },
    {
      "id": 80,
      "name": "Jill Dunlap",
      "type": "feeling",
      "adj": " feisty  ",
      "verb": "have a vodka flight",
      "place": "Russian Tea Time",
      "Side": "Downtown",
      "tip": "Jill says: It’s in the middle of tourist life, but if you have to be down there you \"might as well learn how to say cheers in Russian and do a vodka shot the proper way.\"",
      "link": "https://www.russianteatime.com/store/russian-tea-time/menu/afternoon-tea-and-dessert",
      "address": "77 E Adams St",
      "Latitude": 41.8793475,
      "Longitude": -87.6250758,
      "tags": [
        "midday",
        "drinking",
        "indoor",
        "local business",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 81,
      "name": "Joshua Magno",
      "type": "time",
      "adj": " midsummer and you're walking with the love of your life ",
      "verb": "get the black sesame seed and chocolate fig gelato",
      "place": "Black Dog Gelato",
      "Side": "West Side",
      "link": "https://blackdoggelato.com/",
      "address": "859 N Damen Ave, Chicago, IL 60622",
      "Latitude": 41.897607,
      "Longitude": -87.6767824,
      "tags": [
        "ice cream",
        "kid friendly",
        "indoor",
        "local business",
        "midday",
        "cool off",
        "West Side"
      ]
    },
    {
      "id": 82,
      "name": "Katherine Nagasawa",
      "person_title": "<em>Curious City</em> producer",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "roller skate",
      "place": "The Rink",
      "Side": "South Side",
      "link": "http://www.therinkchicago.com/",
      "address": "1122 E 87th St, Chicago, IL 60619",
      "Latitude": 41.735897,
      "Longitude": -87.5939734,
      "tags": [
        "active",
        "indoor",
        "midday",
        "kid friendly",
        "evening",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 83,
      "name": "Max D",
      "type": "time",
      "adj": " Wednesday ",
      "verb": "check out Wednesday night open mic nights",
      "place": "Elbo Room",
      "Side": "North Side",
      "link": "https://elboroomlive.com/openmic/",
      "address": "2871 N Lincoln Ave, Chicago, IL 60657",
      "Latitude": 41.9342015,
      "Longitude": -87.6607525,
      "tags": [
        "indoor",
        "evening",
        "free",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 84,
      "name": "Erin Eife",
      "type": "description",
      "adj": " a cold day ",
      "verb": "eat chicken noodle soup",
      "place": "Chef Sara's Cafe",
      "Side": "South Side",
      "link": "http://www.chefsarascafe.com/",
      "address": "7201 S Exchange Ave, Chicago, IL 60649",
      "Latitude": 41.7644383,
      "Longitude": -87.5646769,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "relaxing",
        "South Side"
      ]
    },
    {
      "id": 85,
      "name": "Janet Kennedy",
      "type": "feeling",
      "adj": " like a lazy afternoon in acoffee shop but you want to listen to some good music ",
      "verb": "listen to some vinyl while sipping your latte ",
      "place": "B-Sides Coffee and Tea",
      "Side": "South Side",
      "link": "https://bsidescoffeetea.business.site/",
      "address": " 9907 S Walden Pkwy, Chicago, IL 60643",
      "Latitude": 41.7135792,
      "Longitude": -87.6675724,
      "tags": [
        "music",
        "coffee",
        "indoor",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 86,
      "name": "Liz",
      "type": "feeling",
      "adj": " stressed on a summer afternoon ",
      "verb": "take off your sandals and dangle your feet in the stream",
      "place": "the Lurie Garden",
      "Side": "Downtown",
      "link": "https://www.luriegarden.org/",
      "address": "E Monroe St, Chicago, IL 60601",
      "Latitude": 41.8808517,
      "Longitude": -87.6221119,
      "tags": [
        "outdoor",
        "free",
        "relaxing",
        "midday",
        "morning",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 87,
      "name": "Chelsea Rump",
      "type": "time",
      "adj": " Tuesday ",
      "verb": "join a shuffleboard league",
      "place": "the Royal Palms Shuffleboard Club",
      "Side": "North Side",
      "link": "https://www.royalpalmschicago.com/leagues",
      "address": "1750 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9131866,
      "Longitude": -87.6820846,
      "tags": [
        "local business",
        "fun and games",
        "indoor",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 88,
      "name": "Nicolle Neulist",
      "type": "description",
      "adj": " a lucky day ",
      "verb": "bet on live harness racing",
      "place": "Hawthorne Race Course in Cicero",
      "Side": "Suburbs",
      "link": "https://www.hawthorneracecourse.com/",
      "tags": [
        "outdoor",
        "midday",
        "fun and games",
        "Suburbs"
      ]
    },
    {
      "id": 89,
      "name": "Brian Gee",
      "type": "feeling",
      "adj": " fancy ",
      "verb": "take your best friend out for a fancy dinner",
      "place": "Hotel EMC2",
      "Side": "Downtown",
      "link": "https://hotelemc2.com/",
      "address": "228 E Ontario St, Chicago, IL 60611",
      "Latitude": 41.8935883,
      "Longitude": -87.6215303,
      "tags": [
        "food",
        "indoor",
        "evening",
        "feeling fancy",
        "relaxing",
        "good for groups",
        "Downtown"
      ]
    },
    {
      "id": 90,
      "name": "Rick Ohlemacher",
      "person_title": "chef at The Heritage",
      "type": "feeling",
      "adj": " weird",
      "verb": "explore the exhibits",
      "place": "the International Museum of Surgical Science",
      "Side": "North Side",
      "link": "https://imss.org/",
      "address": "1524 N Lake Shore Dr, Chicago, IL 60610",
      "Latitude": 41.9102754,
      "Longitude": -87.6266212,
      "tags": [
        "learn something new",
        "midday",
        "indoor",
        "North Side"
      ]
    },
    {
      "id": 91,
      "name": "Olivia Liddell",
      "type": "feeling",
      "adj": " artsy ",
      "verb": "explore the galleries",
      "place": "the Smart Museum of Art",
      "Side": "South Side",
      "link": "https://smartmuseum.uchicago.edu/",
      "address": "5550 S Greenwood Ave, Chicago, IL 60637",
      "Latitude": 41.7934642,
      "Longitude": -87.6002004,
      "tags": [
        "free",
        "creativity",
        "kid friendly",
        "relaxing",
        "indoor",
        "learn something new",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 92,
      "name": "Dani Adams",
      "type": "feeling",
      "adj": " full of life ",
      "verb": "make friends with your neighbors",
      "place": "your local street festival",
      "link": "https://www.chicagotribune.com/entertainment/festivals/ct-redeye-viz-chicago-summer-festivals-guide-2019-htmlstory.html",
      "tags": [
        "kid friendly",
        "outdoor",
        "midday",
        "evening",
        "wandering"
      ]
    },
    {
      "id": 93,
      "name": "June",
      "type": "time",
      "adj": " a cheap date kind of day ",
      "verb": "park and count planes while eating sliders",
      "place": "White Castle near Midway Airport",
      "Side": "South Side",
      "link": "https://www.yelp.com/biz/white-castle-chicago-18",
      "address": " 4750 W 63rd St, Chicago, IL 60629",
      "Latitude": 41.7787653,
      "Longitude": -87.7415188,
      "tags": [
        "indoor",
        "kid friendly",
        "good views",
        "relaxing",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 94,
      "name": "Shelley Jacobs",
      "type": "feeling",
      "adj": " like you need to explore more ",
      "verb": "go mural hunting in Pilsen, starting",
      "place": "16th and Wolcott",
      "Side": "South Side",
      "link": "https://www.choosechicago.com/things-to-do/museums-and-arts/public-art/pilsen-murals/",
      "address": "16th and wolcott",
      "Latitude": 41.85969,
      "Longitude": -87.6735,
      "tags": [
        "wandering",
        "outdoor",
        "free",
        "kid friendly",
        "midday",
        "morning",
        "evening",
        "active",
        "South Side"
      ]
    },
    {
      "id": 95,
      "name": "Ed Bannon",
      "type": "description",
      "adj": " sunny  ",
      "verb": "walk the trail",
      "place": "the Dunning Read Conservation Area",
      "Side": "North Side",
      "link": "https://www.facebook.com/Dunning-Read-Conservation-Area-215955825232493/",
      "address": "4200 N Oak Park Chicago, IL 60634",
      "Latitude": 41.9562217,
      "Longitude": -87.7990416,
      "tags": [
        "outdoor",
        "free",
        "nature",
        "active",
        "kid friendly",
        "good for groups",
        "morning",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 96,
      "name": "Rick Ohlemacher",
      "person_title": "chef at The Heritage",
      "type": "time",
      "adj": "Saturday",
      "verb": "get a half-price glass of wine on Saturdays",
      "place": "Income Tax",
      "Side": "Downtown",
      "link": "https://www.incometaxbar.com/",
      "address": "5959 North Broadway Chicago, IL 60613",
      "Latitude": 41.9510027,
      "Longitude": -87.6496075,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "evening",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 97,
      "name": "Exavier Pope",
      "person_title": "Chicago journalist",
      "type": "feeling",
      "adj": " hungry but want some soulful hip hop tunes to vibe with your meal ",
      "verb": "eat and vibe out to soulful hip-hop tunes",
      "place": "Booze Box",
      "Side": "West Side",
      "link": "http://sushidokku.com/booze-box/",
      "address": "823 W Randolph St",
      "Latitude": 41.8841113,
      "Longitude": -87.648458,
      "tags": [
        "local business",
        "food",
        "indoor",
        "drinking",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 98,
      "type": "description",
      "adj": " sunny  ",
      "verb": "relax in the beer garden",
      "place": "Chief O'Neill's Pub",
      "Side": "North Side",
      "link": "https://www.chiefoneillspub.com/",
      "address": "3471 N Elston Ave, Chicago, IL 60618",
      "Latitude": 41.9446482,
      "Longitude": -87.7055227,
      "tags": [
        "food",
        "drinking",
        "relaxing",
        "outdoor",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 99,
      "name": "Helen Muhisani",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "get some banana pudding ice cream",
      "place": "Shawn Michelle's Homemade Ice Cream",
      "Side": "South Side",
      "tip": "Jamie Golden also suggests the apple cobbler.",
      "link": "http://www.shawnmichelles.com/",
      "address": "46 E 47th St, Chicago, IL 60653",
      "Latitude": 41.8093554,
      "Longitude": -87.6241486,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "food",
        "local business",
        "cool off",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 100,
      "name": "Emily",
      "type": "feeling",
      "adj": " bored ",
      "verb": "play arcade games ",
      "place": "Emporium Arcade Bar in Wicker Park",
      "Side": "North Side",
      "link": "https://emporiumchicago.com/",
      "address": "1366 N Milwaukee Ave",
      "Latitude": 41.9064555,
      "Longitude": -87.6718496,
      "tags": [
        "fun and games",
        "indoor",
        "local business",
        "drinking",
        "good for groups",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 101,
      "name": "Rahm Emanuel",
      "person_title": "former Chicago mayor",
      "type": "time",
      "adj": "Friday",
      "verb": "sample award-winning Chicago craft beer",
      "place": "Begyle Brewing Company",
      "Side": "North Side",
      "link": "https://www.begylebrewing.com/home/",
      "address": "1800 W Cuyler Ave, Chicago, IL 60613",
      "Latitude": 41.9554507,
      "Longitude": -87.674528,
      "tags": [
        "local business",
        "drinking",
        "indoor",
        "midday",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 102,
      "name": "Kelly Christian",
      "type": "time",
      "adj": " Tuesdayevening ",
      "verb": "get discount pizza on Tuesdays",
      "place": "Reno Chicago",
      "Side": "North Side",
      "link": "https://www.renochicago.com/",
      "address": "2607 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9291517,
      "Longitude": -87.7071753,
      "tags": [
        "food",
        "indoor",
        "evening",
        "midday",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 103,
      "name": "Erin",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "get lost in the shelves",
      "place": "57th Street Books",
      "Side": "South Side",
      "link": "https://57th.semcoop.com/",
      "address": "1301 E 57th St, Chicago, IL 60637",
      "Latitude": 41.7912371,
      "Longitude": -87.5946769,
      "tags": [
        "books",
        "wandering",
        "indoor",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 104,
      "type": "time",
      "adj": " Friday night ",
      "verb": "go see a classic African American film",
      "place": "the Stony Island Arts Bank cinema",
      "Side": "South Side",
      "link": "https://rebuild-foundation.org/site/black-cinema-house/",
      "address": "6760 S Stony Island Ave\r\nChicago, IL",
      "Latitude": 41.7716832,
      "Longitude": -87.5866165,
      "tags": [
        "learn something new",
        "indoor",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 105,
      "name": "Ryan Gilhooley",
      "type": "time",
      "adj": " noon on a weekday ",
      "verb": "watch the Grant Park Orchestra rehearse around midday (Tuesdays through Fridays)",
      "place": "Millennium Park",
      "Side": "Downtown",
      "link": "https://www.grantparkmusicfestival.com/festival-connect/open-rehearsals",
      "address": "201 E Randolph St, Chicago, IL 60602",
      "Latitude": 41.8834354,
      "Longitude": -87.6218416,
      "tags": [
        "outdoor",
        "free",
        "music",
        "Downtown"
      ]
    },
    {
      "id": 106,
      "type": "feeling",
      "adj": " pensive ",
      "verb": "photograph the dogs having the time of their lives",
      "place": "Pratt Beach",
      "Side": "North Side",
      "address": "1045 W Pratt",
      "Latitude": 42.0055782,
      "Longitude": -87.6579541,
      "tags": [
        "animals",
        "outdoor",
        "lakefront",
        "kid friendly",
        "free",
        "evening",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 107,
      "name": "Beth Morrissey",
      "type": "feeling",
      "adj": " stressed ",
      "verb": "do yin yoga",
      "place": "Wildlight Yoga",
      "Side": "North Side",
      "link": "https://www.wildlightyoga.com/",
      "address": "4140 N Milwaukee Ave, Chicago, IL 60641",
      "Latitude": 41.9562665,
      "Longitude": -87.7508544,
      "tags": [
        " relaxing",
        "active",
        "local business",
        "morning",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 108,
      "name": "Monica Eng",
      "person_title": "WBEZ reporter",
      "type": "feeling",
      "adj": " a little too urbaned out ",
      "verb": "stroll along several paths of native plants, 100-year-old maples, and savanna",
      "place": "North Park Village Nature Center",
      "Side": "North Side",
      "tip": "Monica says: \"While you are there, you can also drop off the recycling you've been worried about sending to the city program. The Resource Center has drop off spots by the entrance that they promise to recycle properly without fear or your neighbors' contamination.\" And an anonymous tipster says this is a great place to \"take the kids for a walk and learn about wildlife.\"",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/north-park-village-nature-center",
      "address": "5801 N Pulaski Rd, Chicago, IL 60646",
      "Latitude": 41.9857867,
      "Longitude": -87.7227427,
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "kid friendly",
        "free",
        "North Side"
      ]
    },
    {
      "id": 109,
      "name": "Casey Thiel",
      "type": "time",
      "adj": " Saturdaymorning ",
      "verb": "gather your neighbors for a trash pickup (and have a BBQ afterward).",
      "tags": [
        "outdoor",
        "kid friendly",
        "free",
        "food",
        "good for groups"
      ]
    },
    {
      "id": 110,
      "type": "description",
      "adj": " Rainy  ",
      "verb": "eat gumbo",
      "place": "Heaven on Seven",
      "Side": "Downtown",
      "link": "https://www.heavenonseven.com/",
      "address": "111 N Wabash Ave, Chicago, IL 60602",
      "Latitude": 41.8835178,
      "Longitude": -87.6258728,
      "tags": [
        "local business",
        "food",
        "indoor",
        "evening",
        "midday",
        "kid friendly",
        "Downtown"
      ]
    },
    {
      "id": 111,
      "name": "Melanie Munsey ",
      "type": "time",
      "adj": " Friday ",
      "verb": "play bingo in the basement on Fridays",
      "place": "St. Helen's Church",
      "Side": "West Side",
      "link": "http://www.sthelenparish.net/wp-en/parish/parish-calendar/",
      "address": "2315 W Augusta Blvd, Chicago, IL 60622",
      "Latitude": 41.8991028,
      "Longitude": -87.6848514,
      "tags": [
        "fun and games",
        "indoor",
        "evening",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 112,
      "name": "Gwyn Aubrey",
      "type": "time",
      "adj": " Friday ",
      "verb": "get an ice cream cone and go on a passeggiata (Italian for \"little walk\")",
      "place": "Taylor Street",
      "Side": "West Side",
      "tip": "Gwyn says: Why should Italy have all the fun? Extra points if you get Mario's Italian ice.",
      "address": "1068 W Taylor St, Chicago, IL 60607",
      "Latitude": 41.869672,
      "Longitude": -87.6538354,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "active",
        "wandering",
        "West Side"
      ]
    },
    {
      "id": 113,
      "name": "Bridget Wagner",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "have a beer",
      "place": "Corridor Brewery and Provisions",
      "Side": "North Side",
      "tip": "Bridget recommends chasing your beer with a movie at the Music Box Theatre.",
      "link": "https://www.corridorchicago.com/",
      "address": "3446 N Southport Ave, Chicago, IL 60657",
      "Latitude": 41.944821,
      "Longitude": -87.6643095,
      "tags": [
        "drinking",
        "indoor",
        "cool off",
        "local business",
        "midday",
        "evening",
        "relaxing",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 114,
      "name": "Sterling Haukom Anderson",
      "type": "feeling",
      "adj": " yourself ",
      "verb": "shine ",
      "place": "Slippery Slope",
      "Side": "North Side",
      "link": "http://www.slipperyslopechicago.com/",
      "address": "2357 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9242092,
      "Longitude": -87.6989676,
      "tags": [
        "dancing",
        "indoor",
        "local business",
        "evening",
        "active",
        "North Side"
      ]
    },
    {
      "id": 115,
      "type": "feeling",
      "adj": " low ",
      "verb": "sip a cocktail on top of the city ",
      "place": "Apogee",
      "Side": "Downtown",
      "link": "https://www.apogeechicago.com/",
      "address": "2 W Erie St, Chicago, IL 60654",
      "Latitude": 41.8942059,
      "Longitude": -87.6284554,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "good views",
        "feeling fancy",
        "evening",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 116,
      "name": "Bob Shell",
      "type": "description",
      "adj": " a Monday ",
      "verb": "watch the commuters while having breakfast",
      "place": "Ronny's Steakhouse",
      "Side": "Downtown",
      "link": "https://www.facebook.com/RonnysSteakhouse/",
      "address": "100 W Randolph St, Chicago, IL 60601",
      "Latitude": 41.8851523,
      "Longitude": -87.6316709,
      "tags": [
        "morning",
        "indoor",
        "local business",
        "food",
        "Downtown"
      ]
    },
    {
      "id": 117,
      "name": "Sara Mathers",
      "type": "feeling",
      "adj": " nerdy ",
      "verb": "look at the cool science and technology items for sale ",
      "place": "American Science and Surplus",
      "Side": "North Side",
      "link": "https://www.sciplus.com/",
      "address": "5316 N Milwaukee Ave, Chicago, IL 60630",
      "Latitude": 41.9766873,
      "Longitude": -87.7697992,
      "tags": [
        "indoor",
        "local business",
        "midday",
        "morning",
        "wandering",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 118,
      "name": "Annie Nguyen",
      "type": "time",
      "adj": " a full moon ",
      "verb": "set up a picnic to watch the fire jugglers under a full moon",
      "place": "the Fire Jam",
      "Side": "North Side",
      "tip": "The \"Full Moon Fire Jam\" happens every full moon in a field near Foster Beach.",
      "link": "https://www.chicagoparkdistrict.com/events/full-moon-jam-foster-beach-1",
      "address": "5200 N. Lake Shore Dr. ",
      "Latitude": 41.9768389,
      "Longitude": -87.6477016,
      "tags": [
        "outdoor",
        "picnic",
        "free",
        "evening",
        "kid friendly",
        "active",
        "North Side"
      ]
    },
    {
      "id": 119,
      "name": "Felipe",
      "type": "feeling",
      "adj": " nostalgic ",
      "verb": "revel in nostalgia at \"Another 90's Party\"",
      "place": "Beauty Bar",
      "Side": "West Side",
      "link": "http://thebeautybar.com/home-chicago/",
      "address": "1444 W Chicago Ave",
      "Latitude": 41.8963975,
      "Longitude": -87.6641616,
      "tags": [
        "dancing",
        "evening",
        "indoor",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 120,
      "name": "Chelsea Rump",
      "type": "feeling",
      "adj": " shabby ",
      "verb": "score some new threads ",
      "place": "Una Mae's",
      "Side": "North Side",
      "link": "https://www.unamaeschicago.com/",
      "address": "1528 N Milwaukee Ave # 1",
      "Latitude": 41.9091132,
      "Longitude": -87.6758874,
      "tags": [
        "midday",
        "indoor",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 121,
      "name": "Neda",
      "type": "time",
      "adj": " dinnertime ",
      "verb": "enjoy plant-based comfort food",
      "place": "Kal'ish",
      "Side": "North Side",
      "link": "https://www.kalishvegan.com/",
      "address": "1313 W Wilson Ave, Chicago, IL 60640",
      "Latitude": 41.9651615,
      "Longitude": -87.6628524,
      "tags": [
        "local business",
        "indoor",
        "food",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 122,
      "name": "Alyssa Edes",
      "person_title": "WBEZ producer",
      "type": "feeling",
      "adj": " touristy",
      "verb": "sip a cocktail and enjoy views of the city",
      "place": "the John Hancock Signature Room",
      "Side": "Downtown",
      "tip": "The Signature Room is on the 95th floor of the John Hancock Center.",
      "link": "https://www.signatureroom.com/room/",
      "address": "875 N Michigan Ave, Chicago, IL 60611",
      "Latitude": 41.898883,
      "Longitude": -87.6231503,
      "tags": [
        "evening",
        "midday",
        "indoor",
        "local business",
        "drinking",
        "feeling fancy",
        "good views",
        "Downtown"
      ]
    },
    {
      "id": 123,
      "name": "Gabrielle",
      "type": "feeling",
      "adj": " tired ",
      "verb": "drink coffee ",
      "place": "The Wormhole Coffee",
      "Side": "North Side",
      "link": "https://www.thewormhole.us/",
      "address": "1462 N Milwaukee Ave, Chicago, IL 60622",
      "Latitude": 41.9083283,
      "Longitude": -87.6746647,
      "tags": [
        "coffee",
        "indoor",
        "morning",
        "midday",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 124,
      "type": "feeling",
      "adj": " in need of culture but you want to beoutdoors ",
      "verb": "go see a Shakespearean play",
      "place": "your neighborhood park",
      "link": "https://www.chicagoshakes.com/plays_and_events/explore_season/parks2019/where_and_when",
      "tags": [
        "outdoor",
        "free",
        "evening",
        "kid friendly"
      ]
    },
    {
      "id": 125,
      "name": "Kate",
      "type": "time",
      "adj": " time to take in the fresh air ",
      "verb": "grab your sunnies and take a long walk",
      "place": "The 606",
      "Side": "North Side",
      "address": "W Bloomingdale Ave, Chicago, IL 60647",
      "Latitude": 41.9139246,
      "Longitude": -87.7003545,
      "tags": [
        "free",
        "outdoor",
        "kid friendly",
        "active",
        "relaxing",
        "midday",
        "morning",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 126,
      "name": "Manuel Martinez",
      "person_title": "WBEZ producer",
      "type": "time",
      "adj": " cold  ",
      "verb": "hit the thermal pools",
      "place": "AIRE Ancient Baths",
      "Side": "West Side",
      "link": "https://beaire.com/en/aire-ancient-baths-chicago",
      "address": " 800 W Superior St, Chicago, IL 60642",
      "Latitude": 41.8957293,
      "Longitude": -87.6481481,
      "tags": [
        "indoor",
        "relaxing",
        "midday",
        "evening",
        "morning",
        "feeling fancy",
        "West Side"
      ]
    },
    {
      "id": 127,
      "name": "Margaret Ann",
      "type": "time",
      "adj": " sunny and warm ",
      "verb": "grab a drink",
      "place": "London House Rooftop Bar",
      "Side": "Downtown",
      "link": "https://londonhousechicago.com/rooftop/",
      "address": "85 East Wacker Drive At, N Michigan Ave, Chicago, IL 60601",
      "Latitude": 41.8879023,
      "Longitude": -87.6254458,
      "tags": [
        "drinking",
        "good views",
        "feeling fancy",
        "evening",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 128,
      "name": "Pamela Barnes",
      "type": "feeling",
      "adj": " trapped by the grid ",
      "verb": "follow the river as far as you can",
      "place": "whatever spot is closest to you",
      "tags": [
        "wandering",
        "free",
        "kid friendly",
        "midday",
        "morning",
        "evening"
      ]
    },
    {
      "id": 129,
      "name": "Amy Lecza",
      "type": "time",
      "adj": " 8 p.m. ",
      "verb": "eat all the dumplings your body can hold",
      "place": "QXY",
      "Side": "South Side",
      "tip": "Amy recommends getting bubble tea and walking around Chinatown Square.",
      "link": "http://qxydumplings.com/",
      "address": "2002 S Wentworth Ave #103, Chicago, IL 60616",
      "Latitude": 41.8550738,
      "Longitude": -87.6321316,
      "tags": [
        "local business",
        "food",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 130,
      "name": "Brian Gee",
      "type": "description",
      "adj": " a warm, sunny day ",
      "verb": "grab a drink and play a few games with your friends",
      "place": "the Shore Club",
      "Side": "North Side",
      "link": "https://shoreclubchi.com/",
      "address": "1603 N Lake Shore Dr, Chicago, IL 6061",
      "Latitude": 41.9135039,
      "Longitude": -87.6242481,
      "tags": [
        "drinking",
        "indoor",
        "fun and games",
        "local business",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 131,
      "name": "Diane",
      "type": "time",
      "adj": " sunset ",
      "verb": "check out Art on the MART at sunset",
      "place": "the Merchandise Mart",
      "Side": "Downtown",
      "link": "https://www.artonthemart.com/",
      "address": " 222 W Merchandise Mart Plaza, Chicago, IL 60654",
      "Latitude": 41.8884096,
      "Longitude": -87.6354498,
      "tags": [
        "outdoor",
        "creativity",
        "learn something new",
        "kid friendly",
        "evening",
        "free",
        "Downtown"
      ]
    },
    {
      "id": 132,
      "name": "Mia Sato",
      "type": "feeling",
      "adj": " like you wanna dance! ",
      "verb": "bring cash, wear your dancing shoes (and maybe prepare to wait in line) 💃🏻 ",
      "place": "Danny's Tavern",
      "Side": "North Side",
      "link": "https://www.facebook.com/pages/Dannys-Bar-Wicker-Park/292381780773679",
      "address": "1951 W Dickens Ave, Chicago, IL 60614",
      "Latitude": 41.9194313,
      "Longitude": -87.6772451,
      "tags": [
        "dancing",
        "indoor",
        "local business",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 133,
      "name": "Manuel Martinez",
      "person_title": "WBEZ producer",
      "type": "description",
      "adj": " a cold day ",
      "verb": "eat ramen",
      "place": "Strings Ramen Shop",
      "Side": "South Side",
      "link": "https://www.ramenchicago.com/#the-kitchen",
      "address": "2141 S Archer Ave, Chicago, IL 60616",
      "Latitude": 41.853397,
      "Longitude": -87.633194,
      "tags": [
        "food",
        "local business",
        "indoor",
        "evening",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 134,
      "name": "Mara Jacobucci",
      "type": "time",
      "adj": " flat ",
      "verb": "reach new heights",
      "place": "First Ascent Climbing and Fitness - Humboldt Park",
      "Side": "West Side",
      "link": "https://firstascentclimbing.com/",
      "address": "2950 W Grand Ave, Chicago, IL 60622",
      "Latitude": 41.896599,
      "Longitude": -87.701238,
      "tags": [
        "active",
        "indoor",
        "kid friendly",
        "midday",
        "evening",
        "local business",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 135,
      "name": "Adam Morgan",
      "person_title": "Chicago writer",
      "type": "feeling",
      "adj": " bored ",
      "verb": "read about the world from different perspectives",
      "place": "Pilsen Community Books",
      "Side": "South Side",
      "link": "https://www.pilsencommunitybooks.org/find-us",
      "address": "1102 W 18th St",
      "Latitude": 41.8581882,
      "Longitude": -87.6536044,
      "tags": [
        "indoor",
        "free",
        "books",
        "kid friendly",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 136,
      "name": "Sabrina ",
      "type": "time",
      "adj": " time to get away for a few hours  from the fast paced rat race ",
      "verb": "take the Riverwalk to the end and play a game of bags in the shade",
      "place": "the Island Party Hut tiki bar",
      "Side": "Downtown",
      "link": "http://www.islandpartyhut.com/",
      "address": "355 Chicago Riverwalk, Chicago, IL 60601",
      "Latitude": 41.8880499,
      "Longitude": -87.6196894,
      "tags": [
        "outdoor",
        "fun and games",
        "drinking",
        "midday",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 137,
      "name": "Heidi Stevens",
      "person_title": "<em>Chicago Tribune</em> columnist",
      "type": "feeling",
      "adj": " sweaty ",
      "verb": "cool off with a house-made Italian ice",
      "place": "Fabulous Freddies Italian Eatery",
      "Side": "South Side",
      "link": "http://freddieson31st.com/freddies/",
      "address": "3097, 701 W 31st St #1, Chicago, IL 60616",
      "Latitude": 41.8378707,
      "Longitude": -87.6439968,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "cool off",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 138,
      "name": "Shelley Jacobs",
      "type": "time",
      "adj": " a gorgeous Thursday night ",
      "verb": "eat your way through Thursday evenings",
      "place": "the Argyle Night Market",
      "Side": "North Side",
      "link": "https://www.facebook.com/ArgyleNightMarket/",
      "address": "Argyle Street Chicago IL",
      "Latitude": 41.9723482,
      "Longitude": -87.6622359,
      "tags": [
        "food",
        "local business",
        "indoor",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 139,
      "name": "Diane",
      "type": "time",
      "adj": " 6pm ",
      "verb": "sip a Nebbiolo",
      "place": "Princi",
      "Side": "West Side",
      "tip": "Diane recommends sipping this Italian red wine with a handsome stranger.",
      "link": "https://www.princi.com/",
      "address": "1000 W Randolph St, Chicago, IL 60607",
      "Latitude": 41.8846323,
      "Longitude": -87.6523399,
      "tags": [
        "drinking",
        "indoor",
        "relaxing",
        "local business",
        "West Side"
      ]
    },
    {
      "id": 140,
      "name": "Drew Schmedding",
      "type": "description",
      "adj": " a hot summer day ",
      "verb": "check out the rooftop cabana",
      "place": "The Robey",
      "Side": "North Side",
      "link": "https://www.therobey.com/",
      "address": "2018 W North Ave, Chicago, IL 60647",
      "Latitude": 41.9106105,
      "Longitude": -87.6781632,
      "tags": [
        " relaxing",
        "good views",
        "drinking",
        "outdoor",
        "feeling fancy",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 141,
      "name": "Shelley Jacobs",
      "type": "description",
      "adj": " a cool, rainy day ",
      "verb": "play board games",
      "place": "kibbitznest",
      "Side": "North Side",
      "link": "http://www.kibbitznest.com/",
      "address": "2212 N Clybourn Ave",
      "Latitude": 41.9218648,
      "Longitude": -87.6652658,
      "tags": [
        "fun and games",
        "indoor",
        "midday",
        "drinking",
        "coffee",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 142,
      "name": "Karoon Panosyan",
      "person_title": "WBEZ email marketing manager",
      "type": "feeling",
      "adj": " tropical ",
      "verb": "have a cocktail",
      "place": "Three Dots and a Dash",
      "Side": "Downtown",
      "link": "http://threedotschicago.com/",
      "address": "435 N Clark St, Chicago, IL 60654",
      "Latitude": 41.8903369,
      "Longitude": -87.6309053,
      "tags": [
        "indoor",
        "drinking",
        "evening",
        "local business",
        "Downtown"
      ]
    },
    {
      "id": 143,
      "name": "Samantha ",
      "type": "time",
      "adj": " raining ",
      "verb": "find an old book",
      "place": "Myopic Bookstore",
      "Side": "North Side",
      "link": "https://www.myopicbookstore.com/",
      "address": "1564 N Milwaukee Ave, Chicago, IL 60622",
      "Latitude": 41.9097727,
      "Longitude": -87.6769384,
      "tags": [
        "indoor",
        "books",
        "midday",
        "evening",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 144,
      "name": "Stephanie Marder",
      "type": "description",
      "adj": " a beautiful morning ",
      "verb": "go kayaking",
      "place": "the Chicago Sanitary and Ship Canal",
      "tags": [
        "outdoor",
        "active",
        "active",
        "midday",
        "morning",
        "evening"
      ]
    },
    {
      "id": 145,
      "name": "Rachel B",
      "type": "feeling",
      "adj": " something sweet ",
      "verb": "get a smore ",
      "place": "XO Marshmallow",
      "Side": "North Side",
      "link": "https://www.xomarshmallow.com/",
      "address": "6977 N Sheridan Rd",
      "Latitude": 42.0088747,
      "Longitude": -87.6617327,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "midday",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 146,
      "name": "Joshua Magno",
      "type": "description",
      "adj": " a tourist-filled day ",
      "verb": "eat burgers and drink delicious herbal- and plant-flavored beers",
      "place": "Forbidden Root Restaurant and Brewery",
      "Side": "West Side",
      "link": "http://www.forbiddenroot.com/",
      "address": "1746 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8961997,
      "Longitude": -87.6715978,
      "tags": [
        "food",
        "local business",
        "indoor",
        "drinking",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 147,
      "name": "Dave Stanford",
      "type": "description",
      "adj": " a exploring day ",
      "verb": "check out Chicago's national monument",
      "place": "the Pullman Historic District",
      "Side": "South Side",
      "link": "http://www.pullmanil.org/",
      "address": "11141 S Cottage Grove Ave, Chicago, IL 60628",
      "Latitude": 41.6913431,
      "Longitude": -87.6096707,
      "tags": [
        "learn something new",
        "outdoor",
        "free",
        "midday",
        "morning",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 148,
      "name": "Gabrielle",
      "type": "description",
      "adj": " a warm day ",
      "verb": "drink a negroni slushy, eat fried chicken and play with dogs on the patio",
      "place": "Parson's Chicken and Fish",
      "Side": "North Side",
      "link": "http://www.parsonschickenandfish.com/",
      "address": "2952 W Armitage Ave",
      "Latitude": 41.917626,
      "Longitude": -87.701346,
      "tags": [
        "drinking",
        "food",
        "outdoor",
        "animals",
        "good for groups",
        "evening",
        "midday",
        "outdoor",
        "North Side"
      ]
    },
    {
      "id": 149,
      "name": "Amy Lecza",
      "type": "description",
      "adj": " a cool fall day ",
      "verb": "try a cider flight",
      "place": "The Northman",
      "Side": "North Side",
      "tip": "Amy says this neighborhood is also great for wandering.",
      "link": "https://www.thenorthman.com/",
      "address": "4337 N Lincoln Ave, Chicago, IL 60618",
      "Latitude": 41.9605939,
      "Longitude": -87.6829794,
      "tags": [
        "drinking",
        "wandering",
        "relaxing",
        "indoor",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 150,
      "name": "Kazuyoshi Yamada",
      "person_title": "chef at Superkhana International",
      "type": "description",
      "adj": " a Thursday ",
      "verb": "order the special burger on Thursdays",
      "place": "Cafe Marie-Jeanne",
      "Side": "West Side",
      "tip": "On Thursdays, a beer, burger and fries are $20.",
      "link": "http://www.cafe-marie-jeanne.com/",
      "address": "1001 N California Ave, Chicago, IL 60622",
      "Latitude": 41.8994323,
      "Longitude": -87.6964567,
      "tags": [
        "indoor",
        "food",
        "drinking",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 151,
      "name": "Doug Nystrom",
      "type": "time",
      "adj": " a nice sunny Friday ",
      "verb": "take a mental health day and ride along the North Branch of the Chicago River, starting",
      "place": "Gompers Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/gompers-samuel-park",
      "address": "4222 W Foster Ave, Chicago, IL 60630",
      "Latitude": 41.975816,
      "Longitude": -87.734386,
      "tags": [
        "free",
        "biking",
        "outdoor",
        "kid friendly",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 152,
      "name": "Arionne Nettles",
      "person_title": "WBEZ producer",
      "verb": "make your own breakfast sandwich",
      "place": "Robust Coffee Lounge",
      "Side": "South Side",
      "link": "http://robustcoffeelounge.com/",
      "address": "6300 S Woodlawn Ave, Chicago, IL 60637",
      "Latitude": 41.7802796,
      "Longitude": -87.5964954,
      "tags": [
        "food",
        "morning",
        "local business",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 153,
      "name": "Janaya",
      "type": "description",
      "adj": " a chilly day ",
      "verb": "get tea",
      "place": "Saint's Alp Teahouse",
      "Side": "South Side",
      "link": "https://www.saintsalpchicago.com/",
      "address": "2157 S China Pl, Chicago, IL 60616",
      "Latitude": 41.8537708,
      "Longitude": -87.6346054,
      "tags": [
        " relaxing",
        "food",
        "indoor",
        "good for groups",
        "midday",
        "morning",
        "evening",
        "local business",
        "South Side"
      ]
    },
    {
      "id": 154,
      "name": "Emily",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "do the architectural boat tour",
      "place": "the Chicago River",
      "Side": "Downtown",
      "tip": "Emily says: \"It's the cheapest bar in the city with great views.\"",
      "link": "https://www.architecture.org/tours/detail/chicago-architecture-foundation-center-river-cruise-aboard-chicagos-first-lady/",
      "address": "Chicago river",
      "Latitude": 41.8885152,
      "Longitude": -87.6232657,
      "tags": [
        "learn something new",
        "good views",
        "drinking",
        "kid friendly",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 155,
      "name": "Sterling Haukom Anderson",
      "type": "description",
      "adj": " a nice day ",
      "verb": "grab a doughnut",
      "place": "Smack Dab",
      "Side": "North Side",
      "link": "https://www.smackdabchicago.com/menu",
      "address": "6730 N Clark St, Chicago, IL 60626",
      "Latitude": 42.0044342,
      "Longitude": -87.6732733,
      "tags": [
        "food",
        "indoor",
        "local business",
        "kid friendly",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 156,
      "name": "Samuel Stevens",
      "type": "feeling",
      "adj": " famished ",
      "verb": "grab some rib tips and links",
      "place": "Slab BBQ",
      "Side": "South Side",
      "link": "http://www.slabbbq.com/#home",
      "address": "1918 E 71st St",
      "Latitude": 41.7663595,
      "Longitude": -87.5780059,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 157,
      "name": "Samantha Irby",
      "person_title": "author/comedian",
      "type": "feeling",
      "adj": " like a huge moron  ",
      "verb": "ask for book recommendations ",
      "place": "Women and Children First bookstore",
      "Side": "North Side",
      "link": "https://www.womenandchildrenfirst.com/",
      "address": "5233 N Clark St",
      "Latitude": 41.9772659,
      "Longitude": -87.668092,
      "tags": [
        "books",
        "indoor",
        "local business",
        "kid friendly",
        "midday",
        "evening",
        "morning",
        "learn something new",
        "North Side"
      ]
    },
    {
      "id": 158,
      "name": "Claire",
      "type": "feeling",
      "adj": " melancholy ",
      "verb": "watch the sunset",
      "place": "Loyola Beach",
      "Side": "North Side",
      "tip": "Claire likes Loyola Beach because \"it's not crowded, has beautiful views, (and) is a great place for a light public weeping.\"",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/loyola-beach",
      "address": "1230 W. Greenleaf Ave.",
      "Latitude": 42.0108499,
      "Longitude": -87.6616126,
      "tags": [
        "good views",
        "outdoor",
        "nature",
        "relaxing",
        "free",
        "North Side"
      ]
    },
    {
      "id": 159,
      "name": "Eve Robinson",
      "type": "time",
      "adj": " 1:30am ",
      "verb": "drive while listening to house music",
      "place": "Lake Shore Drive",
      "tags": [
        "lakefront",
        "outdoor",
        "music",
        "evening",
        "wandering",
        "free"
      ]
    },
    {
      "id": 160,
      "name": "Janaya",
      "type": "feeling",
      "adj": " wanderlust ",
      "verb": "explore",
      "place": "Sagawau Canyon Nature Preserve in Lemont",
      "Side": "Suburbs",
      "link": "http://fpdcc.com/events/category/series/canyon-tour/",
      "tags": [
        " relaxing",
        "nature",
        "free",
        "kid friendly",
        "outdoor",
        "active",
        "Suburbs"
      ]
    },
    {
      "id": 161,
      "name": "Michael Lansu",
      "person_title": "WBEZ editor",
      "verb": "sit in your car and eat hot dogs",
      "place": "Superdawg Drive-In",
      "Side": "North Side",
      "link": "http://www.superdawg.com/",
      "address": "6363 N. Milwaukee Avenue, Chicago, IL 60646",
      "Latitude": 41.9967617,
      "Longitude": -87.7870165,
      "tags": [
        "midday",
        "food",
        "evening",
        "local business",
        "kid friendly",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 162,
      "name": "Amanda Berrios",
      "type": "feeling",
      "adj": " insomnia ",
      "verb": "experience Chicago's longest running (and arguably weirdest) late night show, \"The Infinite Wrench,\"",
      "place": "The Neo-Futurists theater",
      "Side": "North Side",
      "link": "https://neofuturists.org/events/theinfinitewrench/",
      "address": "5153 N Ashland Ave",
      "Latitude": 41.9759407,
      "Longitude": -87.669322,
      "tags": [
        "indoor",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 163,
      "name": "Allison Manley",
      "type": "time",
      "adj": " puppy weather ",
      "verb": "admire the lake and playful pooches",
      "place": "the Foster Beach dog park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/foster-beach",
      "address": "1425 N. Damen Avenue \nChicago, IL 60622",
      "Latitude": 41.9080486,
      "Longitude": -87.676738,
      "tags": [
        "lakefront",
        "outdoor",
        "free",
        "animals",
        "kid friendly",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 164,
      "name": "Lib",
      "type": "description",
      "adj": " a leisurely Sundaymorning ",
      "verb": "walk through beautiful Humboldt Park and then get doughnuts and coffee",
      "place": "Roeser's Bakery",
      "Side": "West Side",
      "link": "http://www.roeserscakes.com/",
      "address": "3216 W North Ave, Chicago, IL 60647",
      "Latitude": 41.9103696,
      "Longitude": -87.7076013,
      "tags": [
        "active",
        "outdoor",
        "food",
        "kid friendly",
        "local business",
        "morning",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 165,
      "name": "Sabrina Miller",
      "type": "description",
      "adj": "rainy",
      "verb": "spend the day bowling",
      "place": "Skyway Lanes",
      "Side": "South Side",
      "link": "https://www.facebook.com/SkywayBowl/",
      "address": "9915 S Torrence Ave, Chicago, IL 60617",
      "Latitude": 41.714585,
      "Longitude": -87.559253,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "evening",
        "local business",
        "midday",
        "fun and games",
        "active",
        "South Side"
      ]
    },
    {
      "id": 166,
      "name": "Ambrish Kochikar",
      "type": "feeling",
      "adj": " rich ",
      "verb": "take a selfie with the \"Million Dollar Suitcase\" (Ka-ching!!)",
      "place": "the museum at the Federal Reserve Bank of Chicago",
      "Side": "Downtown",
      "link": "https://www.chicagofed.org/education/money-museum/index",
      "address": "230 S LaSalle St",
      "Latitude": 41.8785478,
      "Longitude": -87.6328668,
      "tags": [
        "midday",
        "indoor",
        "free",
        "kid friendly",
        "Downtown"
      ]
    },
    {
      "id": 167,
      "name": "Jackie Blair",
      "type": "time",
      "adj": "second Saturday of the month",
      "verb": "support West Side entrepreneurs",
      "place": "the Garfield Park Neighborhood Market",
      "Side": "West Side",
      "tip": "This market takes places on the second Saturday and third Thursday of the month from June through October.",
      "link": "http://www.gpcommunitycouncil.org/calendar/category/199",
      "address": "135 N. Kedzie Chicago IL",
      "Latitude": 41.883888,
      "Longitude": -87.705833,
      "tags": [
        "midday",
        "indoor",
        "local business",
        "West Side"
      ]
    },
    {
      "id": 168,
      "type": "feeling",
      "adj": " overwhelmed ",
      "verb": "take in nature or read a novel",
      "place": "the Caldwell Lily Pool",
      "Side": "North Side",
      "link": "http://lincolnparkconservancy.org/projects/alfred-caldwell-lily-pool/",
      "address": "125 W Fullerton Pkwy, Chicago, IL 60614",
      "Latitude": 41.923809,
      "Longitude": -87.6356849,
      "tags": [
        "books",
        "relaxing",
        "outdoor",
        "free",
        "midday",
        "evening",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 169,
      "name": "Erin Eife",
      "type": "feeling",
      "adj": " tired ",
      "verb": "get a cup of coffee",
      "place": "Kusanya Cafe",
      "Side": "South Side",
      "link": "http://www.kusanyacafe.org/home",
      "address": "825 W 69th St, Chicago, IL 60621",
      "Latitude": 41.7685814,
      "Longitude": -87.6455659,
      "tags": [
        "coffee",
        "indoor",
        "local business",
        "morning",
        "relaxing",
        "South Side"
      ]
    },
    {
      "id": 170,
      "name": "Corinne",
      "type": "feeling",
      "adj": " bored ",
      "verb": "pop some quarters in the pinball machines",
      "place": "Logan Arcade",
      "Side": "North Side",
      "link": "https://loganarcade.com/",
      "address": "2410 W Fullerton Ave, Chicago, IL 60647",
      "Latitude": 41.9251867,
      "Longitude": -87.6880934,
      "tags": [
        "indoor",
        "fun and games",
        "midday",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 171,
      "name": "Lauren Hames ",
      "type": "description",
      "adj": " a beautiful sunny day ",
      "verb": "wake up early to eat ",
      "place": "Valois Restaurant",
      "Side": "South Side",
      "tip": "Afterwards, Lauren suggests walking around The University of Chicago campus and visiting the Frank Lloyd Wright-designed Robie House.",
      "link": "http://www.valoisrestaurant.com/",
      "address": "1518 E 53rd St, Chicago, IL 60615",
      "Latitude": 41.79966,
      "Longitude": -87.5883252,
      "tags": [
        "indoor",
        "morning",
        "wandering",
        "food",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 172,
      "name": "Lucia Whalen",
      "type": "time",
      "adj": " Monday night ",
      "verb": "go to the Monday night outdoor comedy show, CAMP,",
      "place": "Village Tap",
      "Side": "North Side",
      "link": "https://www.facebook.com/Campcomedyshow/",
      "address": "2055 W Roscoe St",
      "Latitude": 41.9429695,
      "Longitude": -87.6805983,
      "tags": [
        "evening",
        "outdoor",
        "drinking",
        "free",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 173,
      "name": "Mike ",
      "type": "feeling",
      "adj": " hungry on a Fridayevening ",
      "verb": "go to a Friday night fish fry",
      "place": "Steve's Lounge",
      "Side": "South Side",
      "link": "https://www.facebook.com/stevesloungechicago/",
      "address": "13200 S Baltimore Ave",
      "Latitude": 41.6553258,
      "Longitude": -87.5475046,
      "tags": [
        "local business",
        "food",
        "indoor",
        "evening",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 174,
      "name": "Katie",
      "type": "feeling",
      "adj": " stir crazy ",
      "verb": "walk and hunt for sculptures",
      "place": "the lake",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/artwork-monuments",
      "tags": [
        "lakefront",
        "outdoor",
        "kid friendly",
        "midday",
        "morning",
        "evening"
      ]
    },
    {
      "id": 175,
      "name": "Stephanie Izard",
      "person_title": "Iron Chef",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "take your family to the see octopuses",
      "place": "the Shedd Aquarium ",
      "Side": "Downtown",
      "link": "https://www.sheddaquarium.org/",
      "address": "1200 S Lake Shore Dr, Chicago, IL 60605",
      "Latitude": 41.8675569,
      "Longitude": -87.6131611,
      "tags": [
        "indoor",
        "kid friendly",
        "animals",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 176,
      "name": "Ed Bannon",
      "type": "time",
      "adj": " Saturday ",
      "verb": "bring your kids to play Dungeons & Dragons on Saturdays",
      "place": "the Dunning Library",
      "Side": "North Side",
      "link": "https://chipublib.bibliocommons.com/events/5b0dce510d75dc2f00f03ed9",
      "address": " 7455 W Cornelia Ave, Chicago, IL 60634",
      "Latitude": 41.9430393,
      "Longitude": -87.8139435,
      "tags": [
        "indoor",
        "kid friendly",
        "free",
        "midday",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 177,
      "name": "Mike ",
      "type": "description",
      "adj": " summer  ",
      "verb": "watch the bocce ball leagues play",
      "place": "the taverns on 106th Street",
      "Side": "South Side",
      "address": "3541 E 106th St",
      "Latitude": 41.7025588,
      "Longitude": -87.5372481,
      "tags": [
        "fun and games",
        "indoor",
        "drinking",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 178,
      "name": "Helen Muhisani",
      "type": "feeling",
      "adj": " sun-deprived ",
      "verb": "soak up some rays",
      "place": "31st Street Beach",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/margaret-t-burroughs-beach",
      "address": "3100 S Lake Shore Dr, Chicago, IL 60616",
      "Latitude": 41.8408804,
      "Longitude": -87.6095202,
      "tags": [
        "lakefront",
        "outdoor",
        "local business",
        "relaxing",
        "morning",
        "midday",
        "good for groups",
        "free",
        "South Side"
      ]
    },
    {
      "id": 179,
      "name": "Gabrielle ",
      "type": "description",
      "adj": " a hot day ",
      "verb": "swim in Chicago's only inland beach",
      "place": "Humboldt Park",
      "Side": "West Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/humboldt-beach",
      "address": "1400 N Humboldt Dr, Chicago, IL 60622",
      "Latitude": 41.9066384,
      "Longitude": -87.7014309,
      "tags": [
        "outdoor",
        "active",
        "kid friendly",
        "free",
        "midday",
        "evening",
        "relaxing",
        "West Side"
      ]
    },
    {
      "id": 180,
      "name": "Carrie Shepherd",
      "person_title": "WBEZ reporter",
      "type": "time",
      "adj": " cold ",
      "verb": "drink some wine",
      "place": "Gio's Cafe and Deli",
      "Side": "South Side",
      "link": "https://www.gioscafe.com/",
      "address": "2724 S Lowe Ave, Chicago, IL 60616",
      "Latitude": 41.8436806,
      "Longitude": -87.6429456,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "midday",
        "evening",
        "midday",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 181,
      "name": "Nichole Gardner",
      "type": "feeling",
      "adj": " like a kid in Chicago. You should stop by the Garfield-Clarendon Model Railroad Club HQ at the Clarendon Park Fieldhouse any Friday night and check out their model train track, the largest one ",
      "verb": "check out the largest model train track in Chicago, on Friday nights",
      "place": "the Clarendon Park fieldhouse",
      "Side": "North Side",
      "tip": "The Garfield-Carlendon Model Railroad club is open to visitors every Friday (\"except the first occurance for the month\") from 7 p.m. to 9:00 p.m. ",
      "link": "http://www.garfieldcentral.org/visit",
      "address": "4501 N Clarendon Ave, Chicago, IL 60640",
      "Latitude": 41.963761,
      "Longitude": -87.6492475,
      "tags": [
        "indoor",
        "free",
        "evening",
        "kid friendly",
        "learn something new",
        "North Side"
      ]
    },
    {
      "id": 182,
      "name": "Jennifer Long Riordan",
      "type": "feeling",
      "adj": " hungry",
      "verb": "eat",
      "place": "The Original Pancake House in the Gold Coast",
      "Side": "North Side",
      "link": "https://www.ophchicagoland.com/gold-coast/",
      "address": "22 E Bellevue Pl, Chicago, IL 60611",
      "Latitude": 41.901791,
      "Longitude": -87.6274495,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 183,
      "name": "Dave Stanford",
      "type": "feeling",
      "adj": " like playing by, not in water ",
      "verb": "kayak on the Chicago River from WMS Boathouse",
      "place": "Clark Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/clark-richard-park",
      "address": "3400 N Rockwell St, Chicago, IL 60618",
      "Latitude": 41.9433816,
      "Longitude": -87.6946043,
      "tags": [
        "outdoor",
        "active",
        "kid friendly",
        "nature",
        "free",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 184,
      "type": "feeling",
      "adj": " bored ",
      "verb": "have a hot pot lunch",
      "place": "Lao Sze Chuan",
      "Side": "South Side",
      "link": "http://laoszechuanusa.com/",
      "address": "2172 S Archer Ave, Chicago, IL 60616",
      "Latitude": 41.8532889,
      "Longitude": -87.63495,
      "tags": [
        "indoor",
        "good for groups",
        "midday",
        "evening",
        "food",
        "South Side"
      ]
    },
    {
      "id": 185,
      "name": "Erin McDuffie",
      "type": "feeling",
      "adj": " cooped up with city kids in Chicago. You should see the animal displays and take a hike at the Little Red Schoolhouse in the Cook County Forest Preserves. -or- You're feelingactive ",
      "verb": "see the animal displays and take a hike",
      "place": "the Little Red Schoolhouse Nature Center in the Cook County Forest Preserves in Willow Springs",
      "Side": "Suburbs",
      "link": "http://fpdcc.com/nature-centers/little-red-schoolhouse-nature-center/",
      "tags": [
        "animals",
        "kid friendly",
        "active",
        "free",
        "learn something new",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 186,
      "name": "Priya Ghosh",
      "type": "description",
      "adj": " a summer night ",
      "verb": "ride your bike on the lakefront path to Argyle Street and eat",
      "place": "Tank Noodle",
      "Side": "North Side",
      "link": "https://www.tank-noodle.com/",
      "address": "4953-55 N Broadway, Chicago, IL 60640",
      "Latitude": 41.973133,
      "Longitude": -87.6594309,
      "tags": [
        "food",
        "local business",
        "kid friendly",
        "biking",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 187,
      "name": "Katie",
      "type": "time",
      "adj": " summer vacation ",
      "verb": "take the kids to Drag Queen Story Hour",
      "place": "The Shapiro Ballroom",
      "Side": "West Side",
      "link": "https://www.facebook.com/events/1762820853863269/",
      "address": "1612 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8963194,
      "Longitude": -87.66794,
      "tags": [
        "kid friendly",
        "indoor",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 188,
      "name": "Allyssa Pollard",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "wander around",
      "place": "Architectural Artifacts",
      "Side": "North Side",
      "tip": "Architectural Artificats is a large antique store that was founded by an archaeologist in 1987.",
      "link": "https://www.architecturalartifacts.com/",
      "address": "4325 N Ravenswood Ave, Chicago, IL 60613",
      "Latitude": 41.9605889,
      "Longitude": -87.6735182,
      "tags": [
        "midday",
        "wandering",
        "indoor",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 189,
      "name": "Liz",
      "type": "description",
      "adj": " a dreary day ",
      "verb": "get a beer",
      "place": "Hopleaf Bar",
      "Side": "North Side",
      "link": "https://hopleafbar.com/",
      "address": "5148 N Clark St, Chicago, IL 60640",
      "Latitude": 41.975817,
      "Longitude": -87.6685797,
      "tags": [
        "drinking",
        "indoor",
        "food",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 190,
      "name": "Emily",
      "type": "description",
      "adj": " a balmy day ",
      "verb": "get an ice cream cone",
      "place": "The Freeze",
      "Side": "North Side",
      "link": "https://www.facebook.com/TheFreezeChicago/",
      "address": "2815 W Armitage Ave, Chicago, IL 60647",
      "Latitude": 41.9173274,
      "Longitude": -87.6980352,
      "tags": [
        "ice cream",
        "kid friendly",
        "outdoor",
        "midday",
        "evening",
        "cool off",
        "North Side"
      ]
    },
    {
      "id": 191,
      "name": "Sara Mathers",
      "type": "time",
      "adj": " Sunday ",
      "verb": "eat brunch",
      "place": "MacArthur's",
      "Side": "West Side",
      "link": "https://macarthursrestaurant.com/",
      "address": "5412 W Madison St, Chicago, IL 60644",
      "Latitude": 41.8805324,
      "Longitude": -87.7606929,
      "tags": [
        "food",
        "local business",
        "indoor",
        "morning",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 192,
      "name": "Eden Sabala",
      "type": "time",
      "adj": " 5 pm ",
      "verb": "climb the Carillon tower on Sunday after the Bells of Summer concert",
      "place": "Rockefeller Memorial Chapel on the campus of The University of Chicago",
      "Side": "South Side",
      "tip": "Eden says: \"Take in that evening sunset from the tallest point on campus!\"",
      "link": "https://rockefeller.uchicago.edu/the-carillon/the-bells-of-summer",
      "address": "5850 S Woodlawn Ave, Chicago, IL 60637",
      "Latitude": 41.7885418,
      "Longitude": -87.5970458,
      "tags": [
        "indoor",
        "active",
        "learn something new",
        "music",
        "good views",
        "free",
        "good for groups",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 193,
      "name": "Amanda Stryker",
      "type": "description",
      "adj": " a rainy day in Chicago. You should read a book by one of the many amazing Chicago authors at Heritage Bikes & Coffee. It's a sunny day ",
      "verb": "read a book by one of the many amazing Chicago authors",
      "place": "Heritage Bikes and Coffee",
      "Side": "North Side",
      "link": "https://www.heritagebicycles.com/",
      "address": "2959 N Lincoln Ave, Chicago, IL 60657",
      "Latitude": 41.9357352,
      "Longitude": -87.6628524,
      "tags": [
        "morning",
        "books",
        "coffee",
        "indoor",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 194,
      "name": "Gwyn Aubrey",
      "type": "feeling",
      "adj": " lonely ",
      "verb": "see a foreign film",
      "place": "the Music Box Theatre",
      "Side": "North Side",
      "tip": "Gwyn says: \"Get a fancy drink and sob in the dark as lovers break up over misunderstandings that will haunt them to their graves.\"",
      "link": "https://musicboxtheatre.com/",
      "address": "3733 N Southport Ave",
      "Latitude": 41.9498717,
      "Longitude": -87.6638724,
      "tags": [
        "drinking",
        "indoor",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 195,
      "name": "Rhymefest",
      "person_title": "musician",
      "verb": "take the dogs for a walk",
      "place": "the Cook County Forests Preserves in Niles",
      "Side": "Suburbs",
      "tip": "Rhymefest originally gave his recommendation to us as a rhyme: \"It's a beautiful summer day that Chicago deserves, take the dogs for a walk, visit the Forests Preserves.\"",
      "link": "http://fpdcc.com/",
      "tags": [
        "kid friendly",
        "outdoor",
        "midday",
        "evening",
        "wandering",
        "nature",
        "Suburbs"
      ]
    },
    {
      "id": 196,
      "name": "Doug Nystrom",
      "type": "description",
      "adj": " a warm & sunny day in Chicago. You should have breakfast or lunch in the garden at Tres Kroner restaurant on Foster Av ",
      "verb": "have breakfast or lunch in the garden",
      "place": "Tres Kronor Restaurant",
      "Side": "North Side",
      "link": "http://swedishbistro.com/",
      "address": "3258 W Foster Ave, Chicago, IL 60625",
      "Latitude": 41.9758818,
      "Longitude": -87.7109884,
      "tags": [
        "food",
        "indoor",
        "midday",
        "morning",
        "relaxing",
        "North Side"
      ]
    },
    {
      "id": 197,
      "name": "Karoon Panosyan",
      "person_title": "WBEZ email marketing manager",
      "type": "time",
      "adj": " the perfect weather for walking ",
      "verb": "check out the free zoo, farm and conservatory",
      "place": "Lincoln Park",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/lincoln-abraham-park",
      "address": "2001 N Clark St, Chicago, IL 60614",
      "Latitude": 41.918712,
      "Longitude": -87.6353727,
      "tags": [
        "animals",
        "outdoor",
        "kid friendly",
        "free",
        "wandering",
        "North Side"
      ]
    },
    {
      "id": 198,
      "name": "William Rivas",
      "type": "time",
      "adj": " 7pm ",
      "verb": "enjoy a BYOB dinner",
      "place": "Thai Pastry",
      "Side": "North Side",
      "link": "https://www.thaipastry.com/",
      "address": "4925 N Broadway, Chicago, IL 60640",
      "Latitude": 41.9723285,
      "Longitude": -87.6591153,
      "tags": [
        "indoor",
        "drinking",
        "food",
        "local business",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 199,
      "type": "feeling",
      "adj": " like you've seen everything ",
      "verb": "stop and see the city from a new angle",
      "place": "Adler Planetarium",
      "Side": "Downtown",
      "link": "https://www.adlerplanetarium.org/",
      "address": "1300 S Lake Shore Dr, Chicago, IL 60605",
      "Latitude": 41.8663303,
      "Longitude": -87.6063721,
      "tags": [
        "free",
        "good views",
        "outdoor",
        "local business",
        "Downtown"
      ]
    },
    {
      "id": 200,
      "name": "Jamie Golden",
      "type": "time",
      "adj": "Friday",
      "verb": "have some duck tacos and listen to live jazz",
      "place": "Chant",
      "Side": "South Side",
      "link": "https://www.chantchicago.com/",
      "address": "1509 E 53rd St, Chicago, IL 60615",
      "Latitude": 41.7992741,
      "Longitude": -87.5886011,
      "tags": [
        "indoor",
        "food",
        "music",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 201,
      "name": "Devin Pickell",
      "type": "description",
      "adj": " a sunny, rainy, or any day and you're tired of sipping the same brew ",
      "verb": "check out the locally roasted, freshly sourced beans",
      "place": "Passion House Coffee Roasters",
      "Side": "North Side",
      "link": "https://www.passionhousecoffee.com/cafe-1",
      "address": "2631 N Kedzie Ave, Chicago, IL 60647",
      "Latitude": 41.9293907,
      "Longitude": -87.7071027,
      "tags": [
        "midday",
        "coffee",
        "indoor",
        "morning",
        "relaxing",
        "North Side"
      ]
    },
    {
      "id": 202,
      "name": "Michael Derdzinske",
      "type": "feeling",
      "adj": " stressed  ",
      "verb": "chill out",
      "place": "the Osaka Gardens in Jackson Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/japanese-garden",
      "address": "S Cornell Dr, Chicago, IL 60637",
      "Latitude": 41.7815954,
      "Longitude": -87.5845348,
      "tags": [
        "outdoor",
        "relaxing",
        "kid friendly",
        "nature",
        "midday",
        "morning",
        "evening",
        "free",
        "South Side"
      ]
    },
    {
      "id": 203,
      "name": "Pamela Barnes",
      "type": "description",
      "adj": " weekend ",
      "verb": "jump on any Metra train",
      "place": "a station you've never been",
      "tags": [
        "wandering"
      ]
    },
    {
      "id": 204,
      "name": "Renée",
      "type": "description",
      "adj": " a beautiful Saturday ",
      "verb": "pick up some peaches, feta and a baguette",
      "place": "the Green City Market in Lincoln Park",
      "Side": "North Side",
      "tip": "The Green City Market is only open on Wednesdays and Saturdays. Renée recommends taking your food to the lake for a picnic.",
      "link": "https://www.greencitymarket.org/calendar/index.asp?typeId=14",
      "address": "1817 N Clark St, Chicago, IL 60614",
      "Latitude": 41.9153611,
      "Longitude": -87.633542,
      "tags": [
        "lakefront",
        "outdoor",
        "local business",
        "food",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 205,
      "name": "Kathy B",
      "type": "feeling",
      "adj": " spiritual ",
      "verb": "view the beautiful restoration (based on the original Book of Kells)",
      "place": "Old St. Patrick's Church",
      "Side": "Downtown",
      "tip": "The Book of Kells is a lavishly decorated manuscript of the four gospels of the New Testament.",
      "link": "https://www.oldstpats.org/",
      "address": "700 West Adams",
      "Latitude": 41.8794549,
      "Longitude": -87.6442564,
      "tags": [
        "learn something new",
        "indoor",
        "Downtown"
      ]
    },
    {
      "id": 206,
      "name": "Lisa Marie",
      "type": "description",
      "adj": " a sunny Day ",
      "verb": "be on the patio",
      "place": "Cleo's Pub",
      "Side": "West Side",
      "tip": "WBEZ digital producer Paula Friedrich is a big fan of the veggie burger.",
      "link": "http://www.cleospub.com/",
      "address": "1935 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8957288,
      "Longitude": -87.6759761,
      "tags": [
        "evening",
        "drinking",
        "outdoor",
        "midday",
        "local business",
        "food",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 207,
      "name": "Bill Savage",
      "person_title": "Chicago writer",
      "type": "description",
      "adj": " a scorching day ",
      "verb": "chill out on a scorching day",
      "place": "the Blue Island Beer Company in Blue Island",
      "Side": "Suburbs",
      "link": "http://blueislandbeerco.com/",
      "tags": [
        "drinking",
        "relaxing",
        "local business",
        "cool off",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 208,
      "type": "time",
      "adj": " nighttime ",
      "verb": "take a nighttime bike ride (with a helmet and light of course!) and see Chicago in a different way",
      "place": "one of the city's many bike paths or lanes",
      "link": "https://www.google.com/maps/d/u/0/viewer?mid=1YrwNbsVfyKl_HQiJUGVvvDMK4do&ll=41.85611653628653%2C-87.64801869030765&z=10",
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "kid friendly",
        "lakefront",
        "evening"
      ]
    },
    {
      "id": 209,
      "name": "K. Garcia",
      "type": "description",
      "adj": " a hot sunny day ",
      "verb": "have a frozen margarita on the patio",
      "place": "Tecalitlan restaurant",
      "Side": "West Side",
      "link": "https://www.facebook.com/tecchicago/",
      "address": "1814 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8962465,
      "Longitude": -87.6729274,
      "tags": [
        "drinking",
        "cool off",
        "outdoor",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 210,
      "name": "Helen Muhisani",
      "type": "time",
      "adj": " Fridayevening ",
      "verb": "check out vendors and entertainment on Fridays",
      "place": "Bronzeville Summer Nights",
      "Side": "South Side",
      "address": "Bronzeville, Chicago",
      "Latitude": 41.8166444,
      "Longitude": -87.6167744,
      "tags": [
        "evening",
        "kid friendly",
        "local business",
        "indoor",
        "outdoor",
        "wandering",
        "free",
        "South Side"
      ]
    },
    {
      "id": 211,
      "name": "Amanda",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "ride the swan boats",
      "place": "Humboldt Park",
      "Side": "West Side",
      "tip": "Amanda recommends having some streetcart elotes or raspas from one of the many vendors.",
      "link": "https://wheelfunrentals.com/il/chicago/humboldt-park/rentals/#rentalProduct_1490",
      "address": "1440 N. Humboldt Boulevard",
      "Latitude": 41.907065,
      "Longitude": -87.7030079,
      "tags": [
        "evening",
        "outdoor",
        "kid friendly",
        "active",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 212,
      "type": "feeling",
      "adj": " Adventurous ",
      "verb": "explore historic architecture",
      "place": "the Frank Lloyd Wright tour in Oak Park",
      "Side": "Suburbs",
      "link": "https://flwright.org/visit/homeandstudio",
      "tags": [
        "learn something new",
        "indoor",
        "midday",
        "kid friendly",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 213,
      "name": "Jake Armstrong ",
      "type": "time",
      "adj": " an outside kind of day ",
      "verb": "enjoy frituras",
      "place": "Las Delicias De Puerto Rico",
      "Side": "West Side",
      "link": "https://www.facebook.com/LasDeliciasDePuertoRrico/?rf=204431959690243",
      "address": "4821 W Armitage Ave, Chicago, IL 60639",
      "Latitude": 41.9167271,
      "Longitude": -87.747074,
      "tags": [
        "indoor",
        "food",
        "kid friendly",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 214,
      "name": "Monica Eng",
      "person_title": "WBEZ reporter",
      "type": "time",
      "adj": " 9 a.m. and you have time for a leisurely breakfast ",
      "verb": "try the komplet lepinja",
      "place": "Astoria Bakery and Cafe",
      "Side": "North Side",
      "tip": "Monica says: \"This mom and daughter operation serves regional Serbian specialties you won't find anywhere else in town in a cheerful sunny dining room. Komplet lepinja is a freshly baked loaf of crusty bread filled with egg, Serbian cheese and pork juice. They also serve the most delicious cheese burek (flaky savory pastry) that I've tasted in this city. Because it's a small family operation, call first to make sure they're open and they haven't run out of these specialties. ",
      "link": "https://www.facebook.com/AstoriaChicago/",
      "address": "2954 W Irving Park Rd, Chicago, IL 60618",
      "Latitude": 41.954162,
      "Longitude": -87.7027108,
      "tags": [
        "local business",
        "food",
        "indoor",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 215,
      "name": "Bob Shell",
      "type": "time",
      "adj": " Saturday night ",
      "verb": "play songs on the magical, patron-curated jukebox",
      "place": "Sovereign Liquors",
      "Side": "North Side",
      "link": "https://www.facebook.com/SovereignLiquors/?rf=119189981465387",
      "address": "Chicago, IL 60626",
      "Latitude": 42.0099321,
      "Longitude": -87.663045,
      "tags": [
        "music",
        "evening",
        "indoor",
        "drinking",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 216,
      "name": "Jennifer Kilgore",
      "type": "description",
      "adj": " an overcast day ",
      "verb": "browse for a new book, movie or record",
      "place": "Bucket O'Blood Books and Records",
      "Side": "North Side",
      "link": "http://www.bucketoblood.com/index/index.html",
      "address": "3182 N Elston Ave, Chicago, IL 60618",
      "Latitude": 41.9390017,
      "Longitude": -87.6981315,
      "tags": [
        "wandering",
        "books",
        "local business",
        "kid friendly",
        "indoor",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 217,
      "name": "Marquita Wiggins",
      "person_title": "WBEZ event marketing and audience engagement manager",
      "type": "time",
      "adj": " 8pm ",
      "verb": "play ping-pong",
      "place": "SPIN Chicago",
      "Side": "Downtown",
      "link": "https://wearespin.com/location/chicago/",
      "address": "344 N State St",
      "Latitude": 41.8886647,
      "Longitude": -87.6287233,
      "tags": [
        "indoor",
        "fun and games",
        "midday",
        "evening",
        "active",
        "Downtown"
      ]
    },
    {
      "id": 218,
      "name": "Cassidy Lacy",
      "type": "time",
      "adj": " 4-6pm ",
      "verb": "eat half-priced oysters from 4 to 6 p.m.",
      "place": "Shaw's Crab House",
      "Side": "Downtown",
      "link": "http://shawscrabhouse.com/",
      "address": "21 E Hubbard St, Chicago, IL 60611",
      "Latitude": 41.8899505,
      "Longitude": -87.6271084,
      "tags": [
        "food",
        "local business",
        "indoor",
        "good for groups",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 219,
      "name": "Janaya Greene",
      "type": "description",
      "adj": " an uneventful day ",
      "verb": "skate",
      "place": "Dr. Martin Luther King Jr. Roller Skating and Bowling Center",
      "Side": "South Side",
      "link": "http://www.unitedskates.com/public/chicago/index.cfm",
      "address": "1219 W 76th St, Chicago, IL 60620",
      "Latitude": 41.7556788,
      "Longitude": -87.6544907,
      "tags": [
        "active",
        "indoor",
        "kid friendly",
        "good for groups",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 220,
      "name": "Amanda Berrios",
      "type": "time",
      "adj": " Happy Hour ",
      "verb": "enjoy stunning views while sipping wine",
      "place": "City Winery along the Chicago Riverwalk",
      "Side": "Downtown",
      "link": "https://citywinery.com/chicago/riverwalk/",
      "address": "11 W. Riverwalk South, Chicago, IL 60601",
      "Latitude": 41.8870255,
      "Longitude": -87.6287515,
      "tags": [
        "evening",
        "good views",
        "drinking",
        "outdoor",
        "midday",
        "feeling fancy",
        "Downtown"
      ]
    },
    {
      "id": 221,
      "name": "Miles Kampf-Lassin",
      "type": "description",
      "adj": " a hot day ",
      "verb": "go down the free water slide",
      "place": "the Humboldt Park public pool",
      "Side": "West Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/humboldt-park-pool",
      "address": "958 N Sacramento Ave, Chicago, IL 60622",
      "Latitude": 41.898772,
      "Longitude": -87.7036988,
      "tags": [
        "free",
        "kid friendly",
        "active",
        "cool off",
        "outdoor",
        "midday",
        "morning",
        "West Side"
      ]
    },
    {
      "id": 222,
      "name": "Ed Bannon",
      "type": "feeling",
      "adj": " lonely ",
      "verb": "organize a game night in the back room",
      "place": "Dunning Pour House",
      "Side": "North Side",
      "link": "http://dunningpourhouse.com/",
      "address": "7718 W Addison St",
      "Latitude": 41.9455055,
      "Longitude": -87.820452,
      "tags": [
        "fun and games",
        "drinking",
        "good for groups",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 223,
      "name": "Heather S",
      "type": "feeling",
      "adj": " tired of your near-constant Netflix binge ",
      "verb": "walk along The 606 and stop for pizza and nostalgia",
      "place": "The StopAlong",
      "Side": "North Side",
      "link": "https://www.thestopalong.com/",
      "address": "1812 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9143347,
      "Longitude": -87.6838196,
      "tags": [
        "active",
        "food",
        "kid friendly",
        "outdoor",
        "local business",
        "midday",
        "evening",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 224,
      "name": "Amy VanStee",
      "type": "feeling",
      "adj": " curious ",
      "verb": "explore",
      "place": "the Broadway Antique Market",
      "Side": "North Side",
      "link": "http://bamchicago.com/",
      "address": "6130 N Broadway, Chicago, IL 60660",
      "Latitude": 41.993289,
      "Longitude": -87.660763,
      "tags": [
        "local business",
        "wandering",
        "indoor",
        "midday",
        "relaxing",
        "North Side"
      ]
    },
    {
      "id": 225,
      "name": "Erin McDuffie",
      "type": "time",
      "adj": " 7pm ",
      "verb": "get a waffle cone with the family",
      "place": "the Original Rainbow Cone",
      "Side": "South Side",
      "link": "https://www.rainbowcone.com/",
      "address": "9233 S Western Ave",
      "Latitude": 41.7254691,
      "Longitude": -87.6819396,
      "tags": [
        "ice cream",
        "local business",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "good for groups",
        "cool off",
        "South Side"
      ]
    },
    {
      "id": 226,
      "name": "Sterling Haukom Anderson",
      "type": "description",
      "adj": " a cool day ",
      "verb": "read a book",
      "place": "Northtown Library",
      "Side": "North Side",
      "link": "https://www.chipublib.org/locations/56/",
      "address": "6800 N Western Ave, Chicago, IL 60645",
      "Latitude": 42.0053008,
      "Longitude": -87.6903827,
      "tags": [
        "books",
        "free",
        "indoor",
        "kid friendly",
        "midday",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 227,
      "name": "Emily Graslie",
      "person_title": "host of the Field Museum's <em>Brain Scoop</em>",
      "type": "description",
      "adj": " a cold day ",
      "verb": "take a selfie with Máximo the Titanosaur",
      "place": "the Field Museum",
      "Side": "Downtown",
      "tip": "Admission is free for Illinois residents on certain days.",
      "link": "https://www.fieldmuseum.org/exhibitions/maximo-titanosaur",
      "address": "1400 S Lake Shore Dr, Chicago, IL 60605",
      "Latitude": 41.8661733,
      "Longitude": -87.6169862,
      "tags": [
        "indoor",
        "kid friendly",
        "midday",
        "morning",
        "Downtown"
      ]
    },
    {
      "id": 228,
      "name": "Yamani Hernandez",
      "type": "description",
      "adj": " a hungry day ",
      "verb": "get truffles ",
      "place": "Chocolat Uzma",
      "Side": "South Side",
      "link": "https://www.facebook.com/Chocolatuzma/",
      "address": "1900 S Halsted St, Chicago, IL 60608",
      "Latitude": 41.8565935,
      "Longitude": -87.6468392,
      "tags": [
        "local business",
        "indoor",
        "midday",
        "evening",
        "food",
        "South Side"
      ]
    },
    {
      "id": 229,
      "name": "Bill Savage",
      "person_title": "Chicago author",
      "type": "time",
      "adj": " noon ",
      "verb": "get a great hot dog or the \"mother-in-law\"",
      "place": "Johnny O's",
      "Side": "South Side",
      "tip": "The \"mother-in-law\" is a tamale on a hot dog bun, covered in chili, onions, tomatoes and sport peppers.",
      "link": "http://www.johnnyoshotdogs.com/",
      "address": "3465 S Morgan St, Chicago, IL 60608",
      "Latitude": 41.8308377,
      "Longitude": -87.6507333,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 230,
      "name": "Amanda Stryker",
      "type": "feeling",
      "adj": " under the weather in Chicago, You should eat the matzo ball soup at Steingold's Deli. You're feeling cooped up ",
      "verb": "eat matzo ball soup",
      "place": "Steingold's of Chicago",
      "Side": "North Side",
      "link": "https://www.steingoldsdeli.com/",
      "address": "1840 W Irving Park Rd",
      "Latitude": 41.9544136,
      "Longitude": -87.67574,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 231,
      "name": "Dick Durbin",
      "person_title": "U.S. senator",
      "type": "description",
      "adj": " a perfect baseball day ",
      "verb": "park your bike at the free bike valet near Wrigley Field",
      "place": "the Addison L stop",
      "Side": "North Side",
      "link": "https://www.mlb.com/cubs/ballpark/transportation/bike-riders",
      "address": "1060 W Addison St, Chicago, IL 60613",
      "Latitude": 41.9474473,
      "Longitude": -87.6560538,
      "tags": [
        "outdoor",
        "biking",
        "kid friendly",
        "active",
        "midday",
        "evening",
        "free",
        "North Side"
      ]
    },
    {
      "id": 232,
      "name": "Regina Buccola",
      "type": "time",
      "adj": " 2:30 am ",
      "verb": "hit the dance floor",
      "place": "Late Bar",
      "Side": "North Side",
      "link": "https://latebarchicago.com/",
      "address": "3534 W Belmont Ave, Chicago, IL 60618",
      "Latitude": 41.9394218,
      "Longitude": -87.7163188,
      "tags": [
        "dancing",
        "evening",
        "local business",
        "active",
        "North Side"
      ]
    },
    {
      "id": 233,
      "name": "Melissa Marrero",
      "type": "time",
      "adj": " Monday ",
      "verb": "go for 25 cent wings and watch a baseball game on Monday nights",
      "place": "Wild Goose Bar and Grill ",
      "Side": "North Side",
      "link": "https://www.wildgoosebar.com/",
      "address": "4265 N Lincoln Ave, Chicago, IL 60618",
      "Latitude": 41.9594548,
      "Longitude": -87.6821821,
      "tags": [
        "food",
        "fun and games",
        "indoor",
        "evening",
        "midday",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 234,
      "name": "Melanie Munsey ",
      "type": "description",
      "adj": " snowy ",
      "verb": "enjoy beer flights and games",
      "place": "Great Central Brewing Company",
      "Side": "West Side",
      "link": "http://www.greatcentralbrewing.com/",
      "address": "221 N Wood St",
      "Latitude": 41.885839,
      "Longitude": -87.6714956,
      "tags": [
        "drinking",
        "indoor",
        "fun and games",
        "local business",
        "good for groups",
        "evening",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 235,
      "name": "Drew Schmedding",
      "type": "feeling",
      "adj": " exhausted ",
      "verb": "have high tea and a spa day",
      "place": "The Langham Hotel",
      "Side": "Downtown",
      "link": "http://www.langhamhotels.com/en/the-langham/chicago/dining/afternoon-tea-with-wedgwood/",
      "address": "330 N Wabash Ave",
      "Latitude": 41.8886304,
      "Longitude": -87.6274989,
      "tags": [
        " relaxing",
        "indoor",
        "feeling fancy",
        "midday",
        "good for groups",
        "Downtown"
      ]
    },
    {
      "id": 236,
      "name": "Zeeshan Shah",
      "person_title": "chef at Superkahna International",
      "type": "feeling",
      "adj": " \"screened in\" by all your electronics in Chicago. You should turn off your phone and explore at the Comfort Station",
      "verb": "turn off your phone and explore",
      "place": "the Comfort Station",
      "Side": "North Side",
      "tip": "The Comfort Station is a community arts and performance space.",
      "link": "https://comfortstationlogansquare.org/",
      "address": "2579 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9285748,
      "Longitude": -87.7063204,
      "tags": [
        "wandering",
        "local business",
        "learn something new",
        "midday",
        "free",
        "North Side"
      ]
    },
    {
      "id": 237,
      "name": "Maureen Keane",
      "type": "description",
      "adj": " a stressful day ",
      "verb": "explore your artistic side by taking a drop-in class",
      "place": "ArtReach Chicago",
      "Side": "West Side",
      "link": "https://www.artreachchicago.org/",
      "address": "2651 W Lake St, Chicago, IL 60612",
      "Latitude": 41.88414,
      "Longitude": -87.693306,
      "tags": [
        "creativity",
        "indoor",
        "learn something new",
        "kid friendly",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 238,
      "name": "Sara N",
      "type": "time",
      "adj": " Sunday ",
      "verb": "buy a croissant and veggies on Sundays",
      "place": "the Logan Square farmers market",
      "Side": "North Side",
      "link": "http://logansquarefarmersmarket.org/",
      "address": "2363 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9242452,
      "Longitude": -87.6993324,
      "tags": [
        "outdoor",
        "food",
        "local business",
        "morning",
        "midday",
        "kid friendly",
        "North Side"
      ]
    },
    {
      "id": 239,
      "name": "Mara Jacobucci",
      "type": "feeling",
      "adj": " like you'll never get a table at Antique Taco ",
      "verb": "skip the wait of the Wicker Park location",
      "place": "Antique Taco in Bridgeport",
      "Side": "South Side",
      "link": "http://www.antiquetaco.com/",
      "address": "1000 W 35th St, Chicago, IL 60609",
      "Latitude": 41.8309047,
      "Longitude": -87.6512472,
      "tags": [
        "food",
        "indoor",
        "midday",
        "evening",
        "local business",
        "South Side"
      ]
    },
    {
      "id": 240,
      "name": "Paula Friedrich",
      "person_title": "WBEZ digital producer",
      "type": "time",
      "adj": "sunset",
      "verb": "admire the skyline at dusk",
      "place": "the North Avenue Bridge",
      "Side": "North Side",
      "tip": "Paula says: This is one of the best views of the city!",
      "Latitude": 41.54392,
      "Longitude": -87.39234,
      "tags": [
        "outdoor",
        "free",
        "relaxing",
        "good views",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 241,
      "name": "Tyler",
      "type": "description",
      "adj": " a warm and breezy day ",
      "verb": "enjoy time by yourself",
      "place": "the Baha'i House of Worship in Wilmette",
      "Side": "Suburbs",
      "link": "https://www.bahai.us/bahai-temple/",
      "tags": [
        "outdoor",
        "relaxing",
        "learn something new",
        "midday",
        "morning",
        "Suburbs"
      ]
    },
    {
      "id": 242,
      "name": "Sara Corley",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "grab some produce on Saturdays",
      "place": "the 61st Street Farmers Market",
      "Side": "South Side",
      "link": "https://experimentalstation.org/market",
      "address": "6100 S Blackstone Ave, Chicago, IL 60637",
      "Latitude": 41.7840796,
      "Longitude": -87.5905906,
      "tags": [
        "outdoor",
        "local business",
        "food",
        "relaxing",
        "morning",
        "midday",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 243,
      "name": "Exavier Pope",
      "person_title": "Chicago journalist",
      "type": "time",
      "adj": " Friday evening ",
      "verb": "find a lowkey-but-turnt cocktail bar",
      "place": "Moneygun",
      "Side": "West Side",
      "tip": "Exavier recommends this place for its hidden entrance and dope hip-hop and trap music.",
      "link": "https://www.moneygunchicago.com/",
      "address": "660 W Lake St, Chicago, IL 60661",
      "Latitude": 41.8858299,
      "Longitude": -87.6451549,
      "tags": [
        "local business",
        "food",
        "indoor",
        "drinking",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 244,
      "name": "Renuka Sharma",
      "type": "time",
      "adj": " Sunday night ",
      "verb": "enjoy a vegetarian feast on Sunday nights",
      "place": "ISKCON CHICAGO",
      "Side": "North Side",
      "link": "http://iskconchicago.com/sunday-feast/",
      "address": "1716 W Lunt Ave, Chicago, IL 60626",
      "Latitude": 42.0093219,
      "Longitude": -87.6730229,
      "tags": [
        "indoor",
        "food",
        "local business",
        "free",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 245,
      "name": "Rebecca Makkai",
      "person_title": "Author, <em>The Great Believers</em>",
      "type": "feeling",
      "adj": " uncultured ",
      "verb": "grab some dinner",
      "place": "Jin Ju Restaurant",
      "Side": "North Side",
      "tip": "Rebecca recommends heading to a reading at Women and Children First after dinner. ",
      "link": "https://www.jinjurestaurant.com/",
      "address": "5203 N Clark St, Chicago, IL 60640",
      "Latitude": 41.9763591,
      "Longitude": -87.6682269,
      "tags": [
        "food",
        "local business",
        "indoor",
        "evening",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 246,
      "name": "Raul Rosas",
      "type": "description",
      "adj": " a margarita kind of day ",
      "verb": "grab a pepino margarita - double -",
      "place": "Del Toro",
      "Side": "South Side",
      "link": "http://deltorochicago.com/",
      "address": "2133 S Halsted St, Chicago, IL 60608",
      "Latitude": 41.8532112,
      "Longitude": -87.6462706,
      "tags": [
        "drinking",
        "indoor",
        "cool off",
        "local business",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 247,
      "name": "Evan Moore",
      "person_title": "<em>Chicago Sun-Times</em> journalist",
      "type": "feeling",
      "adj": "hungry",
      "verb": "eat",
      "place": "Jerk Taco Man",
      "Side": "South Side",
      "link": "https://www.jerktacoman.com/",
      "address": "7723 S State St, Chicago, IL 60619",
      "Latitude": 41.7538568,
      "Longitude": -87.6243889,
      "tags": [
        "local business",
        "food",
        "indoor",
        "midday",
        "evening",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 248,
      "name": "Danielle Littman",
      "type": "time",
      "adj": "It's earlymorning",
      "verb": "take a sunrise walk",
      "place": "the lakefront",
      "tags": [
        "lakefront",
        "outdoor",
        "morning",
        "good views",
        "free",
        "active",
        "kid friendly",
        "good for groups"
      ]
    },
    {
      "id": 249,
      "name": "Miles Kampf-Lassin",
      "type": "time",
      "adj": " Wednesday ",
      "verb": "see Wednesday night live jazz",
      "place": "Skylark",
      "Side": "South Side",
      "link": "http://www.skylarkchicago.com/",
      "address": "2149 S Halsted St, Chicago, IL 60608",
      "Latitude": 41.8527754,
      "Longitude": -87.6462829,
      "tags": [
        "music",
        "indoor",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 250,
      "name": "Priya Ghosh",
      "type": "feeling",
      "adj": " cold - like, really cold - ",
      "verb": "go soak ",
      "place": "King Spa and Sauna in Niles",
      "Side": "Suburbs",
      "tags": [
        "indoor",
        "relaxing",
        "midday",
        "morning",
        "evening",
        "Suburbs"
      ]
    },
    {
      "id": 251,
      "name": "Jim DeRogatis",
      "person_title": "author and <em>Sound Opinions</em> Host",
      "type": "description",
      "adj": " a summer day ",
      "verb": "fire up your grill with goods you picked up",
      "place": "Paulina Meat Market",
      "Side": "North Side",
      "link": "https://www.paulinamarket.com/",
      "address": "3501 N Lincoln Ave, Chicago, IL 60657",
      "Latitude": 41.9453314,
      "Longitude": -87.6722143,
      "tags": [
        "food",
        "local business",
        "midday",
        "outdoor",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 252,
      "type": "description",
      "adj": " a rainy day ",
      "verb": "read half of a book on a rainy day",
      "place": "The Armadillo's Pillow",
      "Side": "North Side",
      "tip": "One anonymous tipster says: \"Preferably, the book you read half of the last time it rained.\"",
      "link": "https://www.facebook.com/pages/category/Bookstore/The-Armadillos-Pillow-505183192975828/",
      "address": "6753 N Sheridan Rd, Chicago, IL 60626",
      "Latitude": 42.0050942,
      "Longitude": -87.6605817,
      "tags": [
        "books",
        "indoor",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 253,
      "name": "Sheenal Patel",
      "type": "description",
      "adj": " a Tuesday morning ",
      "verb": "have breakfast ",
      "place": "The Hoxton",
      "Side": "West Side",
      "link": "https://thehoxton.com/illinois/chicago/hotels",
      "address": "200 N Green St, Chicago, IL 60607",
      "Latitude": 41.8859755,
      "Longitude": -87.6487272,
      "tags": [
        "morning",
        "feeling fancy",
        "food",
        "morning",
        "West Side"
      ]
    },
    {
      "id": 254,
      "name": "Alexa L Schutz",
      "type": "feeling",
      "adj": " a light breakfast or snack  ",
      "verb": "grab pie and Metropolis coffee ",
      "place": "Hoosier Mama Pie Company",
      "Side": "West Side",
      "link": "http://www.hoosiermamapie.com/",
      "address": "1618 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8962535,
      "Longitude": -87.6681101,
      "tags": [
        "food",
        "local business",
        "indoor",
        "kid friendly",
        "midday",
        "morning",
        "West Side"
      ]
    },
    {
      "id": 255,
      "name": "Zach Roombos",
      "type": "description",
      "adj": " a Hot day ",
      "verb": "get an iced treat",
      "place": "Miko's Italian Ice",
      "Side": "North Side",
      "link": "https://www.mikositalianice.com/",
      "address": "2236 N Sacramento Ave, Chicago, IL 60647",
      "Latitude": 41.9226324,
      "Longitude": -87.7024177,
      "tags": [
        "ice cream",
        "cool off",
        "food",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 256,
      "name": "Emily Minehart",
      "type": "feeling",
      "adj": " hungry for breakfast ",
      "verb": "eat biscuits",
      "place": "Daley’s Restaurant",
      "Side": "South Side",
      "link": "https://www.daleysrestaurant.com/",
      "address": "6257 S Cottage Grove Ave, Chicago, IL 60637",
      "Latitude": 41.78078,
      "Longitude": -87.6059279,
      "tags": [
        "food",
        "local business",
        "indoor",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 257,
      "name": "Seamus Doheny",
      "person_title": "Vocalo producer",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "browse the zines",
      "place": "Quimby's Bookstore",
      "Side": "North Side",
      "link": "https://www.quimbys.com/",
      "address": "1854 W North Ave, Chicago, IL 60622",
      "Latitude": 41.9107652,
      "Longitude": -87.6747638,
      "tags": [
        "wandering",
        "midday",
        "books",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 258,
      "name": "Bryan Berend",
      "type": "feeling",
      "adj": " like you want some time on a stage ",
      "verb": "sign up for open mic comedy",
      "place": "Cole's Bar",
      "Side": "North Side",
      "link": "https://www.colesbarchicago.com/calendar/2018/9/28/melo-makes-music-marcus-atom-natalie-grace-alford-by7l2-b78kd-2y7we-shlkb-t2dwc-bg4w3-3tztx-z2tw2",
      "address": "2338 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.92366,
      "Longitude": -87.6988111,
      "tags": [
        "free",
        "indoor",
        "evening",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 259,
      "name": "Eden Sabala",
      "type": "feeling",
      "adj": "outdoorsy ",
      "verb": "enjoy a nice summer breeze with a walk along the northern shore of Lake Michigan",
      "place": "Illinois Beach State Park in Zion",
      "Side": "Suburbs",
      "link": "https://www.dnr.illinois.gov/Parks/Pages/AdelineJayGeo-KarisIllinoisBeach.aspx",
      "tags": [
        "outdoor",
        "lakefront",
        "relaxing",
        "good for groups",
        "morning",
        "midday",
        "evening",
        "Suburbs"
      ]
    },
    {
      "id": 260,
      "name": "Steve Johnson",
      "person_title": "<em>Chicago Tribune</em> culture writer",
      "type": "time",
      "adj": " sunny ",
      "verb": "ride a bike to Evanston, starting",
      "place": "Soldier Field",
      "Side": "Downtown",
      "address": "410 Museum Campus Dr, Chicago, IL 60605",
      "Latitude": 41.8660614,
      "Longitude": -87.6141925,
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "kid friendly",
        "lakefront",
        "Downtown"
      ]
    },
    {
      "id": 261,
      "name": "Justinne Ignacio",
      "type": "time",
      "adj": " 2 p.m. ",
      "verb": "watch the butterfly release",
      "place": "the Peggy Notebaert Nature Museum",
      "Side": "North Side",
      "tip": "Butterflies that have just emerged from their chrysalis are released every day at 2 p.m.",
      "link": "http://www.naturemuseum.org/the-museum/exhibits/butterfly-haven",
      "address": "2430 N Cannon Dr, Chicago, IL 60614",
      "Latitude": 41.9266509,
      "Longitude": -87.6352571,
      "tags": [
        "kid friendly",
        "indoor",
        "animals",
        "nature",
        "North Side"
      ]
    },
    {
      "id": 262,
      "type": "time",
      "adj": " a beautiful Sunday ",
      "verb": "play catch",
      "place": "Jefferson Memorial Park",
      "Side": "North Side",
      "tip": "One anonymous tipster also suggests checking out the Jefferson Park Sunday Market.",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/jefferson-thomas-memorial-park",
      "address": "4822 N Long Ave, Chicago, IL 60630",
      "Latitude": 41.9686194,
      "Longitude": -87.7629182,
      "tags": [
        "kid friendly",
        "outdoor",
        "free",
        "active",
        "good for groups",
        "midday",
        "morning",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 263,
      "name": "Lib",
      "type": "time",
      "adj": " late ",
      "verb": "drink a beer and eat a slice (or three)",
      "place": "Dante's Tavern ",
      "Side": "North Side",
      "link": "https://www.danteschicago.com/",
      "address": " 3028 W Armitage Ave, Chicago, IL 60647",
      "Latitude": 41.9175945,
      "Longitude": -87.7036558,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 264,
      "name": "Lindsay Garrett",
      "type": "time",
      "adj": " 8pm ",
      "verb": "get an awesome view of the city",
      "place": "the Willis Tower Skydeck",
      "Side": "Downtown",
      "link": "https://theskydeck.com/",
      "address": "233 S Wacker Dr, Chicago, IL 60606",
      "Latitude": 41.878877,
      "Longitude": -87.6357573,
      "tags": [
        "good views",
        "indoor",
        "midday",
        "kid friendly",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 265,
      "type": "time",
      "adj": " patio weather ",
      "verb": "have a slice of raspberry marzipan cake",
      "place": "Cafe Selmarie",
      "Side": "North Side",
      "link": "http://cafeselmarie.com/",
      "address": "4729 N Lincoln Ave",
      "Latitude": 41.9674389,
      "Longitude": -87.6875034,
      "tags": [
        "local business",
        "indoor",
        "midday",
        "food",
        "evening",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 266,
      "name": "Hannah ",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "spend $5 and take a tour",
      "place": "the Ukrainian National Museum",
      "Side": "West Side",
      "tip": "Hannah says: \"It's the most well-curated [Museum] in America.\"",
      "link": "http://ukrainiannationalmuseum.org/",
      "address": "2249 W Superior St",
      "Latitude": 41.894571,
      "Longitude": -87.684031,
      "tags": [
        "learn something new",
        "indoor",
        "learn something new",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 267,
      "name": "Amy Lecza",
      "type": "feeling",
      "adj": " tired of all your usual spots ",
      "verb": "explore the shelves",
      "place": "Seminary Co-op Bookstore",
      "Side": "South Side",
      "tip": "Amy also recommends strolling past the Obamas' house while you are in the neighborhood.",
      "link": "https://www.semcoop.com/",
      "address": "5751 S Woodlawn Ave, Chicago, IL 60637",
      "Latitude": 41.7947665,
      "Longitude": -87.5916753,
      "tags": [
        "books",
        "wandering",
        "indoor",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 268,
      "name": "Betsy Rubin",
      "type": "feeling",
      "adj": " out of sorts ",
      "verb": "enjoy food and cocktails in the elegant-yet-cozy Mesler Kitchen/Bar/Lounge ",
      "place": "the Sophy Hotel",
      "Side": "South Side",
      "tip": "Betsy says: \"The bar has a pretty fireplace and the dining room has a Chicago literary theme!\"",
      "link": "https://sophyhotel.com/",
      "address": "1411 E 53rd St, Chicago, IL 60615",
      "Latitude": 41.7992822,
      "Longitude": -87.5915562,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "feeling fancy",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 269,
      "name": "Kate",
      "type": "description",
      "adj": " a Go-Cubs-Go kind of day ",
      "verb": "grab your friends and take a self-guided brew tour",
      "place": "Ashland and Lake",
      "Side": "West Side",
      "address": "1601 W. Lake St., Chicago, IL 60612",
      "Latitude": 41.8853231,
      "Longitude": -87.6669371,
      "tags": [
        "midday",
        "active",
        "evening",
        "drinking",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 270,
      "name": "Samantha Irby",
      "person_title": "author/comedian",
      "type": "description",
      "adj": " a hot day in EVANSTON which is basically ",
      "verb": "shut up and watch movies all day in the air conditioning",
      "place": "the Century 12 movie theater in Evanston",
      "Side": "Suburbs",
      "link": "https://www.cinemark.com/illinois/century-12-evanston-cinearts-6-and-xd",
      "tags": [
        "cool off",
        "indoor",
        "midday",
        "evening",
        "morning",
        "Suburbs"
      ]
    },
    {
      "id": 271,
      "name": "Miles Kampf-Lassin",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "get a \"gym shoe\" sandwich",
      "place": "Stony Sub",
      "Side": "South Side",
      "link": "https://www.facebook.com/pages/Stony-Sub/120761597939635",
      "address": "8440 S Stony Island Ave",
      "Latitude": 41.7411863,
      "Longitude": -87.5859411,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 272,
      "name": "Al Keefe",
      "person_title": "WBEZ editor",
      "adj": "warm, but not hot",
      "verb": "go to eat brats and drink beer",
      "place": "Gene's Sausage Shop & Delicatessen",
      "Side": "North Side",
      "tip": "Al says: They have a rooftop bar/hangout area that's only open for the warm months.",
      "address": "4750 N Lincoln Ave, Chicago, IL 60625",
      "Latitude": 41.9677651,
      "Longitude": -87.6883507,
      "tags": [
        "food",
        "midday",
        "evening",
        "food",
        "relaxing",
        "local business",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 273,
      "name": "Meghan",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "get a bacon date and goat cheese empanada ",
      "place": "wherever the 5411 Empanadas food truck is parked",
      "link": "http://5411empanadas.com/thetruck",
      "tags": [
        "outdoor",
        "food",
        "wandering",
        "good for groups"
      ]
    },
    {
      "id": 274,
      "name": "Maureen Keane",
      "type": "time",
      "adj": " Friday afternoon ",
      "verb": "grab some of the best smoked seafood in Illinois",
      "place": "Calumet Fisheries",
      "Side": "South Side",
      "tip": "An anonymous tipster suggests getting the fried oysters and eating them in nearby Calumet Park. ",
      "link": "http://www.calumetfisheries.com/",
      "address": "3259 E 95th St, Chicago, IL 60617",
      "Latitude": 41.7226511,
      "Longitude": -87.5439701,
      "tags": [
        "outdoor",
        "food",
        "local business",
        "midday",
        "evening",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 275,
      "name": "Brian Gee",
      "type": "time",
      "adj": " Saturday night at 10:30 ",
      "verb": "see Chicago's best drag show, Drag Matinee, on a Saturday night",
      "place": "Berlin Nightclub",
      "Side": "North Side",
      "link": "https://www.berlinchicago.com/index.html",
      "address": "954 W Belmont Ave, Chicago, IL 60657",
      "Latitude": 41.9400986,
      "Longitude": -87.653701,
      "tags": [
        "local business",
        "indoor",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 276,
      "name": "Karen Trine",
      "type": "description",
      "adj": " nice ",
      "verb": "get off the water taxi",
      "place": "Ping Tom Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/tom-ping-memorial-park",
      "address": "1700 S Wentworth Ave, Chicago, IL 60616",
      "Latitude": 41.8591184,
      "Longitude": -87.6325964,
      "tags": [
        "outdoor",
        "kid friendly",
        "midday",
        "wandering",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 277,
      "name": "Jo Segalla ",
      "type": "description",
      "adj": " a perfect day ",
      "verb": "walk around Lincoln Park Zoo and get lunch",
      "place": "Cafe Brauer",
      "Side": "North Side",
      "link": "https://www.lpzoo.org/dining/patio-cafe-brauer",
      "address": "2021 N Stockton Dr",
      "Latitude": 41.9190996,
      "Longitude": -87.6338709,
      "tags": [
        "active",
        "wandering",
        "food",
        "midday",
        "animals",
        "North Side"
      ]
    },
    {
      "id": 278,
      "name": "Nick Reinert ",
      "type": "description",
      "adj": " a fabulous day ",
      "verb": "take some Instagram photos",
      "place": "the wndr museum",
      "Side": "West Side",
      "link": "https://wndrmuseum.com/",
      "address": "1130 W Monroe St, Chicago, IL 60607",
      "Latitude": 41.8805359,
      "Longitude": -87.6558487,
      "tags": [
        "indoor",
        "kid friendly",
        "midday",
        "learn something new",
        "West Side"
      ]
    },
    {
      "id": 279,
      "name": "Yamani Hernandez",
      "type": "feeling",
      "adj": " stressed or under the weather ",
      "verb": "get acupuncture, body work or do yoga",
      "place": "Haji Healing Salon",
      "Side": "South Side",
      "link": "hajihealingsalon.com",
      "address": "746 E 79th St, Chicago, IL 60619",
      "Latitude": 41.7513916,
      "Longitude": -87.6059329,
      "tags": [
        " relaxing",
        "local business",
        "indoor",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 280,
      "name": "Eric Zorn",
      "person_title": "<em>Chicago Tribune</em> columnist",
      "type": "description",
      "adj": " warm but overcast  ",
      "verb": "go on a bike ride",
      "place": "Bunker Hill Forest Preserve",
      "Side": "North Side",
      "link": "http://fpdcc.com/clayton-f-smith-preserves/",
      "address": "W Harts Rd, Chicago, IL 60714",
      "Latitude": 42.010227,
      "Longitude": -87.7951037,
      "tags": [
        "nature",
        "active",
        "outdoor",
        "nature",
        "biking",
        "free",
        "kid friendly",
        "North Side"
      ]
    },
    {
      "id": 281,
      "name": "Ryan Fiebing",
      "type": "time",
      "adj": " 8am ",
      "verb": "get breakfast, sit on the stoop and watch the world go by",
      "place": "Art's Drive In",
      "Side": "North Side",
      "link": "http://artsdrivein.com/",
      "address": "1333 W North Ave, Chicago, IL 60642",
      "Latitude": 41.9104729,
      "Longitude": -87.6616658,
      "tags": [
        "local business",
        "food",
        "outdoor",
        "morning",
        "North Side"
      ]
    },
    {
      "id": 282,
      "name": "Stephanie Izard",
      "person_title": "Iron Chef",
      "type": "time",
      "adj": " early morning ",
      "verb": "break a sweat",
      "place": "Cross Town Fitness - West Loop",
      "Side": "West Side",
      "link": "https://crosstownfitness.com/",
      "address": "1031 W Madison St, Chicago, IL 60607",
      "Latitude": 41.8814112,
      "Longitude": -87.653411,
      "tags": [
        "active",
        "indoor",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 283,
      "name": "Joshua Magno",
      "type": "feeling",
      "adj": " restlessly cold, gay, and lonely ",
      "verb": "get your gay and straight friends and play board games ",
      "place": "Meeting House Tavern",
      "Side": "North Side",
      "link": "http://www.meetinghousetavern.com/about.html",
      "address": "5025 N Clark St, Chicago, IL 60640",
      "Latitude": 41.9732158,
      "Longitude": -87.6678122,
      "tags": [
        "indoor",
        "local business",
        "fun and games",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 284,
      "name": "Neda",
      "type": "feeling",
      "adj": " stressed ",
      "verb": "take a relaxing walk ",
      "place": "Montrose Point Bird Sanctuary",
      "Side": "North Side",
      "link": "https://www.chicago.gov/content/dam/city/depts/zlup/Sustainable_Development/Publications/Chicago_Nature_and_Wildlife_Plan/Lincoln_Park_Montrose_Point_Bird_Sanctuary.pdf",
      "address": "Montrose Point Bird Sanctuary",
      "Latitude": 41.9631998,
      "Longitude": -87.6331366,
      "tags": [
        " relaxing",
        "nature",
        "free",
        "kid friendly",
        "outdoor",
        "active",
        "kid friendly",
        "North Side"
      ]
    },
    {
      "id": 285,
      "name": "Sabrina Miller",
      "type": "feeling",
      "adj": "like somethign sweet",
      "verb": "eat gourmet doughnuts and cakes",
      "place": "Calumet Bakery",
      "Side": "South Side",
      "link": "https://calumetbakery.com/",
      "address": "2510 E 106th St, Chicago, IL 60617",
      "Latitude": 41.702992,
      "Longitude": -87.562652,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "midday",
        "local business",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 286,
      "name": "Eric Zorn",
      "person_title": "<em>Chicago Tribune</em> columnist",
      "type": "feeling",
      "adj": " punchy  ",
      "verb": "go contra dancing on Monday nights",
      "place": "the Irish American Heritage Center",
      "Side": "North Side",
      "link": "http://www.chicagobarndance.org/calendar/",
      "address": "4626 N Knox Ave",
      "Latitude": 41.965278,
      "Longitude": -87.7444982,
      "tags": [
        "dancing",
        "active",
        "indoor",
        "evening",
        "learn something new",
        "free",
        "North Side"
      ]
    },
    {
      "id": 287,
      "name": "Alyssa Edes",
      "person_title": "WBEZ producer",
      "type": "description",
      "adj": " a mild day ",
      "verb": "walk down Devon Avenue and get Indian food",
      "place": "Udupi Palace",
      "Side": "North Side",
      "link": "http://www.udupipalacetogo.com/about.html",
      "address": "1841, 2543 W Devon Ave, Chicago, IL 60659",
      "Latitude": 41.9974238,
      "Longitude": -87.6939926,
      "tags": [
        "midday",
        "wandering",
        "indoor",
        "local business",
        "food",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 288,
      "name": "Chelsea Rump",
      "type": "description",
      "adj": " frigid ",
      "verb": "order a boozy steamer",
      "place": "C.C. Ferns",
      "Side": "West Side",
      "tip": "A \"boozy steamer\" is a coffee-and-spirits drink that comes hot or iced.",
      "link": "http://ccferns.com/",
      "address": "2806 W Augusta Blvd, Chicago, IL 60622",
      "Latitude": 41.8994227,
      "Longitude": -87.6971915,
      "tags": [
        "morning",
        "drinking",
        "indoor",
        "midday",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 289,
      "name": "Eve Robinson",
      "type": "description",
      "adj": " sunny  ",
      "verb": "get ice cream",
      "place": "Sugar Shack",
      "Side": "South Side",
      "link": "https://www.sugarshackon26th.com/menu",
      "address": "630 W 26th St, Chicago, IL 60616",
      "Latitude": 41.8455092,
      "Longitude": -87.6428206,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "cool off",
        "South Side"
      ]
    },
    {
      "id": 290,
      "type": "feeling",
      "adj": " frisky ",
      "verb": "pet rescue cats",
      "place": "The Catcade",
      "Side": "North Side",
      "link": "https://www.thecatcade.org/",
      "address": "1235 W Belmont Ave, Chicago, IL 60657",
      "Latitude": 41.9395625,
      "Longitude": -87.6604641,
      "tags": [
        "indoor",
        "animals",
        "kid friendly",
        "fun and games",
        "midday",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 291,
      "name": "Erika L. Sánchez",
      "person_title": "Chicago author",
      "type": "time",
      "adj": " nighttime ",
      "verb": "take a nighttime bike ride",
      "place": "the lake",
      "tags": [
        "lakefront",
        "outdoor",
        "biking",
        "active",
        "kid friendly",
        "good for groups",
        "evening"
      ]
    },
    {
      "id": 292,
      "name": "Yamani Hernandez",
      "type": "description",
      "adj": " a hungry day ",
      "verb": "eat ",
      "place": "Mary's Taqueria",
      "Side": "South Side",
      "link": "https://www.facebook.com/pages/Marys-Taqueria/437466589626438",
      "address": "1901 S Canalport Ave, Chicago, IL 60616",
      "Latitude": 41.856536,
      "Longitude": -87.6419852,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 293,
      "type": "description",
      "adj": " a warm day ",
      "verb": "get some frozen yogurt",
      "place": "Josi's Frozen Yogurt Cafe",
      "Side": "North Side",
      "link": "https://josisfrozenyogurt.com/",
      "address": "4032 N Milwaukee Ave, Chicago, IL 60641",
      "Latitude": 41.953969,
      "Longitude": -87.74866,
      "tags": [
        "local business",
        "ice cream",
        "kid friendly",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 294,
      "name": "Frank Kryzak",
      "type": "time",
      "adj": "evening ",
      "verb": "brewery hop, starting at Dovetail and ending",
      "place": "Half Acre",
      "Side": "North Side",
      "address": "1800 W Belle Plaine Ave, Chicago, IL 60613",
      "Latitude": 41.9562428,
      "Longitude": -87.674533,
      "tags": [
        "drinking",
        "indoor",
        "outdoor",
        "wandering",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 295,
      "name": "Deborah Mercer",
      "type": "feeling",
      "adj": " in a rut ",
      "verb": "check out the art ",
      "place": "the Intuit art gallery",
      "Side": "West Side",
      "link": "https://www.art.org/",
      "address": "756 N Milwaukee Ave, Chicago, IL 60642",
      "Latitude": 41.8953517,
      "Longitude": -87.6546064,
      "tags": [
        "learn something new",
        "indoor",
        "midday",
        "creativity",
        "West Side"
      ]
    },
    {
      "id": 296,
      "name": "Julian Hayda",
      "person_title": "WBEZ producer",
      "type": "feeling",
      "adj": " like you need a quick vacation ",
      "verb": "take a day trip",
      "place": "Indiana Dunes National Park in Chesterton",
      "Side": "Suburbs",
      "tip": "Julian recommends taking the Metra South Shore Line to get there.",
      "link": "https://www.nps.gov/indu/index.htm",
      "tags": [
        "active",
        "outdoor",
        "kid friendly",
        "nature",
        "lakefront",
        "morning",
        "evening",
        "Suburbs"
      ]
    },
    {
      "id": 297,
      "name": "Tim",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "listen to CHIRP Radio",
      "place": "your nearest city park",
      "tip": "You can hear CHIRP on the North Side at 107.1FM, or listen online anywhere in the world.",
      "link": "https://chirpradio.org/",
      "tags": [
        "music",
        "outdoor",
        "free",
        "evening",
        "midday",
        "morning"
      ]
    },
    {
      "id": 298,
      "name": "A. N. Toonen",
      "type": "description",
      "adj": " a balmy day ",
      "verb": "ride your bike to drink some beers",
      "place": "3 Floyds Brewpub in Munster, Indiana",
      "Side": "Suburbs",
      "tip": "A.N. recommends making a stop at Calumet Fisheries for a little sustenance along the way.",
      "link": "https://www.3floyds.com/brewpub/?age_verification=90950b2c3f",
      "tags": [
        "drinking",
        "food",
        "biking",
        "active",
        "Suburbs"
      ]
    },
    {
      "id": 299,
      "name": "Latrina Robinson",
      "type": "description",
      "adj": " a hot summer day ",
      "verb": "play mini golf",
      "place": "Douglas Park",
      "Side": "West Side",
      "link": "https://chicago.curbed.com/building/12598/douglas-park-mini-golf",
      "address": "1401 S Sacramento Dr, Chicago, IL 60623",
      "Latitude": 41.8635955,
      "Longitude": -87.7004276,
      "tags": [
        "free",
        "kid friendly",
        "outdoor",
        "active",
        "morning",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 300,
      "name": "Heidi Stevens",
      "person_title": "<em>Chicago Tribune</em> columnist",
      "type": "time",
      "adj": " sunrise ",
      "verb": "sit with a cup of coffee (or a mimosa) at sunrise",
      "place": "57th Street Beach",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/57th-street-beach",
      "address": "5700 South Lake Shore Drive \r\nChicago, IL 60611",
      "Latitude": 41.7920438,
      "Longitude": -87.5829263,
      "tags": [
        "outdoor",
        "relaxing",
        "lakefront",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 301,
      "name": "Hannah ",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "take someone on a date",
      "place": "the Chicago Magic Lounge",
      "Side": "North Side",
      "link": "https://www.chicagomagiclounge.com/",
      "address": "5050 N Clark St, Chicago, IL 60640",
      "Latitude": 41.9739244,
      "Longitude": -87.6684896,
      "tags": [
        "indoor",
        "evening",
        "feeling fancy",
        "North Side"
      ]
    },
    {
      "id": 302,
      "name": "Sabrina Miller",
      "type": "feeling",
      "adj": "social",
      "verb": "enjoy house music, day parties and Bears Sundays",
      "place": "The Family Den",
      "Side": "South Side",
      "link": "https://www.facebook.com/FamilyDenLounge/",
      "address": "8942 S Stony Island Ave, Chicago, IL 60617",
      "Latitude": 41.7320304,
      "Longitude": -87.5857978,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "evening",
        "local business",
        "midday",
        "music",
        "South Side"
      ]
    },
    {
      "id": 303,
      "name": "Corinne",
      "type": "description",
      "adj": " a muggy day ",
      "verb": "nosh on a \"peanut butter potato chip\" custard bar",
      "place": "Pretty Cool Ice Cream",
      "Side": "North Side",
      "tip": "Chef Rick Ohlemacher also recommends getting a piecicle here.",
      "link": "https://www.prettycoolicecream.com/new-page-1",
      "address": " 2353 N California Ave, Chicago, IL 60647",
      "Latitude": 41.924345,
      "Longitude": -87.6972579,
      "tags": [
        "ice cream",
        "kid friendly",
        "midday",
        "outdoor",
        "local business",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 304,
      "name": "Lucia Whalen",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "roller skate",
      "place": "Fleetwood Roller Rink in Summit",
      "Side": "South Side",
      "link": "https://fleetwoodrollerrink.com/",
      "tags": [
        "midday",
        "indoor",
        "kid friendly",
        "active",
        "local business",
        "midday",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 305,
      "name": "Erik Benusa",
      "type": "feeling",
      "adj": " lost and afraid ",
      "verb": "hop on the Metra and relax at a concert",
      "place": "Ravinia in Highland Park",
      "Side": "Suburbs",
      "link": "https://www.ravinia.org/",
      "tags": [
        "music",
        "outdoor",
        "relaxing",
        "evening",
        "good for groups",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 306,
      "name": "Rebecca Makkai",
      "person_title": "Author, <em>The Great Believers</em>",
      "type": "description",
      "adj": " Gloomy ",
      "verb": "ride the elevator to the 10th floor and walk down, eavesdropping on the music lessons",
      "place": "the Fine Arts Building",
      "Side": "Downtown",
      "link": "https://fineartsbuildingstudios.com/",
      "address": "410 S Michigan Ave, Chicago, IL 60605",
      "Latitude": 41.8764761,
      "Longitude": -87.6247088,
      "tags": [
        "relaxing",
        "indoor",
        "free",
        "midday",
        "music",
        "Downtown"
      ]
    },
    {
      "id": 307,
      "name": "Steve S.",
      "type": "description",
      "adj": " a sunny weekend day ",
      "verb": "take your bike on the Rock Island District Metra line and tour the local winery and breweries",
      "place": "the 91st Street Metra stop",
      "Side": "South Side",
      "tip": "Steve specifically suggets Wild Blossom Meadery, Horse Thief Hollow and Open Outcry Brewing Company.",
      "address": "9105 S Prospect Sq, Chicago, IL 60620",
      "Latitude": 41.7283238,
      "Longitude": -87.6678005,
      "tags": [
        "biking",
        "outdoor",
        "active",
        "midday",
        "drinking",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 308,
      "name": "Natalie Moore",
      "person_title": "WBEZ reporter",
      "verb": "check out the art trolley tour that happens every third Friday of the month",
      "place": "the Bronzeville Art District",
      "Side": "South Side",
      "link": "https://www.eventbrite.com/e/bronzeville-art-district-3rd-friday-trolley-tour-june-to-september-2019-tickets-59920071547",
      "address": "446 E 47th St, Chicago, IL 60653",
      "Latitude": 41.8096695,
      "Longitude": -87.6146817,
      "tags": [
        "kid friendly",
        "outdoor",
        "evening",
        "creativity",
        "South Side"
      ]
    },
    {
      "id": 309,
      "name": "Cassidy Lacy",
      "type": "feeling",
      "adj": " blergh ",
      "verb": "focus on self-care",
      "place": "Scratch Goods",
      "Side": "West Side",
      "tip": "Scratch Goods is a spa that focuses \"food-grade\" skincare.",
      "link": "https://www.scratchgoods.com/",
      "address": "843 W Randolph St",
      "Latitude": 41.884093,
      "Longitude": -87.6492071,
      "tags": [
        "indoor",
        "relaxing",
        "midday",
        "local business",
        "West Side"
      ]
    },
    {
      "id": 310,
      "name": "Bridget Wagner",
      "type": "time",
      "adj": " Sunday ",
      "verb": "pack a thermos and sandwich, and enjoy your meal as you read a book",
      "place": "Belmont Harbor",
      "Side": "North Side",
      "link": "https://www.chicagoharbors.info/harbors/belmont/",
      "address": "3600 Recreation Drive Chicago IL, 60613",
      "Latitude": 41.9518616,
      "Longitude": -87.6411118,
      "tags": [
        "books",
        "lakefront",
        "relaxing",
        "picnic",
        "morning",
        "midday",
        "free",
        "North Side"
      ]
    },
    {
      "id": 311,
      "type": "feeling",
      "adj": " bored ",
      "verb": "take a class",
      "place": "Hubbard Street Dance Chicago",
      "Side": "West Side",
      "link": "https://www.hubbardstreetdance.com/programs-classes/",
      "address": "1147 Jackson Blvd, Chicago, IL 60607",
      "Latitude": 41.8776647,
      "Longitude": -87.6565968,
      "tags": [
        "active",
        "indoor",
        "learn something new",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 312,
      "name": "Sara Mathers",
      "type": "time",
      "adj": " 2pm on a Friday ",
      "verb": "buy fresh fruits and vegetables on Fridays",
      "place": "IMAN’s Youth and Arts Wellness Center",
      "Side": "South Side",
      "link": "https://www.imancentral.org/organizing-advocacy/freshbeatsandeats/",
      "address": "2744 W 63rd St, Chicago, IL 60629",
      "Latitude": 41.779335,
      "Longitude": -87.6928182,
      "tags": [
        "food",
        "local business",
        "indoor",
        "relaxing",
        "kid friendly",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 313,
      "name": "Kelly Christian",
      "type": "feeling",
      "adj": " existentially drained ",
      "verb": "get dinner and a drink, then sit outside and watch the rats swim down the Chicago River as you contemplate your future",
      "place": "the Whole Foods Market on Kingsbury",
      "Side": "North Side",
      "address": "1550 N Kingsbury St, Chicago, IL 60642",
      "Latitude": 41.9086808,
      "Longitude": -87.6526427,
      "tags": [
        "food",
        "drinking",
        "outdoor",
        "evening",
        "wandering",
        "North Side"
      ]
    },
    {
      "id": 314,
      "name": "Kunur Tucker",
      "type": "feeling",
      "adj": " celebratory ",
      "verb": "get omakase ",
      "place": "KAI ZAN",
      "Side": "West Side",
      "tip": "Omakase is a japanese tasting menu.",
      "link": "http://www.eatatkaizan.com/",
      "address": "2557 W Chicago Ave",
      "Latitude": 41.895506,
      "Longitude": -87.6915835,
      "tags": [
        "food",
        "indoor",
        "local business",
        "evening",
        "midday",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 315,
      "name": "Exavier Pope",
      "person_title": "Chicago journalist",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "drink mimosas on a rooftop",
      "place": "Aba Restaurant",
      "Side": "West Side",
      "link": "http://www.abarestaurantchicago.com/",
      "address": "302 N Green St 3rd floor, Chicago, IL 60607",
      "Latitude": 41.8868435,
      "Longitude": -87.6487318,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "evening",
        "midday",
        "good views",
        "relaxing",
        "West Side"
      ]
    },
    {
      "id": 316,
      "name": "Sara Mathers",
      "type": "feeling",
      "adj": " bored ",
      "verb": "tour the grounds",
      "place": "the \"Gold Dome Building\" in Garfield Park",
      "Side": "West Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/garfield-james-park",
      "address": "100 N Central Park Ave, Chicago, IL 60624",
      "Latitude": 41.8826775,
      "Longitude": -87.7162576,
      "tags": [
        "indoor",
        "free",
        "kid friendly",
        "good for groups",
        "morning",
        "evening",
        "midday",
        "learn something new",
        "West Side"
      ]
    },
    {
      "id": 317,
      "name": "Janaya Greene",
      "type": "feeling",
      "adj": " inquisitive  ",
      "verb": "view art",
      "place": "DuSable Museum of African American History",
      "Side": "South Side",
      "tip": "Chicago writer Adam Morgan calls it the \"most underrated museum in Chicago.\"",
      "link": "https://www.dusablemuseum.org/",
      "address": "740 E 56th Pl",
      "Latitude": 41.7919142,
      "Longitude": -87.6071902,
      "tags": [
        "indoor",
        "kid friendly",
        "learn something new",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 318,
      "name": "Danny Rodgers",
      "type": "time",
      "adj": " a beautiful summerevening ",
      "verb": "watch the evening flights arrive at O'Hare Airport",
      "place": "Robinson Woods-South",
      "Side": "North Side",
      "tip": "WBEZ producer Julian Hayda recommends watching planes from the Resthaven Cemetery.",
      "link": "http://fpdcc.com/robinson-woods/",
      "address": "10000 W O'Hare Ave, Chicago, IL 60666",
      "Latitude": 41.9738886,
      "Longitude": -87.8907904,
      "tags": [
        "outdoor",
        "free",
        "kid friendly",
        "good views",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 319,
      "name": "Sara Mathers",
      "type": "description",
      "adj": " a day of reflection and service in Chicago. You should arrange a tour of Black Panther history ",
      "verb": "arrange a tour of the Black Panthers' history in Chicago",
      "place": "the Westside Justice Center",
      "Side": "West Side",
      "link": "https://www.westsidejustice.org/contact",
      "address": "601 S California Ave, Chicago, IL 60612",
      "Latitude": 41.8736411,
      "Longitude": -87.6959025,
      "tags": [
        "indoor",
        "free",
        "learn something new",
        "midday",
        "morning",
        "good for groups",
        "kid friendly",
        "West Side"
      ]
    },
    {
      "id": 320,
      "type": "description",
      "adj": " a rainy day ",
      "verb": "explore",
      "place": "the Chicago Pedway system",
      "Side": "Downtown",
      "link": "https://www.chicago.gov/city/en/depts/cdot/provdrs/ped/svcs/pedway.html",
      "Latitude": 41.881927,
      "Longitude": -87.624626,
      "tags": [
        "indoor",
        "free",
        "nature",
        "active",
        "kid friendly",
        "wandering",
        "active",
        "Downtown"
      ]
    },
    {
      "id": 321,
      "name": "Andy Brown",
      "type": "time",
      "adj": " 1 pm on a Friday ",
      "verb": "watch the skyline get smaller, then bigger, from the windows after you get on a CTA train",
      "place": "a Pink Line stop",
      "Side": "West Side",
      "address": "Pink line, Chicago IL",
      "Latitude": 41.8543669,
      "Longitude": -87.6858429,
      "tags": [
        "lakefront",
        "relaxing",
        "midday",
        "wandering",
        "good views",
        "morning",
        "evening",
        "free",
        "West Side"
      ]
    },
    {
      "id": 322,
      "name": "Gia",
      "type": "feeling",
      "adj": " alone  ",
      "verb": "people watch",
      "place": "the Crown Fountain",
      "Side": "Downtown",
      "tip": "Gia says: \"There are so many babies to smile at.\"",
      "link": "https://millenniumparkfoundation.org/art-architecture/crown-fountain/",
      "address": "201 E Randolph St, Chicago, IL 60602",
      "Latitude": 41.8834354,
      "Longitude": -87.6218416,
      "tags": [
        "outdoor",
        "kid friendly",
        "free",
        "relaxing",
        "Downtown"
      ]
    },
    {
      "id": 323,
      "name": "Julia Smith",
      "type": "time",
      "adj": " Saturday ",
      "verb": "see Paper Machete on Saturdays",
      "place": "the Green Mill",
      "Side": "North Side",
      "tip": "Paper Machete is a comedy revue show. One anonymous tipster says it's a great place to \"share some laughs with your fellow Chicagoans.\"",
      "link": "http://greenmilljazz.com/calendar/",
      "address": "4802 N Broadway, Chicago, IL 60640",
      "Latitude": 41.9692095,
      "Longitude": -87.6599036,
      "tags": [
        "indoor",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 324,
      "name": "Renée",
      "type": "feeling",
      "adj": " down ",
      "verb": "soak in the joys of pups running through the lake (and buy ice cream from a push cart)",
      "place": "Montrose Dog Beach",
      "Side": "North Side",
      "link": "https://mondog.org/",
      "Latitude": 41.9684776,
      "Longitude": -87.643618,
      "tags": [
        "ice cream",
        "indoor",
        "kid friendly",
        "outdoor",
        "food",
        "local business",
        "animals",
        "cool off",
        "North Side"
      ]
    },
    {
      "id": 325,
      "name": "Sabrina ",
      "type": "feeling",
      "adj": " thirsty & salty ",
      "verb": "drink a pitcher of guava margaritas on the patio",
      "place": "La Vaca Margarita Bar",
      "Side": "South Side",
      "link": "https://www.facebook.com/La-Vaca-Margarita-BAR-187412394769133/",
      "address": "1160 W 18th St, Chicago, IL 60608",
      "Latitude": 41.8581536,
      "Longitude": -87.6557326,
      "tags": [
        "drinking",
        "outdoor",
        "local business",
        "evening",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 326,
      "name": "Bryan Berend",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "borrow a new board game",
      "place": "the Harold Washington Library Center",
      "Side": "Downtown",
      "link": "https://www.chipublib.org/news/puzzles-board-games-available-at-harold-washington-library-center/",
      "address": "400 S State St, Chicago, IL 60605",
      "Latitude": 41.8763203,
      "Longitude": -87.6282014,
      "tags": [
        "free",
        "fun and games",
        "kid friendly",
        "morning",
        "midday",
        "good for groups",
        "Downtown"
      ]
    },
    {
      "id": 327,
      "name": "Beth Morrissey",
      "type": "description",
      "adj": " a hot day ",
      "verb": "drink a cold beer",
      "place": "Ted's Place",
      "Side": "North Side",
      "link": "https://www.facebook.com/pages/category/Pub/Teds-Place-372973277782/",
      "address": "4425 N Central Ave, Chicago, IL 60630",
      "Latitude": 41.9612844,
      "Longitude": -87.7671497,
      "tags": [
        "drinking",
        "indoor",
        "food",
        "local business",
        "midday",
        "evening",
        "cool off",
        "North Side"
      ]
    },
    {
      "id": 328,
      "name": "Danielle A Scruggs",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "eat Mexican food",
      "place": "La Catedral Cafe and Restaurant",
      "Side": "South Side",
      "link": "https://www.chefambrociogonzalez.com/new-index",
      "address": "2500 S Christiana Ave, Chicago, IL 60623",
      "Latitude": 41.8461381,
      "Longitude": -87.7091104,
      "tags": [
        "local business",
        "food",
        "indoor",
        "midday",
        "evening",
        "local business",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 329,
      "name": "Renée",
      "type": "time",
      "adj": " Sunday afternoon ",
      "verb": "window shop in the stores",
      "place": "California Avenue",
      "Side": "West Side",
      "address": "2806 W Augusta Blvd, Chicago, IL 60622",
      "Latitude": 41.8994227,
      "Longitude": -87.6971915,
      "tags": [
        "local business",
        "wandering",
        "outdoor",
        "indoor",
        "West Side"
      ]
    },
    {
      "id": 330,
      "name": "Colleen Lavin",
      "type": "description",
      "adj": " a deceptively cold day ",
      "verb": "take refuge in the winter garden",
      "place": "the Harold Washington Library Center",
      "Side": "Downtown",
      "link": "https://www.chipublib.org/news/your-new-favorite-study-space-winter-garden-at-harold-washington-library-center/",
      "address": "400 S State St, Chicago, IL 60605",
      "Latitude": 41.8763203,
      "Longitude": -87.6282014,
      "tags": [
        "indoor",
        "free",
        "relaxing",
        "morning",
        "midday",
        "books",
        "Downtown"
      ]
    },
    {
      "id": 331,
      "name": "Stephanie Izard",
      "person_title": "Iron Chef",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "eat \"goi du du\" (green papaya salad)",
      "place": "HaiSous",
      "Side": "South Side",
      "link": "https://www.haisous.com/",
      "address": "1800 S Carpenter St, Chicago, IL 60608",
      "Latitude": 41.8578651,
      "Longitude": -87.6535415,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 332,
      "name": "Sabrina Miller",
      "type": "feeling",
      "adj": "hungry",
      "verb": "eat chicken and special sauce",
      "place": "Hienie's Shrimp House",
      "Side": "South Side",
      "link": "https://www.hienies.com/",
      "address": "10359 S Torrence Ave, Chicago, IL 60617",
      "Latitude": 41.7065687,
      "Longitude": -87.5593807,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "evening",
        "local business",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 333,
      "name": "Sara Mathers",
      "type": "feeling",
      "adj": " restless ",
      "verb": "check out an event",
      "place": "the Breathing Room in the #LetUsBreathe Collective",
      "Side": "South Side",
      "link": "https://www.letusbreathecollective.com/what-is-breathing-room",
      "address": "1434 W 51st St Chicago, IL 60609",
      "Latitude": 41.8017881,
      "Longitude": -87.6616578,
      "tags": [
        " relaxing",
        "local business",
        "indoor",
        "learn something new",
        "evening",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 334,
      "name": "Sterling Haukom Anderson",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "grab a drink",
      "place": "Hopewell Brewing Company ",
      "Side": "North Side",
      "link": "https://www.hopewellbrewing.com/",
      "address": "2760 N Milwaukee Ave, Chicago, IL 60647",
      "Latitude": 41.9312366,
      "Longitude": -87.7114552,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 335,
      "name": "Dave Stanford",
      "type": "time",
      "adj": " dreary ",
      "verb": "ride an unfamiliar L line and",
      "place": "the end find a nice snack",
      "tags": [
        "morning",
        "food",
        "wandering",
        "kid friendly",
        "active",
        "midday",
        "evening",
        "good for groups"
      ]
    },
    {
      "id": 336,
      "name": "Justin Shannin",
      "type": "description",
      "adj": " a gloomy day ",
      "verb": "play a board game from the free wall of games",
      "place": "Dice Dojo",
      "Side": "North Side",
      "link": "https://www.chicagolandgames.com/",
      "address": "5550 N Broadway #1, Chicago, IL 60640",
      "Latitude": 41.9833168,
      "Longitude": -87.66035,
      "tags": [
        "fun and games",
        "free",
        "kid friendly",
        "indoor",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 337,
      "name": "Natalie Moore",
      "person_title": "WBEZ reporter",
      "verb": "play tennis",
      "place": "Tuley Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/tuley-murray-park",
      "address": "501 E 90th Pl, Chicago, IL 60619",
      "Latitude": 41.7301281,
      "Longitude": -87.6112026,
      "tags": [
        "midday",
        "morning",
        "active",
        "outdoor",
        "South Side"
      ]
    },
    {
      "id": 338,
      "name": "Kelly Fox",
      "type": "time",
      "adj": " lunchtime ",
      "verb": "bring your bagged lunch to the benches surrounding the Crown Fountain (the one with the faces)",
      "place": "Millennium Park",
      "Side": "Downtown",
      "tip": "Kelly says: \"The kids' joy is infectious!\"",
      "link": "https://millenniumparkfoundation.org/art-architecture/crown-fountain/",
      "address": "201 E Randolph St, Chicago, IL 60602",
      "Latitude": 41.8834354,
      "Longitude": -87.6218416,
      "tags": [
        "midday",
        "free",
        "kid friendly",
        "outdoor",
        "midday",
        "Downtown"
      ]
    },
    {
      "id": 339,
      "type": "description",
      "adj": " a pleasant day ",
      "verb": "walk in the woods and learn some history",
      "place": "the Chicago Portage National Historic Site in Forest View",
      "Side": "Suburbs",
      "link": "https://www.stateparks.com/chicago_portage_national_historic_site_in_illinois.html",
      "tags": [
        "learn something new",
        "outdoor",
        "free",
        "kid friendly",
        "active",
        "Suburbs"
      ]
    },
    {
      "id": 340,
      "name": "Lane Pickett",
      "type": "description",
      "adj": " a beautiful day ",
      "verb": "go for an iced coffee",
      "place": "the Bridgeport Coffeehouse",
      "Side": "South Side",
      "link": "https://bridgeportcoffee.net/",
      "address": "3101 S Morgan St, Chicago, IL 60608",
      "Latitude": 41.8378643,
      "Longitude": -87.6508496,
      "tags": [
        "indoor",
        "coffee",
        "relaxing",
        "local business",
        "cool off",
        "South Side"
      ]
    },
    {
      "id": 341,
      "name": "Kelly Christian",
      "type": "description",
      "adj": " a sunny week day ",
      "verb": "play minigolf, use the photobooth and check out the batting cages",
      "place": "Novelty Golf in Lincolnwood",
      "Side": "Suburbs",
      "tip": "Kelly recommends you hit up the nearby Dairy Star (which also has non-dairy options). WBEZ Digital Editor Michael Lansu also recommends checking out Novelty Golf's famous TV commercial.",
      "link": "http://www.noveltygolf.com/",
      "tags": [
        "outdoor",
        "indoor",
        "active",
        "kid friendly",
        "good for groups",
        "fun and games",
        "Suburbs"
      ]
    },
    {
      "id": 342,
      "name": "Erin",
      "type": "feeling",
      "adj": " stressed out ",
      "verb": "wander around the Magic Hedge ",
      "place": "Montrose Harbor",
      "Side": "North Side",
      "tip": "The Magic Hedge is a migratory bird sanctuary.",
      "link": "https://www.chicagoharbors.info/harbors/montrose/",
      "address": "601 W Montrose Ave, Chicago, IL 60613",
      "Latitude": 41.9630332,
      "Longitude": -87.6381737,
      "tags": [
        "lakefront",
        "outdoor",
        "kid friendly",
        "nature",
        "animals",
        "free",
        "North Side"
      ]
    },
    {
      "id": 343,
      "type": "feeling",
      "adj": " hungover ",
      "verb": "get fries (ordered extra crispy) and a burger",
      "place": "Top Notch Beefburgers",
      "Side": "South Side",
      "tip": "WBEZ digital producer Arionne Nettles recommends the Oreo shake.",
      "link": "https://www.facebook.com/topnotchbeverly/",
      "address": "2116 W 95th St, Chicago, IL 60643",
      "Latitude": 41.7212944,
      "Longitude": -87.6754304,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 344,
      "name": "Janet Kennedy",
      "type": "description",
      "adj": " a warm Fridayevening ",
      "verb": "grab a drink, listen to live music and enjoy tasty treats from a food truck",
      "place": "Cork and Kerry's beer garden",
      "Side": "South Side",
      "link": "https://corkandkerrybeverly.com/",
      "address": "10614 S Western Ave, Chicago, IL 60643",
      "Latitude": 41.7004501,
      "Longitude": -87.6816198,
      "tags": [
        "drinking",
        "music",
        "food",
        "outdoor",
        "evening",
        "indoor",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 345,
      "name": "Gabrielle ",
      "type": "feeling",
      "adj": " big ",
      "verb": "go star-gazing",
      "place": "the Exelon Observatory on The 606",
      "Side": "West Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/exelon-observatory",
      "address": "1801 N Ridgeway Ave, Chicago, IL 60647",
      "Latitude": 41.9136633,
      "Longitude": -87.7202355,
      "tags": [
        "outdoor",
        "relaxing",
        "evening",
        "kid friendly",
        "free",
        "kid friendly",
        "relaxing",
        "West Side"
      ]
    },
    {
      "id": 346,
      "name": "Gina Bognar ",
      "type": "time",
      "adj": " Thursdaymorning ",
      "verb": "go to the Thursday morning farmers market",
      "place": "Daley Plaza",
      "Side": "Downtown",
      "link": "https://www.chicago.gov/city/en/depts/dca/supp_info/farmersmarkets1.html",
      "address": "50 W Washington St, Chicago, IL 60602",
      "Latitude": 41.8840336,
      "Longitude": -87.6301288,
      "tags": [
        "outdoor",
        "food",
        "local business",
        "morning",
        "Downtown"
      ]
    },
    {
      "id": 347,
      "name": "Karen Trine",
      "type": "feeling",
      "adj": " crowded/cramped ",
      "verb": "ride a bike to Promontory Point (and back) starting",
      "place": "Northerly Island",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/northerly-island-park",
      "address": "1521 S. Linn White Dr.",
      "Latitude": 41.860156,
      "Longitude": -87.608323,
      "tags": [
        "lakefront",
        "outdoor",
        "biking",
        "active",
        "free",
        "kid friendly",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 348,
      "name": "Tyler",
      "type": "time",
      "adj": " the hottest day of July ",
      "verb": "get a lemonade (Italian ice)",
      "place": "Mario's Italian Lemonade",
      "Side": "West Side",
      "link": "https://www.facebook.com/MariosItalianLemonade/",
      "address": "1068 W Taylor St, Chicago, IL 60607",
      "Latitude": 41.869672,
      "Longitude": -87.6538354,
      "tags": [
        "kid friendly",
        "ice cream",
        "outdoor",
        "indoor",
        "cool off",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 349,
      "name": "Gabrielle",
      "type": "time",
      "adj": " monday ",
      "verb": "listen to show tunes on Musical Mondays",
      "place": "Sidetrack",
      "Side": "North Side",
      "link": "https://www.sidetrackchicago.com/",
      "address": "3349 N Halsted St, Chicago, IL 60657",
      "Latitude": 41.9433314,
      "Longitude": -87.649038,
      "tags": [
        "music",
        "indoor",
        "local business",
        "good for groups",
        "dancing",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 350,
      "name": "Allison Manley",
      "type": "description",
      "adj": " a regular day ",
      "verb": "order some churros",
      "place": "Don Churro",
      "Side": "South Side",
      "link": "https://www.facebook.com/donchurrochicagopilsen/",
      "address": "1626 S Blue Island Ave, Chicago, IL 60608",
      "Latitude": 41.8590078,
      "Longitude": -87.6604088,
      "tags": [
        "food",
        "indoor",
        "kid friendly",
        "local business",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 351,
      "name": "Deborah Mercer",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "visit Project Onward studio and gallery",
      "place": "the Bridgeport Art Center",
      "Side": "South Side",
      "link": "https://bridgeportart.com/",
      "address": "1200 W 35th St",
      "Latitude": 41.8308937,
      "Longitude": -87.6563405,
      "tags": [
        "creativity",
        "indoor",
        "free",
        "midday",
        "learn something new",
        "free",
        "South Side"
      ]
    },
    {
      "id": 352,
      "name": "Greta Johnsen",
      "person_title": "<em>Nerdette</em> host",
      "type": "feeling",
      "adj": " wistful  ",
      "verb": "walk around ",
      "place": "the Chicago Botanic Garden in Glencoe",
      "Side": "Suburbs",
      "link": "https://www.chicagobotanic.org/",
      "tags": [
        "active",
        "outdoor",
        "morning",
        "midday",
        "nature",
        "good for groups",
        "Suburbs"
      ]
    },
    {
      "id": 353,
      "name": "William Rivas",
      "type": "feeling",
      "adj": " ready to dance, dance the night away ",
      "verb": "dance the night away",
      "place": "Big Chicks",
      "Side": "North Side",
      "link": "http://bigchicks.com/",
      "address": "5024 N Sheridan Rd, Chicago, IL 60640",
      "Latitude": 41.9740444,
      "Longitude": -87.6552816,
      "tags": [
        "drinking",
        "dancing",
        "evening",
        "local business",
        "good for groups",
        "active",
        "North Side"
      ]
    },
    {
      "id": 354,
      "type": "description",
      "adj": " a rainy day ",
      "verb": "have a drink",
      "place": "Scofflaw",
      "Side": "North Side",
      "link": "https://www.scofflawchicago.com/",
      "address": "3201 W Armitage Ave, Chicago, IL 60647",
      "Latitude": 41.9171812,
      "Longitude": -87.7072164,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 355,
      "type": "time",
      "adj": " a second Friday ",
      "verb": "take advantage of \"Second Fridays\"",
      "place": "Pilsen",
      "Side": "South Side",
      "tip": "On the second Friday of the month, galleries and artist studios on Halsted are open to the public.",
      "link": "http://chicagoartsdistrict.org/events_main.asp",
      "address": "Pilsen Chicago",
      "Latitude": 41.8524902,
      "Longitude": -87.6562598,
      "tags": [
        "indoor",
        "free",
        "creativity",
        "wandering",
        "outdoor",
        "South Side"
      ]
    },
    {
      "id": 356,
      "name": "Natalie Moore",
      "person_title": "WBEZ reporter",
      "verb": "have a picnic",
      "place": "Washington Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/washington-george-park",
      "address": "5531 S. King Dr. Chicago, IL 60615",
      "Latitude": 41.7934569,
      "Longitude": -87.6155009,
      "tags": [
        "kid friendly",
        "food",
        "picnic",
        "outdoor",
        "nature",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 357,
      "name": "Annie Nguyen",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "take a lakefront bike ride to get a bomb AF cardamom and rose iced latte",
      "place": "Build Coffee",
      "Side": "South Side",
      "link": "https://buildcoffee.org/",
      "address": " 6100 S Blackstone Ave, Chicago, IL 60637",
      "Latitude": 41.7840796,
      "Longitude": -87.5905906,
      "tags": [
        "biking",
        "outdoor",
        "free",
        "active",
        "food",
        "local business",
        "South Side"
      ]
    },
    {
      "id": 358,
      "name": "Natalie Moore",
      "person_title": "WBEZ reporter",
      "verb": "get bread pudding ",
      "place": "Miss Lee Good Food",
      "Side": "South Side",
      "link": "https://www.facebook.com/pages/Miss-Lee-Good-Food/121724951174486",
      "address": "203 E Garfield Blvd, Chicago, IL 60637",
      "Latitude": 41.7941652,
      "Longitude": -87.6204281,
      "tags": [
        "kid friendly",
        "food",
        "indoor",
        "local business",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 359,
      "name": "Jonathan P",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "get Mexican food",
      "place": "El Taco Feliz Taqueria",
      "Side": "North Side",
      "link": "https://www.facebook.com/pages/El-Taco-Feliz/183887901808413",
      "address": " 5439 W Addison St, Chicago, IL 60641",
      "Latitude": 41.9458009,
      "Longitude": -87.7633956,
      "tags": [
        "food",
        "indoor",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 360,
      "name": "Laurence Holmes",
      "person_title": "WSCR radio host",
      "type": "feeling",
      "adj": "like you want something sweet",
      "verb": "devour a doughnut",
      "place": "Dat Donuts",
      "Side": "South Side",
      "tip": "This doughtnut shop is a 24-hour operation.",
      "link": "https://www.datdonut.com/",
      "address": "8251 S Cottage Grove Ave, Chicago, IL 60619",
      "Latitude": 41.7443552,
      "Longitude": -87.6046361
    },
    {
      "id": 361,
      "name": "June",
      "type": "description",
      "adj": " a warm summer day ",
      "verb": "visit the quaint beach and wander around the art gallery",
      "place": "the South Shore Cultural Center",
      "Side": "South Side",
      "tip": "Angela R. Rudolph says: Go to the annual screening of The Wiz (held every year at the South Shore Cultural Center). \"It's a hoot! If you’re of a certain age you get to relive a childhood favorite, group sing/say the movie and see the South Side Chicago at its finest.\"",
      "address": "7059 S South Shore Dr",
      "Latitude": 41.7683018,
      "Longitude": -87.563868,
      "tags": [
        "lakefront",
        "indoor",
        "outdoor",
        "free",
        "creativity",
        "free",
        "nature",
        "South Side"
      ]
    },
    {
      "id": 362,
      "name": "Emily",
      "type": "time",
      "adj": " snowing ",
      "verb": "watch a movie at Regal 14 and then have dinner in front of the fire",
      "place": "Owen and Engine",
      "Side": "North Side",
      "link": "https://www.owenandengine.com/",
      "address": "2600 N Western Ave, Chicago, IL 60647",
      "Latitude": 41.9297964,
      "Longitude": -87.68908,
      "tags": [
        "local business",
        "food",
        "indoor",
        "relaxing",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 363,
      "name": "Lee Helmer",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "shop for recycled art supplies",
      "place": "The WasteShed",
      "Side": "West Side",
      "link": "http://www.thewasteshed.com/",
      "address": "2842 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8960301,
      "Longitude": -87.6985884,
      "tags": [
        "creativity",
        "indoor",
        "kid friendly",
        "midday",
        "morning",
        "good for groups",
        "West Side"
      ]
    },
    {
      "id": 364,
      "name": "Joy R",
      "type": "feeling",
      "adj": " too urban  ",
      "verb": "hike the limestone aquaducts",
      "place": "the Dan Ryan Woods",
      "Side": "South Side",
      "link": "http://fpdcc.com/dan-ryan-woods/",
      "address": "8300 S Western Ave Chicago, IL 60620 US",
      "Latitude": 41.7409287,
      "Longitude": -87.6822164,
      "tags": [
        "outdoor",
        "active",
        "kid friendly",
        "free",
        "midday",
        "free",
        "South Side"
      ]
    },
    {
      "id": 365,
      "name": "Bill Savage",
      "person_title": "Chicago author",
      "type": "feeling",
      "adj": " ambitious ",
      "verb": "take an ambitious bike ride on the Major Taylor Trail to the Whistler Woods Forest Preserve in Riverdale. Start",
      "place": "\n83rd and Western",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/park-no-548-major-taylor-bike-trail",
      "Latitude": 41.7009433,
      "Longitude": -87.6533549,
      "tags": [
        "active",
        "biking",
        "nature",
        "outdoor",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 366,
      "name": "Kelly Fox",
      "type": "description",
      "adj": " a rainy day ",
      "verb": "hunt for dinosaurs in the Fern Room",
      "place": "the Garfield Park Conservatory",
      "Side": "West Side",
      "tip": "Visiting the Garfield Park Conservatory was one of the most recommended activities.",
      "link": "https://garfieldconservatory.org/",
      "address": "300 N Central Park Ave, Chicago, IL 60624",
      "Latitude": 41.8864959,
      "Longitude": -87.717822,
      "tags": [
        "free",
        "kid friendly",
        "relaxing",
        "indoor",
        "nature",
        "midday",
        "West Side"
      ]
    },
    {
      "id": 367,
      "type": "time",
      "adj": " anytime ",
      "verb": "eat brisket",
      "place": "Green Street Smoked Meats",
      "Side": "West Side",
      "link": "https://greenstreetmeats.com/",
      "address": "112 N Green St, Chicago, IL 60607",
      "Latitude": 41.8836836,
      "Longitude": -87.6487662,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "West Side"
      ]
    },
    {
      "id": 368,
      "name": "Julian Hayda",
      "person_title": "WBEZ producer",
      "type": "time",
      "adj": " Friday ",
      "verb": "race turtles on Friday nights",
      "place": "Big Joe's",
      "Side": "North Side",
      "link": "https://www.facebook.com/bigjoeschicago/",
      "address": "1818 W Foster Ave, Chicago, IL 60640",
      "Latitude": 41.9762385,
      "Longitude": -87.6755517,
      "tags": [
        "indoor",
        "local business",
        "animals",
        "fun and games",
        "evening",
        "fun and games",
        "North Side"
      ]
    },
    {
      "id": 369,
      "name": "Katherine Nagasawa",
      "person_title": "<em>Curious City</em> producer",
      "type": "time",
      "adj": " sunset ",
      "verb": "have a picnic and watch the skyline change colors",
      "place": "Milton Lee Olive Park",
      "Side": "Downtown",
      "tip": "WBEZ reporter Monica Eng also recommended this little known park. She says it has \"breathtaking lakeside views of the city in a quiet grassy, tree-lined European style oasis.\" But keep in mind that it closes at 8 p.m., which leaves plenty of time to ride your bike or the CTA home before dark. ",
      "link": "https://tclf.org/landscapes/milton-lee-olive-park",
      "address": "511 N Columbus Dr, Chicago, IL 60611",
      "Latitude": 41.8914042,
      "Longitude": -87.6199634,
      "tags": [
        "outdoor",
        "picnic",
        "free",
        "good views",
        "midday",
        "evening",
        "good for groups",
        "Downtown"
      ]
    },
    {
      "id": 370,
      "name": "Justin Shannin",
      "type": "feeling",
      "adj": " the itch to create something",
      "verb": "record some music, make a podcast or do some creative writing",
      "place": "a YOUmedia space at a Chicago public library",
      "tip": "There are YOUmedia locations at 12 Chicago public libaries. They are all geared towards teenagers.",
      "link": "https://www.chipublib.org/programs-and-partnerships/youmedia/",
      "address": "400 S State St",
      "Latitude": 41.8762968,
      "Longitude": -87.6282279,
      "tags": [
        "free",
        "kid friendly",
        "creativity",
        "midday",
        "morning"
      ]
    },
    {
      "id": 371,
      "name": "Sydney G Weiss",
      "type": "time",
      "adj": " 6 am ",
      "verb": "go to Buckingham Fountain at 6 a.m. (before all the tourists come)",
      "place": "Grant Park",
      "Side": "Downtown",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/clarence-f-buckingham-memorial-fountain",
      "address": "337 E Randolph St, Chicago, IL 60601",
      "Latitude": 41.8823821,
      "Longitude": -87.6193666,
      "tags": [
        "outdoor",
        "kid friendly",
        "free",
        "morning",
        "Downtown"
      ]
    },
    {
      "id": 372,
      "name": "Jackie Moore",
      "type": "description",
      "adj": " a brisk day ",
      "verb": "play outdoor tennis",
      "place": "O'Halleran Park",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/ohallaren-bernard-park",
      "address": "8335 S Honore St, Chicago, IL 60620",
      "Latitude": 41.742683,
      "Longitude": -87.6692724,
      "tags": [
        "active",
        "kid friendly",
        "outdoor",
        "fun and games",
        "good for groups",
        "free",
        "South Side"
      ]
    },
    {
      "id": 373,
      "name": "Samantha Irby",
      "person_title": "author/comedian",
      "type": "time",
      "adj": " sundaymorning-ish  ",
      "verb": "drink palomas and whiskey shots",
      "place": "Big Star",
      "Side": "North Side",
      "tip": "Samantha says don't go if \"it's too crowded or not cool anymore.\"",
      "link": "http://www.bigstarchicago.com/wickerpark",
      "address": "1531 N Damen Ave, Chicago",
      "Latitude": 41.9091576,
      "Longitude": -87.6771306,
      "tags": [
        "drinking",
        "outdoor",
        "food",
        "midday",
        "evening",
        "morning",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 374,
      "name": "Lisa Marie",
      "type": "time",
      "adj": " 11 pm ",
      "verb": "grab a drink (and stay for live music or a dance party)",
      "place": "Liar's Club",
      "Side": "North Side",
      "link": "https://www.facebook.com/liarsclubchicago/",
      "address": "1665 W Fullerton Ave, Chicago, IL 60614",
      "Latitude": 41.9248851,
      "Longitude": -87.6706375,
      "tags": [
        "drinking",
        "dancing",
        "indoor",
        "local business",
        "evening",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 375,
      "name": "Allyssa Pollard",
      "type": "feeling",
      "adj": " bored and hangry ",
      "verb": "get pastries",
      "place": "the bakeries along Chicago Avenue",
      "Side": "West Side",
      "tip": "After you finish your pastries, Allyssa recommends going to the Ukrainian Institute of Modern Art.",
      "address": "Chicago and Damen Chicago IL",
      "Latitude": 41.8960693,
      "Longitude": -87.6771771,
      "tags": [
        "wandering",
        "midday",
        "indoor",
        "morning",
        "West Side"
      ]
    },
    {
      "id": 376,
      "name": "Sara Corley",
      "type": "feeling",
      "adj": " a little down ",
      "verb": "see a show",
      "place": "The Revival improv comedy theater",
      "Side": "South Side",
      "link": "http://www.the-revival.com/",
      "address": "1160 E 55th St",
      "Latitude": 41.7951841,
      "Longitude": -87.5971999,
      "tags": [
        "indoor",
        "evening",
        "local business",
        "South Side"
      ]
    },
    {
      "id": 377,
      "name": "Drew Schmedding",
      "type": "time",
      "adj": " a summer weekend ",
      "verb": "eat brunch in Andersonville and then soak up the sun",
      "place": "Hollywood Beach",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/osterman-beach",
      "address": "4600 North Lake Shore Drive",
      "Latitude": 41.9671092,
      "Longitude": -87.6451491,
      "tags": [
        "local business",
        "food",
        "outdoor",
        "lakefront",
        "morning",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 378,
      "type": "description",
      "adj": " a cold, grey day ",
      "verb": "warm up on a cold, gray day",
      "place": "the Lincoln Park Conservatory",
      "Side": "North Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/lincoln-park-conservatory",
      "address": "2391 N Stockton Dr",
      "Latitude": 41.9242872,
      "Longitude": -87.6352185,
      "tags": [
        "indoor",
        "nature",
        "free",
        "midday",
        "evening",
        "morning",
        "good for groups",
        "North Side"
      ]
    },
    {
      "id": 379,
      "name": "Danielle A Scruggs",
      "type": "time",
      "adj": " Saturday ",
      "verb": "visit the Arts and Public Life center",
      "place": "the Garfield Green Line stop",
      "Side": "South Side",
      "link": "https://www.facebook.com/pg/artspubliclife/events/",
      "address": "301 E Garfield Blvd, Chicago, IL 60637",
      "Latitude": 41.7941527,
      "Longitude": -87.6189854,
      "tags": [
        "kid friendly",
        "free",
        "indoor",
        "creativity",
        "learn something new",
        "South Side"
      ]
    },
    {
      "id": 380,
      "name": "Rachel Ellsworth",
      "type": "feeling",
      "adj": " stressed ",
      "verb": "treat yourself with a massage",
      "place": "Egea Spa in Evanston",
      "Side": "Suburbs",
      "link": "https://egeaspa.com/",
      "tags": [
        "local business",
        "relaxing",
        "indoor",
        "midday",
        "evening",
        "morning",
        "local business",
        "Suburbs"
      ]
    },
    {
      "id": 381,
      "name": "Eve",
      "type": "time",
      "adj": " sunny ",
      "verb": "have a drink outside",
      "place": "Lady Gregory's",
      "Side": "North Side",
      "link": "https://ladygregorys.com/restaurant/lga",
      "address": "5260 N Clark St, Chicago, IL 60640",
      "Latitude": 41.9778861,
      "Longitude": -87.6686199,
      "tags": [
        "drinking",
        "outdoor",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 382,
      "name": "Jennifer Kilgore",
      "type": "feeling",
      "adj": " cooped up ",
      "verb": "enjoy a beer on the riverside",
      "place": "Metropolitan Brewery",
      "Side": "North Side",
      "link": "http://metrobrewing.com/",
      "address": "3057 N Rockwell St, Chicago, IL 60618",
      "Latitude": 41.9374191,
      "Longitude": -87.6925813,
      "tags": [
        "drinking",
        "indoor",
        "local business",
        "cool off",
        "North Side"
      ]
    },
    {
      "id": 383,
      "name": "Seamus Doheny",
      "person_title": "Vocalo producer",
      "type": "feeling",
      "adj": " peckish ",
      "verb": "drink a vegan chocolate shake ",
      "place": "The Chicago Diner",
      "Side": "North Side",
      "link": "http://www.veggiediner.com/",
      "address": "3411 N Halsted St",
      "Latitude": 41.9440048,
      "Longitude": -87.6491625,
      "tags": [
        "food",
        "ice cream",
        "kid friendly",
        "local business",
        "North Side"
      ]
    },
    {
      "id": 384,
      "name": "Jon Langford",
      "person_title": "Chicago musician",
      "type": "description",
      "adj": " a soul-sucking day ",
      "verb": "hatch a scheme to undermine the corrupt local authorities and catch a band",
      "place": "the Hideout",
      "Side": "North Side",
      "tip": "Other recommendations for the Hideout include: \"Enjoy drinks and a stimulating discussion with A Scientist Walks into a Bar\" and \"listen to local celebrities call out bingo and compete to win a fresh harvest at Veggie Bingo.\"",
      "link": "https://www.hideoutchicago.com/",
      "address": "1354 W Wabansia Ave, Chicago, IL 60642",
      "Latitude": 41.9138993,
      "Longitude": -87.6626011,
      "tags": [
        "indoor",
        "local business",
        "midday",
        "evening",
        "North Side"
      ]
    },
    {
      "id": 385,
      "name": "Kazuyoshi Yamada",
      "person_title": "chef at Superkhana International",
      "type": "feeling",
      "adj": " like you have shpilkes in your kishka",
      "verb": "grab a Divvy bike when you feel like you have shpikes in your kishka and ride to the South Side Cultural Center and Stony Island Arts Bank",
      "place": "the lakeshore",
      "Side": "South Side",
      "tip": "Kazuyoshi guarantees you'll come home a bit more royk.",
      "address": "7059 S South Shore Dr, Chicago, IL 60649",
      "Latitude": 41.7683018,
      "Longitude": -87.563868,
      "tags": [
        "lakefront",
        "outdoor",
        "kid friendly",
        "midday",
        "morning",
        "evening",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 386,
      "name": "Latrina Robinson",
      "type": "feeling",
      "adj": " hungry ",
      "verb": "get saucy fried chicken ",
      "place": "Uncle Remus",
      "Side": "South Side",
      "link": "https://uncleremususa.com/",
      "address": "737 E 47th St, Chicago, IL 60615",
      "Latitude": 41.8093676,
      "Longitude": -87.6073693,
      "tags": [
        "food",
        "local business",
        "indoor",
        "midday",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 387,
      "name": "Sterling Haukom Anderson",
      "type": "time",
      "adj": " time for an awesome fundraising event ",
      "verb": "pick up some new jewelry",
      "place": "The Silver Room",
      "Side": "South Side",
      "link": "https://thesilverroom.com/",
      "address": "1506 E 53rd St, Chicago, IL 60615",
      "Latitude": 41.7996603,
      "Longitude": -87.5887855,
      "tags": [
        "local business",
        "indoor",
        "midday",
        "feeling fancy",
        "South Side"
      ]
    },
    {
      "id": 388,
      "name": "Nick",
      "type": "time",
      "adj": "4:00 AM",
      "verb": "see if you can find the coyotes (which hide under the bushes in the day and hunt at night)",
      "place": "Northerly Island",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/northerly-island-park",
      "address": "1521 S. Linn White Dr. Chicago, IL 60605",
      "Latitude": 41.860156,
      "Longitude": -87.608323,
      "tags": [
        "animals",
        "outdoor",
        "evening",
        "kid friendly",
        "nature",
        "free",
        "South Side"
      ]
    },
    {
      "id": 389,
      "name": "Alanna",
      "type": "feeling",
      "adj": " artsy ",
      "verb": "take a class ",
      "place": "The Chicago Mosaic School",
      "Side": "North Side",
      "link": "https://chicagomosaicschool.com/classes-workshops/",
      "address": "1127 W Granville Ave, Chicago, IL 60660",
      "Latitude": 41.9942759,
      "Longitude": -87.6595464,
      "tags": [
        "indoor",
        "kid friendly",
        "morning",
        "evening",
        "midday",
        "North Side"
      ]
    },
    {
      "id": 390,
      "name": "Sara Mathers",
      "type": "time",
      "adj": " noon on Thursday ",
      "verb": "tour some urban farms at noon on Thursdays",
      "place": "Wood Street Urban Farm Stand",
      "Side": "South Side",
      "link": "http://growinghomeinc.org/our-farms/",
      "address": "5814 S Wood St, Chicago, IL 60636",
      "Latitude": 41.7880123,
      "Longitude": -87.6694982,
      "tags": [
        "outdoor",
        "food",
        "local business",
        "relaxing",
        "kid friendly",
        "learn something new",
        "midday",
        "morning",
        "South Side"
      ]
    },
    {
      "id": 391,
      "name": "Lane Pickett",
      "type": "time",
      "adj": " rainy ",
      "verb": "go on a tour",
      "place": "The Plant",
      "Side": "South Side",
      "tip": "The Plant is a community of food businesses. Maureen Kelleher suggests visiting the Saturday morning farmers market.",
      "link": "https://plantchicago.org/",
      "address": "1400 W 46th St",
      "Latitude": 41.8106669,
      "Longitude": -87.6606705,
      "tags": [
        "indoor",
        "free",
        "local business",
        "learn something new",
        "evening",
        "South Side"
      ]
    },
    {
      "id": 392,
      "name": "Becky Brofman",
      "type": "time",
      "adj": " 10 pm on a Wednesday night ",
      "verb": "watch the Wednesday night fireworks",
      "place": "DuSable Harbor",
      "Side": "Downtown",
      "link": "https://www.chicagoharbors.info/harbors/dusable/",
      "address": "111 N Lake Shore Dr, Chicago, IL 60601",
      "Latitude": 41.8840953,
      "Longitude": -87.612431,
      "tags": [
        "outdoor",
        "lakefront",
        "free",
        "kid friendly",
        "evening",
        "Downtown"
      ]
    },
    {
      "id": 393,
      "name": "Chrissy Delgado",
      "type": "feeling",
      "adj": " lonely ",
      "verb": "adopt your new best friend",
      "place": "Chicago Animal Care and Control",
      "Side": "South Side",
      "link": "https://www.chicago.gov/city/en/depts/cacc.html",
      "address": "2741 S Western Ave",
      "Latitude": 41.8419368,
      "Longitude": -87.684154,
      "tags": [
        "animals",
        "indoor",
        "kid friendly",
        "South Side"
      ]
    },
    {
      "id": 394,
      "name": "Alexa L Schutz",
      "type": "time",
      "adj": " date night ",
      "verb": "escape the crowds for an intimate and delicious meal outdoors",
      "place": "Homestead on the Roof",
      "Side": "West Side",
      "link": "http://www.homesteadontheroof.com/",
      "address": "1924 W Chicago Ave, Chicago, IL 60622",
      "Latitude": 41.8962448,
      "Longitude": -87.6756447,
      "tags": [
        "outdoor",
        "food",
        "local business",
        "relaxing",
        "midday",
        "evening",
        "good views",
        "West Side"
      ]
    },
    {
      "id": 395,
      "name": "Kora",
      "type": "description",
      "adj": " rainy  ",
      "verb": "play board games",
      "place": "Marz Community Brewing Company",
      "Side": "South Side",
      "link": "http://marzbrewing.com/",
      "address": "3630 S Iron St, Chicago, IL 60609",
      "Latitude": 41.8278582,
      "Longitude": -87.6597314,
      "tags": [
        "good for groups",
        "fun and games",
        "drinking",
        "indoor",
        "evening",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 396,
      "name": "Maureen Keane",
      "type": "feeling",
      "adj": " adventurous ",
      "verb": "discover nature ",
      "place": "the South Shore Nature Sanctuary",
      "Side": "South Side",
      "link": "https://www.chicagoparkdistrict.com/parks-facilities/south-shore-natural-area",
      "address": "7059 S South Shore Dr, Chicago, IL 60649",
      "Latitude": 41.7683018,
      "Longitude": -87.563868,
      "tags": [
        "lakefront",
        "outdoor",
        "relaxing",
        "kid friendly",
        "free",
        "nature",
        "good for groups",
        "South Side"
      ]
    },
    {
      "id": 397,
      "name": "Sarah T",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "get an iced coffee and people watch",
      "place": "L' Cafecito Jumping Bean",
      "Side": "South Side",
      "tip": "Sarah says: Their patio is right outside of the Pink Line stop, making it optimal for people watching. There are also beautiful murals that compliment the pastel benches and tables",
      "link": "https://www.facebook.com/pinklinedamen/",
      "address": "2010 S Damen Ave, Chicago, IL 60608",
      "Latitude": 41.854682,
      "Longitude": -87.67609,
      "tags": [
        "coffee",
        "indoor",
        "outdoor",
        "good views",
        "morning",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 398,
      "name": "Arionne Nettles",
      "person_title": "WBEZ producer",
      "verb": "take an immersive cycling class ",
      "place": "Cycmode",
      "Side": "Downtown",
      "tip": "Ari says: This workout spot is great because it's a black woman-owned business.",
      "link": "https://cycmode.com/",
      "address": "1333 S Wabash Ave, Chicago, IL 60605",
      "Latitude": 41.864818,
      "Longitude": -87.625268,
      "tags": [
        "active",
        "indoor",
        "local business",
        "Downtown"
      ]
    },
    {
      "id": 399,
      "type": "time",
      "adj": "Sunday",
      "verb": "peruse the fabrics and trimmings",
      "place": "the Textile Discount Outlet",
      "Side": "South Side",
      "link": "http://www.textilediscountoutlet.com/",
      "address": "2121 W 21st St, Chicago, IL 60608",
      "Latitude": 41.8537075,
      "Longitude": -87.679307,
      "tags": [
        "local business",
        "indoor",
        "wandering",
        "midday",
        "South Side"
      ]
    },
    {
      "id": 400,
      "name": "Becca",
      "type": "description",
      "adj": " a sunny day ",
      "verb": "get Korean barbecue",
      "place": "Crisp",
      "Side": "North Side",
      "link": "http://www.crisponline.com/MainMenu.aspx",
      "address": "2940 N Broadway, Chicago, IL 60657",
      "Latitude": 41.9361153,
      "Longitude": -87.6445262,
      "tags": [
        "food",
        "indoor",
        "local business",
        "midday",
        "evening",
        "good for groups",
        "North Side"
      ]
    }
  ],
  "mainTags": [
    "indoor",
    "outdoor",
    "active",
    "relaxing",
    "kid friendly",
    "free"
  ],
  "secondaryTags": [
    "midday",
    "wandering",
    "lakefront",
    "morning",
    "evening",
    "food",
    "local business",
    "drinking",
    "biking",
    "cool off",
    "fun and games",
    "good views",
    "feeling fancy",
    "learn something new",
    "coffee",
    "ice cream",
    "music",
    "books",
    "nature",
    "good for groups",
    "animals",
    "picnic",
    "dancing",
    "creativity"
  ],
  "allTags": {},
  "neighborhoods": [
    "North Side",
    "South Side",
    "West Side",
    "Downtown",
    "Suburbs"
  ]
}